<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <!-- <img class="pointer" @click="returnBack()" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg" alt="" /> -->
      <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 0 || (activityData.id != 13 && activityData.id != 14) }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step v-if="activityData.id == 13 || activityData.id == 14 " title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板  TODO:BI店铺礼包80 -->
      <div class="firststep" v-if="localStep == 0 && (activityData.id == 13 || activityData.id == 14)">
        <div v-if="activityData.id == 13 || activityData.id == 14" style="margin-bottom: 20px">
          <jd-tip>
            <div>
              官方规则：店铺礼包和开卡礼包为同类型活动，每个店铺只能存在1个进行中礼包活动（并与其他系统同步）且不支持预创建，所以店铺礼包在哪里创建的也只能在哪里关闭哦。
            </div>
          </jd-tip>
        </div>
        <!-- 导航切换 -->
        <!--  -->
        <template
          v-if="activityData.id == 13 || activityData.id == 14 || activityData.id == 1 || activityData.id == 34 || activityData.id == 80">
          <div class="activeEdit_bottom" v-loading="loading">
            <div class="template">
              <div style="width: 82px;padding-top: 5px;">模板类型：</div>
              <div class="template-nav">
                <div class="template-wz pointer" v-for="(item, index) in navList" :key="item.id"
                  @click="handleNav(item, index)" :class="{ activeTem: tabActive == index }" v-show="item.isVisible">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <!-- m模板图 -->
            <div class="templateBox">
              <!-- 自定义上传 -->
              <div class="temImg" v-if="navItem.title == '自定义上传'">
                <div class="temImg_content pointer" @click="visibleUpload = true"
                  style="border: 1px solid rgba(123,97,255,0.15);">
                  <div class="temImg_content_img temImg_dz">
                    <div class="temImg_dz_center">
                      <span>上传图片</span>
                    </div>
                  </div>
                  <div class="temImg_content_wz" style="background: rgba(123, 97, 255, 0.05);"></div>
                </div>
              </div>
              <!-- 定制 -->
              <div class="temImg" v-else>
                <div class="temImg_content" @click="handleOpen()" style="border: 1px solid #D4E2FF">
                  <div class="temImg_content_img temImg_dz">
                    <div class="temImg_dz_center">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                      <span>品牌定制</span>
                    </div>
                  </div>
                  <div class="temImg_content_wz" style="background: #EAF1FF;"></div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                  <div class="temImg_content_bgshadow_codeDZ">
                    <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                  </div>
                </div>
              </div>
              <!-- 模板 -->
              <div class="temImg" v-for="item in giftList" :key="item.id">
                <div class="temImg_content">
                  <div class="temImg_content_img">
                    <img  style="width:100%;max-height: 380px;" v-if="activityData.id == 13" :src="item.templateUrl" alt="" />
                    <img  style="width:100%;max-height: 380px;" v-if="activityData.id == 14" :src="item.templateExampleUrl"
                      alt="" />
                    <img style="width:100%;max-height: 380px;" v-if="activityData.id == 1 || activityData.id == 34"
                      :src="item.imageUrl" alt="" />
                    <img v-if="item.expirationType" class="temImg_content_img_free" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/free.svg"
                      alt="" srcset="" />
                    <div v-if="item.expirationType" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                    <img v-if="item.days" class="temImg_content_img_free" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/free.svg" alt=""
                      srcset="" />
                    <div v-if="item.days" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                  </div>
                  <div class="temImg_content_wz">
                    <span class="temImg_title">{{ item.templateName || item.imageName }}</span>
                    <span class="temImg_desc">模板ID：{{ item.id }}</span>
                  </div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow">
                  <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"
                    :style="{ marginTop: item.prizeType != '[]' ? '80px' : '' }"></div>
                  <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                  <div class="temImg_content_bgshadow_jx" v-if="item.prizeType != '[]' && item.prizeType">
                    <div>奖项：最多支持{{ item.awardNumLimit || item.prizeType.split(",").length }}个奖品</div>
                    <div>
                      （{{
        item.prizeType
          .replace("1", "店铺积分")
          .replace("2", "京豆")
          .replace("3", "京券")
          .replace("4", "东券")
          .replace(/,/g, "、")
      }}）
                    </div>
                  </div>
                  <div style="display: flex;" v-if="navItem.title == '自定义上传'">
                    <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">使用此模板</div>
                    <div class="temImg_content_bgshadow_btn pointer" @click="handleDel(item)">删除模板</div>
                  </div>
                  <div v-else class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">使用此模板</div>
                </div>
              </div>
            </div>
            <br />
            <!-- 分页 -->
            <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pageData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            style="text-align: right;margin-top: 20px;"
          >
          </el-pagination> -->
          </div>
        </template>


        <template v-else>
          <div class="activeEdit_bottom" v-loading="loading">
            <div class="template">
              <div style="width: 74px;padding-top: 5px;">模板类型：</div>
              <div class="template-nav">
                <div class="template-wz pointer" v-for="(item, index) in tempSwitchList" :key="item.id"
                  :class="{ activeTem: index == 0 }" v-show="item.isVisible">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <!-- m模板图 -->
            <div class="templateBox">
              <!-- 定制 -->
              <div class="temImg">
                <div class="temImg_content" @click="handleOpen()" style="border: 1px solid #D4E2FF;">
                  <div class="temImg_content_img temImg_dz">
                    <div class="temImg_dz_center">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                      <span>品牌定制</span>
                    </div>
                  </div>
                  <div class="temImg_content_wz" style="background: #EAF1FF;"></div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                  <div class="temImg_content_bgshadow_codeDZ">
                    <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                  </div>
                </div>
              </div>
              <!-- 模板 -->
              <div class="temImg">
                <div class="temImg_content">
                  <div class="temImg_content_img">
                    <img style="width:100%;max-height: 380px;" :src="activityData.telImg" alt="" />
                  </div>
                  <div class="temImg_content_wz">
                    <span class="temImg_title">{{ activityData.name }}</span>
                    <span class="temImg_desc">模板ID：1</span>
                  </div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow">
                  <div class="temImg_content_bgshadow_code qrCodeIMG" id="queryId" ref="queryId"></div>
                  <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                  <div class="temImg_content_bgshadow_btn pointer" @click="nextStep('1')">使用此模板</div>
                </div>
              </div>
              <!-- 模板 -->
              <div class="temImg" v-show="this.activityData.id == '1'">
                <div class="temImg_content">
                  <div class="temImg_content_img">
                    <img style="width:100%;max-height: 380px;" :src="activityData.telImg2" alt="" />
                  </div>
                  <div class="temImg_content_wz">
                    <span class="temImg_title">{{ activityData.name }}</span>
                    <span class="temImg_desc">模板ID：2</span>
                  </div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow">
                  <div class="temImg_content_bgshadow_code qrCodeIMG" id="queryId2" ref="queryId2"></div>
                  <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                  <div class="temImg_content_bgshadow_btn pointer" @click="nextStep('2')">使用此模板</div>
                </div>
              </div>
              <!-- 模板 -->
              <div class="temImg" v-show="this.activityData.id == '1'">
                <div class="temImg_content">
                  <div class="temImg_content_img">
                    <img style="width:100%;max-height: 380px;" :src="activityData.telImg3" alt="" />
                  </div>
                  <div class="temImg_content_wz">
                    <span class="temImg_title">{{ activityData.name }}</span>
                    <span class="temImg_desc">模板ID：3</span>
                  </div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow">
                  <div class="temImg_content_bgshadow_code qrCodeIMG" id="queryId3" ref="queryId3"></div>
                  <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                  <div class="temImg_content_bgshadow_btn pointer" @click="nextStep('3')">使用此模板</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- </div> -->
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 0 || (activityData.id != 13 && activityData.id != 14)">
        <div  v-if="activityData.id == 13" style="margin-bottom: 16px">
          <jd-tip>
            <div>
              官方规则：<br/>
              <p>1、<span class="orangeColor">活动生效时间：</span> POP和自营15分钟后生效。</p>
              <p>2、礼包涉及到引导用户跳转至新页面开卡，因此礼包无法直接完成发奖，您可以将奖励配置到用户跳转的目标页面。</p>
              <p>3、京东规定店铺礼包奖品不可为空，为保证礼包创建成功，此处为礼包默认创建<span class="orangeColor">1积分</span>为奖品。</p>
            </div>
          </jd-tip>
        </div>
        <div v-if="activityData.id == 14"  style="margin-bottom: 16px">
          <jd-tip>
            <div>
              官方规则：<br/>
              <p>1、<span style="color:#000;font-weight: bold;">活动生效时间：</span>POP和自营15分钟后生效。</p>
              <p>2、FCS商家创建礼包时，暂时无法选择优惠券礼品，请您知晓，避免造成客诉！</p>
            </div>
          </jd-tip>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="140px">
          <!-- 基本信息 -->
          <template v-if="activityData.id != 13 && activityData.id != 14">
            <informationForm
            @selectPeopleSure="selectPeopleSure" 
            @getMemberFn="resetMemberFn"
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime.sync="ruleForm.activityStartTime" 
            :defaultActivityEndTime.sync="ruleForm.activityEndTime" 
            ref="informationForm" 
            v-model="ruleForm"
            :plusObject.sync="ruleDto.plusObject" 
            :openCardStartTime.sync="ruleDto.openCardStartTime" 
            :openCardEndTime.sync="ruleDto.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            :disabled="isStart" 
            :localStepNum="localStepNum"
            :isNeedActMemberPurchased="activityData.id == 34"
            :isNeedCusType="false"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
            <template #actMemberSlot>
              <div v-if="actMember == '4'" class="non-member-box">
                <el-form-item label="最后一次交易时间:" required>
                  <el-date-picker
                  v-model="nonObjTime"
                  :disabled="isStart"
                  type="datetimerange"
                  :picker-options="nonPickerOption"
                  range-separator="至"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="完成订单笔数:" style="margin-bottom: 0">
                  <el-select v-model="nonObj.finishOrderType" :disabled="isStart" style="width: 106px; margin-right: 6px" @change="handleFinishOrder">
                    <el-option :key="0"  label="大于等于" :value="0"></el-option>
                    <el-option :key="1"  label="小于等于" :value="1"></el-option>
                    <el-option :key="2"  label="介于" :value="2"></el-option>
                  </el-select>
                <el-input v-model="nonObj.numStart"  style="width: 100px; margin-right: 4px" :disabled="isStart" @input="nonObj.numStart = handleInput($event)" @blur="updateNumStartInputBox" @change="handleChange"/><span>笔</span>
                <template v-if="nonObj.finishOrderType == 2">
                  <span style="margin: 0 7px">~</span>
                  <el-input v-model="nonObj.numEnd"  style="width: 100px;margin-right: 4px" :disabled="isStart" @input="nonObj.numEnd = handleInput($event)" @blur="updateNumEndInputBox" @change="handleChange"/><span>笔</span>
                </template>
              
                </el-form-item>
                <div class="non-tip">
                  <jd-tip color="text">
                    <span class="tip-color">说明：这里是做已购非会员引导入会的场景，非会员需在活动期间入会方可参与活动，非活动期间入会的会员不可参与</span>
                  </jd-tip>
                </div>
              </div>
            </template>
            </informationForm>
            <!-- <jd-title label="基本信息" type="bold"></jd-title>
            <el-form-item label="活动名称:" required>
              <el-input v-model="ruleForm.activityName" :disabled="isStart" maxlength="15" show-word-limit
                placeholder="请填入活动名称" style="width: 500px"></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="ruleForm.activityStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1" @change="activityTimeChange"
                  :picker-options="pickerOptionsValue" :default-time="defaultTime[0]" :clearable="false" :disabled="isStart"
                  >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleForm.activityEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2" @change="activityTimeChange" @focus="orderFocus"
                  :picker-options="pickerOptionsValueEnd" :default-time="defaultTime[0]" :clearable="false"
                  >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut
                  }}</span> 小时
                <el-tooltip class="item" effect="light" content="活动时间不可超过互动数据授权有效期及店铺接入有效期" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
              <div class="act-tip" v-if="isShowTip">
                *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
              </div>
            </el-form-item> -->
          </template>
          <!-- <el-form-item label="活动对象:" prop="partner"
            v-if="localStepNum == 1 || localStepNum == 3 || localStepNum == 4 || localStepNum == 7 || activityData.id == 34">
            <el-radio v-model="actMember" label="1" :disabled="isStart">不限</el-radio>
            <el-radio v-model="actMember" label="2" :disabled="isStart">会员身份</el-radio>
            <el-radio v-model="actMember" label="3" :disabled="isStart || softType == 1">指定人群
              <el-button v-if="actMember == '3'" :disabled="isStart" @click="openCrowd" style="margin-left:12px;">已选人群({{peopleSelected.length}})</el-button>
            </el-radio>
            <el-radio v-model="actMember" label="4" :disabled="isStart" v-if="activityData.id == 34">已购非会员</el-radio>
            <div v-if="actMember == '2'" style="display:flex">
              <span>会员等级：</span>
              <el-checkbox-group v-model="ruleForm.partner" @change="checkListchange" :disabled="isStart" v-if="actMember == '2'">
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox label="0" name="partner" :disabled="ruleForm.partner == -1">非会员</el-checkbox>
                <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="partner" :disabled="ruleForm.partner == -1">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="isStart">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <i v-if="!isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color:#F56C6C">注意：该条件对【非会员】身份不生效</span>
          </el-form-item> -->

          <!-- <div v-if="actMember == '4'" class="non-member-box">
            <el-form-item label="最后一次交易时间:" required>
              <el-date-picker
                v-model="nonObjTime"
                :disabled="isStart"
                type="datetimerange"
                :picker-options="nonPickerOption"
                range-separator="至"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="完成订单笔数:" style="margin-bottom: 0">
              <el-select v-model="nonObj.finishOrderType" :disabled="isStart" style="width: 106px; margin-right: 6px" @change="handleFinishOrder">
                <el-option :key="0"  label="大于等于" :value="0"></el-option>
                <el-option :key="1"  label="小于等于" :value="1"></el-option>
                <el-option :key="2"  label="介于" :value="2"></el-option>
              </el-select>
              <el-input v-model="nonObj.numStart"  style="width: 100px; margin-right: 4px" :disabled="isStart" @input="nonObj.numStart = handleInput($event)" @blur="updateNumStartInputBox" @change="handleChange"/><span>笔</span>
              <template v-if="nonObj.finishOrderType == 2">
                <span style="margin: 0 7px">~</span>
                <el-input v-model="nonObj.numEnd"  style="width: 100px;margin-right: 4px" :disabled="isStart" @input="nonObj.numEnd = handleInput($event)" @blur="updateNumEndInputBox" @change="handleChange"/><span>笔</span>
              </template>
              
            </el-form-item>
            <div class="non-tip">
              <jd-tip color="text">
                <span class="tip-color">说明：这里是做已购非会员引导入会的场景，非会员需在活动期间入会方可参与活动，非活动期间入会的会员不可参与</span>
              </jd-tip>
            </div>
          </div> -->
          <!-- 1.14迭代 plus会员限制
          <el-form-item label="Plus会员身份:" v-if="localStepNum == 1 || localStepNum == 3 || localStepNum == 4 || localStepNum == 7 || activityData.id == 34" required>
            <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="isStart">不限</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="isStart">Plus会员</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="isStart">非plus会员</el-radio>
            <div style="color:#F56C6C;width: 700px;">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
          </el-form-item> -->


          <!-- 手机预览效果 -->
          <!-- <div class="addCartPhoneTmp" v-if="activityData.id == 34">
            <add-cart-phone v-if="phoneShow" :activityData="templateInfoData" :ruleForm="ruleForm"
              :prizeList="awardSettingsLsit" :goodsList="mainImagelist" :sellerNick="sellerNick" />
          </div> -->

          <!-- 关注店铺提示 -->
          <!-- <div v-if="localStepNum == 4" style="width: 580px; margin-left: 56px">
            <jd-tip>
              <p>注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</p>
            </jd-tip>
          </div> -->
          <!-- <el-form-item label="奖品设置:" prop="prizeSite" v-if="localStepNum == 3 || localStepNum == 6">
          赠送
          <el-input v-model="ruleForm.bonusPoints" placeholder="请输入" style="width: 70px" @input.native="checkputn"> </el-input>
          积分
        </el-form-item> -->
          <jd-title label="资料信息" v-if="localStepNum == 7" type="bold"/>
          <el-form-item label="完善资料信息:" prop="information" v-if="localStepNum == 7">
            <!-- 上部分 -->
            <!-- <el-checkbox-group v-model="ruleForm.information" :disabled="isStart"> -->
              <el-checkbox label="-1" name="partner" v-model="isCheckAllInformation" :disabled="isStart">全部</el-checkbox>
              <el-checkbox v-for="item,index in informationList" :key="index" :label="item.value" name="partner"
                @change="changeInformation($event,item.value)" :disabled="isStart"
                :value="ruleForm.information.indexOf(item.value) != -1 || ruleForm.information.indexOf('-1') != -1">
                {{item.name}}
              </el-checkbox>
              <!-- <el-checkbox label="姓名" name="partner"></el-checkbox>
              <el-checkbox label="手机号码" name="partner"></el-checkbox>
              <el-checkbox label="生日" name="partner"></el-checkbox>
              <el-checkbox label="微信" name="partner"></el-checkbox>
              <el-checkbox label="QQ" name="partner"></el-checkbox>
              <el-checkbox label="邮箱" name="partner"></el-checkbox>
              <el-checkbox label="性别" name="partner"></el-checkbox>
              <el-checkbox label="职业" name="partner"></el-checkbox>
              <el-checkbox label="地区" name="partner"></el-checkbox>
              <el-checkbox label="详细地址" name="partner"></el-checkbox> -->
              <br />
            <!-- </el-checkbox-group> -->
            <!-- 下部分 -->
            <el-checkbox-group v-model="ruleForm.informationOne" :disabled="isStart">
              <div v-for="(item, index) in itemArrOne.slice(0, 10)" :key="index">
                <el-checkbox :label="item.informationmation ? item.informationmation : index"
                  :value="item.informationmation" :key="item.informationmation" v-bind="{
checked: itemArrOne[index].informationmationOne + '' ? true : false,
      }">
                    <el-select :disabled="isStart" v-model="item.informationmationSelect" placeholder="请选择" style="width: 100px;margin-right: 12px;" @change="handleSelect($event,index)">
                      <el-option
                        v-for="msg in msgOptions"
                        :key="msg.value"
                        :label="msg.label"
                        :value="msg.value">
                      </el-option>
                    </el-select>
                  <el-input v-model="item.informationmationOne" :disabled="isStart" placeholder="自定义信息名称"> </el-input>
                  <div style="    display: inline-block;margin-left: 10px;position: relative;"
                    @click="deleteaInfo(index)">
                    <img style="position: absolute;top: -13px;" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" />
                  </div>
                </el-checkbox>
              </div>
              <jd-button @click="perfectAdd"
                :disabled="itemArrOne.length == 10 || isStart">+ 添加 </jd-button>
              <jd-button type="text" :disabled="isStart">（{{
        itemArrOne.length ? itemArrOne.length : 0 }}/10）</jd-button>
            </el-checkbox-group>
          </el-form-item>
          <jd-title label="奖品设置" v-if="localStepNum == 4 || localStepNum == 7 || activityData.id == 34" type="bold"/>
          <!-- 奖品展示 -->
          <el-form-item label="奖品展示:" required v-if="activityData.id == 34">
            <el-radio-group v-model="ruleForm.showPrize" :disabled="isStart">
              <el-radio :label="1">展示实际奖品</el-radio>
              <el-radio :label="0">不展示奖品</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 奖品剩余数量 -->
          <el-form-item label="奖品剩余数量:" required v-if="activityData.id == 34 && ruleForm.showPrize == 1">
            <el-radio-group v-model="ruleForm.showPrizeNum" :disabled="isStart">
              <el-radio :label="1">展示奖品剩余数量</el-radio>
              <el-radio :label="0">不展示奖品剩余数量</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 奖品设置 关注店铺、完善信息、加购有礼 -->
          <el-form-item label="奖品设置:" prop="setPrize"
            v-if="localStepNum == 4 || localStepNum == 7 || activityData.id == 34">
            <jd-table :tableData="awardSettingsLsit" style="width: 1100px;margin-top: 15px;">
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" style="color:#2768FF;cursor: pointer;"
                    @click="selectPacket(scope.$index, scope.row)">选择奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column width="299">
                <template slot="header" slot-scope="scope">
                  <div class="flexc-cen-x">
                    <span>奖品名称（{{ activityData.id == 34 ? '12字内' : '页面展示' }}）</span>
                    <el-tooltip v-if="activityData.id == 34" class="itemImg1" effect="light" content="显示在活动页奖品展示区和中奖提示区"
                      placement="top">
                      <el-button type="text">
                        <i class="el-icon-question"></i>
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12"
                    show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot="header" slot-scope="scope">
                  <div class="flexc-cen-x">
                    <span>奖品数量</span>
                    <el-tooltip v-if="activityData.id == 34" class="itemImg2" effect="light" content="奖品数量发完后，提示用户奖品发放完毕"
                      placement="top">
                      <el-button type="text">
                        <i class="el-icon-question"></i>
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)" maxlength="10"
                    class="inputcount" show-word-limit style="width: 150px" placeholder="请输入" @blur="beAdd(scope.row)"
                    :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="每日发放限额" width="120">
                <template slot-scope="scope">
                  <dailyLimitConfig
                    :row="scope.row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="isStart">
                <template slot-scope="scope">
                  <jd-button type="blueText" v-if="scope.row.title"
                    @click="itemAddNum('awardSettingsLsit',scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="s" style="color:#7f85e9;margin-right: 10px;" @click="deletePacket(scope.row, '1')">清空</span>
                  <span v-show="scope.$index != 0" class="s" @click="deletePacket(scope.$index)">删除</span>
                </template>
              </el-table-column> -->
            </jd-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
          </el-form-item>

          <!-- 加购商品设置 -->
          <template v-if="activityData.id == 34">
            <jd-title label='进店设置' type="bold"></jd-title>
            <el-form-item label="进店逛逛:">
              <el-radio-group v-model="ruleForm.goShopSetting" :disabled="isStart" @change="onShopSetChange">
                <el-radio :label="0">进入店铺首页</el-radio>
                <el-radio :label="1">跳转指定小程序</el-radio>
                <el-radio :label="2">进入指定链接</el-radio>
              </el-radio-group>              
              <div style="color:#F56C6C">部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券</div>
            </el-form-item>
            <div v-if="ruleForm.goShopSetting==1">
              <el-form-item label="小程序appId:" required>
                <el-input
                  type="textarea"
                  placeholder="请输入小程序appId"
                  style="width: 425px;margin-left:8px;"
                  show-word-limit
                  v-model="ruleForm.goShopAppId"
                  :maxlength="1000"
                  :disabled="isStart"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面路径path:">
                <el-input
                  type="textarea"
                  placeholder="请输入小程序页面路径path"
                  style="width: 425px;margin-left:8px;"
                  show-word-limit
                  v-model="ruleForm.goShopUrl"
                  :maxlength="1000"
                  :disabled="isStart"
                ></el-input>
                <div style="color:#F56C6C">注意：path若不写，则默认进入小程序主页。</div>
              </el-form-item>
            </div>
            <el-form-item label="指定链接:" required v-if="ruleForm.goShopSetting==2">
              <el-input
                type="textarea"
                placeholder="请输入指定链接"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="isStart"
              ></el-input>
              <div style="color:#F56C6C">注意：仅可填写京东域内的 H5页面地址，不可设置外链。参考链接：https://m.jd.com/。</div>
            </el-form-item>

            <jd-title label="加购商品设置" type="bold"/>
            <el-form-item label="加购商品:" required>
              <el-button :disabled="isStart" style="width: 155px; margin: 0 15px;display: inline-block;"
                :class="[{ 'add_btn1': ruleForm.exposureSwitch },{'global-view-btn':backgroundOpacity}]"  @click="addGoods">
                {{ itemListFor.length != "" ? "添加商品" + "(" + itemListFor.length + "/50" + ")" : "添加商品" }}
              </el-button>
              <draggable v-if="itemListFor.length > 0" v-model="mainImagelist" chosen-class="chosen" :scroll="true"
                animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd"
                style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;" filter=".unmover">
                <transition-group type="transition">
                  <div v-for="(item, index) in mainImagelist" :key="item.skuId"
                    style="display: inline-block; position: relative" class="show_upImg2" :class="isStart ? 'unmover' : ''">
                    <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                    <div class="delectPosible" v-if="!isStart">
                      <span class="delectSort">拖动排序</span>
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <el-form-item label="是否支持一键加购:">
              <el-radio v-model="ruleForm.showBatchAddCart" :label="0" :disabled="isStart">不支持</el-radio>
              <el-radio v-model="ruleForm.showBatchAddCart" :label="1" :disabled="isStart">加购全部商品</el-radio>
              <el-radio v-model="ruleForm.showBatchAddCart" :label="2" :disabled="isStart">加购部分商品</el-radio>
              <el-button :disabled="isStart || ruleForm.showBatchAddCart !=2" style="width: 155px; margin: 0 15px;display: inline-block;" @click="selectAddGoods">
                {{selectedGoodList.length ? `已选择${selectedGoodList.length}个` : '选择商品'}}
              </el-button>
              <!-- <el-checkbox v-model="ruleForm.showBatchAddCart" :disabled="isStart">一键加购全部商品</el-checkbox> -->
            </el-form-item>
            <el-form-item label="加购方式:" required style="color: #606266;">
              成功加购
              <el-input-number v-model="ruleForm.addCartNum" @change="handleAddNum" :min="1" :max="50"
                :disabled="isStart"></el-input-number>
              <!-- :max="selectGoodsArr.length ? selectGoodsArr.length : 1"  -->
              件，可领取奖品
            </el-form-item>
          </template>

          <!-- 邀请关注有礼 -->
          <jd-title label="奖品设置" v-if="localStepNum == 6" type="bold"/>
          <el-form-item label="奖品设置:" prop="setPrize" v-if="localStepNum == 6">
            <el-radio v-model="ruleForm.isCumulativePrize" :label="0" :disabled="isStart">统一奖品</el-radio>
            <el-radio v-model="ruleForm.isCumulativePrize" :label="1" :disabled="isStart">梯度奖品</el-radio>
            <el-radio v-model="ruleForm.isCumulativePrize" :label="2" :disabled="isStart">任务奖品</el-radio>
            <div class="prize_box" style="width:1100px" v-show="ruleForm.isCumulativePrize == 0">
              每邀请<el-input v-model="ruleForm.inviteNum" style="width: 70px;margin:0 10px;"
                @input="ruleForm.inviteNum = getNumberData(1, $event, 0, 1)" @blur="inviteNumBlur" :disabled="isStart">
              </el-input>人可得<span style="color:#fe4d45">{{ awardSettingsLsit[0].title || "" }}</span>，活动期间最多邀请<el-input
                v-model="ruleForm.peopleCount" style="width: 70px;margin:0 10px;"
                @input="ruleForm.peopleCount = getNumberData(1, $event, 0, 1)" @blur="peopleCountBlur"
                :disabled="isStart">
              </el-input>人，超出人数不再获得奖励<el-tooltip class="item" effect="light" content="以成功邀请好友关注店铺的人数为准"
                placement="bottom">
                <el-button type="text" style="width:40px">
                  <i style="color: #ccc;" class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
              <jd-table :tableData="awardSettingsLsit" style="width: 100%;margin-top: 15px;">
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span class="s" style="color:#2768FF;cursor: pointer;"
                      @click="selectPacket(scope.$index, scope.row)">选择奖品</span>
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="值" width="80" prop="price"></el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.title" maxlength="12"
                      show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.totalAmount"
                      @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                      @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)"
                      maxlength="10" class="inputcount" show-word-limit style="width: 150px" placeholder="请输入"
                      @blur="beAdd(scope.row)" :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" v-if="isStart">
                  <template slot-scope="scope">
                    <jd-button type="blueText" v-if="scope.row.title"
                      @click="itemAddNum('awardSettingsLsit',scope.$index)">增加奖品数量</jd-button>
                  </template>
                </el-table-column>
              </jd-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            </div>

            <div class="prize_box" style="width:1100px" v-show="ruleForm.isCumulativePrize == 1">
              <div>
                <jd-tip color="yello">
                  规则：达到邀请人数的最大人数并领取奖品后，可继续邀请开卡但是不能获得奖品
                </jd-tip>
              </div>

              <el-table :data="tableData" style="width: 1100px; border: 1px solid #f0f0f0;margin-top: 15px;"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }">
                <el-table-column prop="date" label="邀请人数" width="110">
                  <template slot-scope="scope">
                    <el-input :disabled="isStart" v-model="scope.row.peopleCount"
                      @input="scope.row.peopleCount = getNumberData(1, $event, 0, 1)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span @click="centerVis(scope)" style="color:#2768FF;cursor: pointer;">选择奖品</span>
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="值" width="80" prop="price">
                  <template slot-scope="scope">
                    <span>{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.title" maxlength="12"
                      show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.prizeCount"
                      @input.native="(e) => (scope.row.prizeCount = checkputnCount(e, scope.row, 'jindou'))"
                      @input="scope.row.prizeCount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 2)"
                      @blur="beAdd(scope.row, 2)" :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                      totalAmountKey="prizeCount"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <jd-button type="blueText" v-if="!isStart"
                      @click="itemDel(scope.$index)">删除</jd-button>
                    <jd-button type="blueText" v-if="isStart && scope.row.title"
                      @click="itemAddNum('tableData', scope.$index)">增加奖品数量</jd-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <jd-button v-if="!isStart" @click="addPrizeRule" style="margin-top: 8px">
                增加奖项
              </jd-button>
            </div>

            <div class="prize_box" style="width:1100px" v-show="ruleForm.isCumulativePrize == 2">
              <div>
                <jd-tip color="yello">
                  温馨提示规则：<br/>
                  设置活动的各个奖项，请尽量确保一个活动中的各个奖项的份数一致，避免某个奖项提前领取完，导致用户看到奖项但无法领取而客诉
                </jd-tip>
              </div>

              <el-table :data="taskTableData" style="width: 1100px; border: 1px solid #f0f0f0;margin-top: 15px;"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }">
                <el-table-column label="任务" width="80" type="index" :index="indexMethod">
                </el-table-column>
                <el-table-column prop="date" label="邀请人数" width="110">
                  <template slot-scope="scope">
                    <el-input :disabled="isStart" v-model="scope.row.peopleCount"
                      @input="scope.row.peopleCount = getNumberData(1, $event, 0, 1)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span @click="centerVis(scope)" style="color:#2768FF;cursor: pointer;">选择奖品</span>
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="值" width="80" prop="price">
                  <template slot-scope="scope">
                    <span>{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.title" maxlength="12"
                      show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.prizeCount"
                      @input.native="(e) => (scope.row.prizeCount = checkputnCount(e, scope.row, 'jindou'))"
                      @input="scope.row.prizeCount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 2)"
                      @blur="beAdd(scope.row, 2)" :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                      totalAmountKey="prizeCount"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <jd-button v-if="!isStart" type="blueText"
                      @click="itemDel(scope.$index)">删除</jd-button>
                    <jd-button type="blueText" v-if="isStart || scope.row.title"
                      @click="itemAddNum('taskTableData', scope.$index)">增加奖品数量</jd-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <jd-button v-if="!isStart" @click="addPrizeRule" style="margin-top: 8px">
                增加任务
              </jd-button>
            </div>
          </el-form-item>

          <!-- <el-form-item label="活动条件:" v-if="activityData.id == 1 || localStepNum == 3">
            <el-checkbox label="关注店铺后方可参与活动" v-model="ruleForm.isFollow" :disabled="isStart"></el-checkbox>
          </el-form-item> -->

          <!-- 每日限时抢 -->
          <jd-title label="奖品设置" v-if="localStepNum == 3" type="bold"/>
          <el-form-item label="每日开抢时间:" prop="limitedTimeGrab" v-if="localStepNum == 3">
            <el-time-picker v-model="ruleForm.limitedTimeGrab" :disabled="isStart" placeholder="请选择时间" value-format="HH:mm:ss"
              class="startTime"> </el-time-picker>
          </el-form-item>
          <el-form-item label="奖品份数:" prop="prizeCount" v-if="localStepNum == 3">
            每日共赠送
            <el-input :disabled="isStart" v-model="ruleForm.prizeCount" placeholder="请输入"
              @input="ruleForm.prizeCount = getNumberData(1, $event, 0, 1)" style="width: 70px"> </el-input>
            份奖品，每人每日限领一份奖品，先到先得
          </el-form-item>
          <el-form-item label="选择奖品:" v-if="localStepNum == 3" required>
            <jd-table :tableData="awardSettingsLsit" style="width: 1100px;margin-top: 15px;">
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <jd-button type="blueText"
                    @click="selectPacket(scope.$index, scope.row)">选择奖品</jd-button>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12"
                    show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)" maxlength="10"
                    class="inputcount" show-word-limit style="width: 150px" placeholder="请输入" @blur="beAdd(scope.row)"
                    :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="isStart">
                <template slot-scope="scope">
                  <jd-button type="blueText" v-if="scope.row.title"
                    @click="itemAddNum('awardSettingsLsit',scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
            </jd-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
          </el-form-item>

          <!-- 签到赢好礼 -->
          <jd-title label="签到设置" v-if="activityData.id == 1 || firstNum == 1" type="bold"/>
          <el-form-item label="每日签到奖品设置:" prop="prizeSet" v-if="activityData.id == 1 || firstNum == 1" required>
            <el-checkbox-group v-model="ruleForm.prizeSet" :disabled="isStart">
              <el-checkbox name="prizeSet" @change="prizeSetChange" label="true">
                每日签到送
                <span style="color:#fe4d45">{{ awardSettingsLsit[0].title }}</span>
              </el-checkbox>
              <br />
            </el-checkbox-group>
            <jd-table :tableData="awardSettingsLsit" style="width: 1200px;margin-top: 15px;">
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" style="color:#2768FF;cursor: pointer;"
                    @click="selectPacket(scope.$index, scope.row)">选择奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12"
                    show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)" maxlength="10"
                    class="inputcount" show-word-limit style="width: 150px" placeholder="请输入"
                    @blur="beAdd(scope.row)" :disabled="isStart"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="每日发放限额" width="120">
                <template slot-scope="scope">
                  <dailyLimitConfig
                    :row="scope.row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="isStart">
                <template slot-scope="scope">
                  <jd-button type="blueText" v-if="scope.row.title"
                    @click="itemAddNum('awardSettingsLsit',scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
            </jd-table>
          </el-form-item>

          <el-form-item label="指定签到日期奖品设置:" required v-if="activityData.id == 1">
            <el-checkbox v-model="fixedDate" :disabled="isStart">固定日期</el-checkbox>
            <jd-table :tableData="itemArrDate" style="width: 1200px;margin-top: 15px;" v-if="fixedDate">
              <el-table-column label="日期" width="160">
                <template #default="{row}">
                  <el-date-picker
                    v-model="row.fixedSendDate"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="fixedSendDateOptions"
                    :disabled="isStart"
                    @change="fixedSendDateChange($event,row)"
                    style="width: 130px"
                  >
                  </el-date-picker>                 
                </template>
              </el-table-column>
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" style="color:#2768FF;cursor: pointer;"
                    @click="selectItemArr(scope.$index, scope.row)">选择奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12"
                    show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)" maxlength="10"
                    class="inputcount" show-word-limit style="width: 150px" placeholder="请输入" @blur="beAdd(scope.row)"
                    :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="每日发放限额" width="120">
                <template slot-scope="scope">
                  <dailyLimitConfig
                    :row="scope.row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span v-if="!isStart" style="color:red;" v-show="scope.$index != 0" class="pointer"
                    @click="itemArrDate.splice(scope.$index, 1)">删除</span>
                  <jd-button type="blueText" v-if="isStart && scope.row.title"
                    @click="itemAddNum('itemArrDate', scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
            </jd-table>
            <jd-button v-if="!isStart && fixedDate" @click="addFixedDate" style="margin-top: 8px;">
              增加奖项
            </jd-button>
          </el-form-item>
          <el-form-item label="连续签到奖品设置:" required v-if="activityData.id == 1 || firstNum == 1">
            <el-checkbox-group v-model="ruleForm.prizeSetOne" :disabled="isStart">
              <el-checkbox label="连续签到" name="prizeSet" @change="signInpoints">连续签到送 &nbsp;</el-checkbox>
            </el-checkbox-group>
            <el-form-item label-width="110px" label-position="left"  label="连续签到规则:" required v-if="ruleForm.prizeSetOne">
              <el-radio v-model="ruleForm.continueRuleType" :label="0" :disabled="isStart">可完成多次</el-radio>
              <el-radio v-model="ruleForm.continueRuleType" :label="1" :disabled="isStart">仅可完成1次</el-radio>
            </el-form-item>
            <jd-tip>
              <div>
                <div style="font-weight: 600;">规则说明</div>
                <p>可完成多次：达到连续签到最大天数并领取奖品或中途漏签后，签到记录清零，从第1天重新计算；例如：连续签到规则最大天数为5天，则连续签到5天并领取奖品后，第6天的连续签到记录是1天，多条件为累计叠加。</p><p>仅可完成1次：达到连续签到最大天数并领取奖品或中途漏签后，签到记录不清零，可以继续签到但是不再获得奖品；</p>
              </div>
            </jd-tip>
            <jd-table :tableData="itemArr" style="width: 1200px;margin-top: 15px;">
              <el-table-column label="连续签到天数" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.days" @input="scope.row.days = getNumberData(1, $event, 0, 1)"
                    style="width: 120px" placeholder="请输入" :disabled="isStart"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" style="color:#2768FF;cursor: pointer;"
                    @click="selectItemArr(scope.$index, scope.row)">选择奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12"
                    show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)" maxlength="10"
                    class="inputcount" show-word-limit style="width: 150px" placeholder="请输入" @blur="beAdd(scope.row)"
                    :disabled="activityData.isStart && !scope.row.minNum || isStart"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="每日发放限额" width="120">
                <template slot-scope="scope">
                  <dailyLimitConfig
                    :row="scope.row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span v-if="!isStart" style="color:red;" v-show="scope.$index != 0" class="pointer"
                    @click="deletea(scope.$index)">删除</span>
                  <jd-button type="blueText" v-if="isStart && scope.row.title"
                    @click="itemAddNum('itemArr', scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
            </jd-table>
            <jd-button v-if="!isStart" @click="addCondition" style="margin-top: 8px;">
              增加奖项
            </jd-button>
          </el-form-item>

          <jd-title label="补卡任务配置" v-if="activityData.id == 1 || firstNum == 1" type="bold"/>
          <el-form-item label="是否开启补卡:" v-if="activityData.id == 1 || firstNum == 1">
            <el-checkbox v-model="isSignInReissueEnabled" :disabled="isStart">开启做任务获得补签卡（开启后需设置任务，表示用户可以通过完成指定任务获取补签卡，进行补签）</el-checkbox>
            <template v-if="isSignInReissueEnabled">
              <jd-tip style="margin-top: 16px;">
                <p>规则说明</p>
                <p>可完成多次：达到连续签到最大天数并领取奖品或中途漏签后，签到记录清零，从第一天重新计算；例如：连续前端规则最大天数为5天，则连续签到5天并领取奖品后，第六天的连续签到记录是1天，多条件为累计叠加。</p>
                <p>仅可完成一次：达到连续签到最大天数并领取奖品或中途漏签后，签到记录不清零，可以继续签到但是不再获得奖品；</p>
              </jd-tip>
            </template>
          </el-form-item>
          <el-form-item label="任务获取:" required v-show="(activityData.id == 1 || firstNum == 1) && isSignInReissueEnabled">
            <div class="flex-1">
              <div>
                <jd-button type="blue" @click="isShowTaskDialog = true">添加任务+</jd-button>
              </div>
              <div style="margin-top: 16px;">
                <taskDialog 
                  v-model="isShowTaskDialog" 
                  ref="taskDialog"
                  :isStart="isStart" 
                  :taskList.sync="taskList" 
                  :activityStartTime="ruleForm.activityStartTime" 
                  :activityEndTime="ruleForm.activityEndTime"
                  taskTypeText="补卡"
                />
              </div>
            </div>
          </el-form-item>
          <template v-if="this.activityData.id != 13 && this.activityData.id != 14">
            <activityPageSettings isShowShopName :isShowMoreSet="activityData.id!=34" v-model="customerPaperwork" ref="activityPageSettings" :designSpecificationsUrl="designSpecificationsList[activityData.id]" :isNeedCustomerPaperworkData="false" v-if="activityData.id == 1 || activityData.id == 34" :isCustomPreview="activityData.id == 34" :isNeedSetBG="activityData.id != 34" :cusTemplateJSON.sync="cusTemplateJSON" :giftList="giftList" :templateId="templateId" @selectTemplate="selectTemplate" :widthNumber="750" :heightNumber="1700">
              <!-- 加购有礼条件 -->
              <template #otherSet v-if="activityData.id == 34">
                <el-form-item label="活动背景图:" required>
                  <div style="display: flex;">
                    <el-popover placement="top-start" width="380" trigger="hover">
                      <img style="width:350px" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/addCart.jpg"
                        alt="" />
                      <span slot="reference"><i class="el-icon-question itemImg3"></i></span>
                    </el-popover>
                    <div class="activitypicUrl">
                      <el-image style="width: 200px; height: 130px" :src="ruleForm.picUrl" fit="contain">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <div class="right" style="width: 400px;">
                        <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                          :before-upload="beforeUpload" :on-success="handleUpload" :disabled="isStart">
                          <jd-button type="blueText">自定义上传</jd-button>
                        </el-upload>
                        <jd-button type="blueText" @click="picUrlReset">重置</jd-button>
                        <jd-button style="margin-left: 10px !important;" type="blueText" @click="lookDesignSpecifications">查看设计规范</jd-button>
                        <div class="tips">
                          <p>建议上传尺寸：750px * 574px</p>
                          <p>图片大小：1MB以内</p>
                          <p>格式：jpg、png</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动背景色:" required>
                  <div style="display: flex;align-items: center;">
                    <el-color-picker v-model="colorData" show-alpha :predefine="predefineColors" color-format="rgb" size="large" @active-change="handleChangeColor" @change="changeColor" :disabled="isStart">
                    </el-color-picker>
                    <jd-button type="blueText" style="margin-left: 8px" @click="isStart ? '' : rgbReset">重置</jd-button>
                  </div>
                </el-form-item>
              </template>

              <template v-if="activityData.id == 34" #customPreview>
                <!-- 手机预览效果 -->
                <add-cart-phone v-if="phoneShow" :activityData="templateInfoData" :ruleForm="ruleForm" :prizeList="awardSettingsLsit" :goodsList="mainImagelist" :sellerNick="sellerNick" />
              </template>
            </activityPageSettings>
            <activityPageSettings isShowShopName :isShowMoreSet="localStepNum!=7" v-model="customerPaperwork" :designSpecificationsUrl="designSpecificationsList[activityData.id]" :isNeedCustomerPaperworkData="false" v-else :cusTemplateJSON.sync="cusTemplateJSON" :giftList="[{imageName:activityData.name,imageUrl:activityData.telImg,id:0,secondImageUrl:activityData.telImg}]" :templateId="templateId" @selectTemplate="()=>{}" :widthNumber="750" :heightNumber="heightNumberFind()"></activityPageSettings>
          </template>
          <templat v-if="activityData.id == 1 || localStepNum == 3 || localStepNum == 4 || localStepNum == 6">
            <exposureList :defaultExposureSwitch.sync="ruleForm.exposureSwitch" v-model="itemListFor" :backgroundOpacity="backgroundOpacity"></exposureList>
          </templat>


          <!-- 开卡礼包和店铺 -->
          <template v-if="activityData.id == 13 || activityData.id == 14">
            <jd-title label="基本信息" type="bold"/>
            <el-form-item label="活动名称:" required>
              <el-input v-model="ruleForm.activityName" :disabled="isStart" maxlength="15" show-word-limit
                placeholder="请填入活动名称" style="width: 400px"></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="ruleForm.activityStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1" @change="activityTimeChange"
                  :picker-options="pickerOptionsValue" :default-time="defaultTime[0]" :clearable="false"
                  :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleForm.activityEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2" @change="activityTimeChange"
                  :picker-options="pickerOptionsValueEnd" :default-time="defaultTime[0]" :clearable="false"
                  :disabled="activityData.isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))">
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut
                  }}</span> 小时
                <el-tooltip class="item" effect="light" content="活动时间不可超过互动数据授权有效期及店铺接入有效期" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
            <el-form-item label="关注店铺:">
              <el-radio v-model="ruleForm.requestFollow" label="1" :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))">是</el-radio>
              <el-radio v-model="ruleForm.requestFollow" label="2" :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))">否</el-radio>
              <el-tooltip class="item" effect="light" content="勾选关注后参加活动的同时关注店铺" placement="bottom">
                <el-button type="text" style="margin-left: -20px;width:35px">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
            <jd-title label="活动条件" v-if="activityData.id == 14" type="bold"/>
            <el-form-item label="加购商品:" class="zindexBox" prop="exposure" v-if="activityData.id == 14">
              <el-radio-group @change="exposureChange" v-model="ruleForm.radio" :disabled="isStart">
                <el-radio :label="0">不限制</el-radio>
                <el-radio :label="1">加购商品</el-radio>
              </el-radio-group>
              <jd-button style="margin-left: 8px"
                @click="exposureProducts" :disabled="ruleForm.exposureSwitch == false || isStart">
                {{ itemListFor.length != "" ? "+添加" + "(" + itemListFor.length + "/20" + ")" : "+添加" }}
              </jd-button>
              <el-tooltip class="item" effect="light" content="勾选后领取礼包直接加购指定商品，最多添加20个sku" placement="bottom">
                <el-button type="text" style="width:35px">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
              <draggable v-if="itemListFor.length > 0" v-model="mainImagelist" chosen-class="chosen" :scroll="true"
                animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd"
                style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;" filter=".unmover">
                <transition-group type="transition">
                  <div v-for="(item, index) in mainImagelist" :key="item.skuId"
                    style="display: inline-block; position: relative" class="show_upImg2" :class="isStart ? 'unmover' : ''">
                    <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                    <!-- <div @click.stop="delec(index)" class="delectPosible">
                    <i class="el-icon-circle-close" style="font-size: 16px"></i>
                  </div> -->
                    <div class="delectPosible" v-if="!isStart">
                      <span class="delectSort">拖动排序</span>
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <jd-title label="礼包设置" type="bold"/>
            <el-form-item label="选择目标人群:" required>请选择需要投放的人群 </el-form-item>
            <div class="crowd">
              <jd-title label="系统自定义人群">
                <div slot="slotBox" >（系统自定义人群<span class="orangeColor">只支持单选</span
              >，并且无法和推荐人群同时选择；未关注店铺用户人群标签<span class="orangeColor">可多选</span>）</div>
              </jd-title>
              <div style="border: 1px solid #f0f0f0;margin-top: 16px;">
                <div class="crowd-tab">
                  <div class="crowd-tab-head">
                    <div class="crowd-tab-name">人群名称</div>
                    <div class="crowd-tab-sm" style="color:#000">人群说明</div>
                  </div>
                  <div class="crowd-tab-middle" v-for="item in personLab.customizeList" :key="item.labelId">
                    <div class="crowd-tab-name nameAlign">
                      <el-radio style="width:97%" @change="radioChange" v-model="ruleForm.modelIds" :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))"
                        :label="item.labelId">
                        <el-tooltip class="item" effect="light" :content="item.labelName" placement="top-start">
                          <el-button class="overHiddle">{{ item.labelName }}</el-button>
                        </el-tooltip>
                      </el-radio>
                    </div>

                    <div class="crowd-tab-sm" :class="{ descbox: item.labelVal }">
                      {{ item.labelDesc }}
                      <template v-if="!disableVF">
                        <div class="dx" v-if="item.labelVal && item.labelVal.length > 1">
                          <el-checkbox :disabled="disableVF || isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" style="display: inline-block"
                            v-model="verCheckAll" @change="handleCheckedChange">全选</el-checkbox>
                          <el-checkbox-group @change="handleChang" style="display: inline-block;margin-left: 30px;"
                            v-model="ruleForm.vermicelliVal">
                            <el-checkbox :disabled="disableVF || isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" v-for="item1 in item.labelVal"
                              :label="item1.level" :key="item1.level">{{
        item1.desc
      }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="crowd">
              <jd-title label="推荐人群">
                <div slot="slotBox">
                  （推荐人群<span class="orangeColor">只支持单选</span>，并且无法和系统自定义人群同时选择；店铺会员人群标签<span class="orangeColor">等级0-5可多选</span>，但<span class="orangeColor">跟非会员选项互斥</span>）
                </div>
              </jd-title>
              <div style="border: 1px solid #f0f0f0;margin-top: 16px;">
                <div class="crowd-tab">
                  <div class="crowd-tab-head">
                    <div class="crowd-tab-name">人群名称</div>
                    <div class="crowd-tab-sm" style="color:#000">人群说明</div>
                  </div>
                  <div class="crowd-tab-middle" v-for="info in personLab.recommendList" :key="info.labelId">
                    <div class="crowd-tab-name nameAlign">
                      <el-radio style="width:97%" :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" @change="radioChange" v-model="ruleForm.modelIds"
                        :label="info.labelId">
                        <el-tooltip class="item" effect="light" :content="info.labelName" placement="top-start">
                          <el-button class="overHiddle">{{ info.labelName }}</el-button>
                        </el-tooltip>
                      </el-radio>
                    </div>
                    <div class="crowd-tab-sm descbox" :class="{ descbox: info.labelVal && info.labelVal.length > 1 }">
                      {{ info.labelDesc }}
                      <template v-if="!disableCUS">
                        <div class="dx" v-if="info.labelVal && info.labelVal.length > 1">
                          <el-checkbox v-show=" info.labelName !== '店铺会员'" :disabled="disableCUS || isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" style="display: inline-block;" v-model="starCheckAll" @change="handleCheckedStarChange"
                          >全选</el-checkbox
                        >
                          <el-checkbox-group @change="handleChang" style="display: inline-block;"
                            v-model="ruleForm.starVal">
                            <div v-for="item1 in info.labelVal" :key="item1.level" style="display: inline-block;">
                              <el-checkbox  v-if='item1.level == -1' :label="item1.level"  :disabled="disableCUS || isStart ||openClick == 1 || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" > {{
                                item1.desc
                              }}</el-checkbox>
                              <el-checkbox  v-else :label="item1.level"  :disabled="disableCUS || isStart || openClick == 2 || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" >{{
                                item1.desc
                              }}</el-checkbox>
                            </div>
                            </el-checkbox-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-form-item label="发送人数:" required>
              <!-- prop="activityName" 发送人数 -->
              <el-input v-model="ruleForm.sendCount"
                @input.native="(e) => (ruleForm.sendCount = checkputnsend(e, ruleForm.sendCount, 'jindou'))"
                @input="ruleForm.sendCount = getNumberData(1, $event, 0, 1)" @change="handleSendCount" show-word-limit
                placeholder="请输入" style="width: 140px" :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))">
              </el-input>
              <el-tooltip class="item" effect="light" content="奖品发放总人数设置" placement="bottom">
                <el-button type="text" style="margin-left: 6px;width: 35px;">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
              <el-checkbox v-model="ruleForm.isOutClose" :disabled="isStart || (activityData.id == 13 && (valueRow ? valueRow.status == 2 : false))" style="margin-left:7px">
                勾选奖品发完自动结束活动
              </el-checkbox>
            </el-form-item>

            <el-form-item label="礼包奖项:" required v-if="false">
              <el-radio :disabled="giftYouDisabled || isStart" @change="changeHavePrizes"
                v-model="ruleForm.isHavePrizes" label="1">有奖项</el-radio>
              <el-radio :disabled="giftWuDisabled || isStart" @change="changeHavePrizes" v-model="ruleForm.isHavePrizes"
                label="2">无奖项<span style="color:#999">（链接跳转）</span></el-radio>
            </el-form-item>

            <el-form-item label="礼包样式:" style="position: relative;" required>
              <template v-if="ruleForm.isHavePrizes == 2">
                <template v-if="false">
                  <el-button type="text" style="background: #fe4d45;color:#fff" :disabled="isStart">上传图片</el-button>
                  <el-tooltip v-if="false" placement="bottom-start" effect="light" popper-class="tooplitMax">
                    <div slot="content" class="tooltipBox">
                      <div class="tooltipBox-left">
                        <!-- <div class="tooltipheis"></div> -->
                        <div class="tooltipBoder"></div>
                        <div class="tooltipliji"></div>
                        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/mengbantu.png" alt="" />
                      </div>
                      <div class="tooltipBox-right">
                        <div style="margin-top:28px">
                          <p class="p1">字体：</p>
                          <p class="p2">方正及汉仪字体（正文内容）</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">尺寸：</p>
                          <p class="p2">礼包整体尺寸（包括氛围素材） 630*788px</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">按钮：</p>
                          <p class="p2">“领取按钮”大小440*100px，位置居中于礼包下方，并且与礼包有明显的区分，清晰可见；</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">礼包主要区域要求：</p>
                          <p class="p2">礼包主要区域标题与正文区分，文字内容与礼包背景要有明显的差别，利益点突出，主次分明，利益点文案不得融入背景</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">氛围素材区域要求：</p>
                          <p class="p2">氛围素材区域剧中与礼包主要区域与整体页面，高度788px；氛围素材与利益点区分；</p>
                        </div>
                      </div>
                    </div>
                    <!-- <el-button>图片示例</el-button> -->
                    <el-button type="text" style="color:#333">图片示例</el-button>
                  </el-tooltip>
                  <el-button type="text"
                    style="background: #fe4d45;color:#fff;position: absolute;left: 466px;">上传图片</el-button>
                  <el-tooltip v-if="false" placement="bottom-start" effect="light" popper-class="tooplitMax">
                    <div slot="content" class="tooltipBox">
                      <div class="tooltipBox-left">
                        <!-- <div class="tooltipheis"></div> -->
                        <div class="tooltipBoder"></div>
                        <div class="tooltipliji"></div>
                        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/mengbantu.png" alt="" />
                      </div>
                      <div class="tooltipBox-right">
                        <div style="margin-top:28px">
                          <p class="p1">字体：</p>
                          <p class="p2">方正及汉仪字体（正文内容）</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">尺寸：</p>
                          <p class="p2">礼包整体尺寸（包括氛围素材） 630*788px</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">按钮：</p>
                          <p class="p2">“领取按钮”大小440*100px，位置居中于礼包下方，并且与礼包有明显的区分，清晰可见；</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">礼包主要区域要求：</p>
                          <p class="p2">礼包主要区域标题与正文区分，文字内容与礼包背景要有明显的差别，利益点突出，主次分明，利益点文案不得融入背景</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">氛围素材区域要求：</p>
                          <p class="p2">氛围素材区域剧中与礼包主要区域与整体页面，高度788px；氛围素材与利益点区分；</p>
                        </div>
                      </div>
                    </div>
                    <!-- <el-button>图片示例</el-button> -->
                    <el-button type="text" style="color:#333;position:absolute;left: 637px;">图片示例</el-button>
                  </el-tooltip>
                </template>
                <div style="display:flex;">
                  <div style="width: 540px;">
                    <jd-button type="break" :disabled="isStart" @click="giftPopup = true, giftPopupNum = 1">重新选择</jd-button>
                    <div>非会员礼包<span style="color:#999">（非会员人群进入店铺时展示的礼包样式）</span></div>
                    <div class="wrapperBg" style="width: 235px;height: 419px;position: relative;">
                      <img class="giftImg" :src="templateUrlimg" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                    </div>
                    <div style="margin-top:20px">跳转链接<span style="color:#999">（建议设置开卡链接）</span></div>
                    <div>
                      <el-input type="textarea" class="textareabox" placeholder="请输入链接" style="width: 336px;"
                        resize="none" v-model="ruleForm.jumpLink" :disabled="isStart"></el-input>
                    </div>
                    <div style="margin-top:10px">
                      <jd-tip>
                        注：用户点击礼包跳转的落地页链接，如果不设置，则点击礼包默认关闭弹窗
                      </jd-tip>
                    </div>
                  </div>
                  <div style="width: 540px;">
                    <jd-button type="break" @click="giftPopup = true, giftPopupNum = 2" :disabled="isStart">重新选择</jd-button>
                    <div>
                      <el-checkbox v-model="ruleForm.isMemberGiftCheck" :disabled="isStart"> 会员礼包 </el-checkbox><span
                        style="color:#999">（如不勾选，则会员进入店铺则不弹出礼包）</span>
                    </div>
                    <div class="wrapperBg" style="width: 235px;height: 419px;position: relative;">
                      <img class="giftImg" :src="templateUrlimg1" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                    </div>
                    <div style="margin-top:20px">跳转链接<span style="color:#999">（建议设置优惠券\活动页面\商品页面的链接）</span></div>
                    <div>
                      <el-input type="textarea" class="textareabox" placeholder="请输入链接" style="width: 336px"
                        resize="none" v-model="ruleForm.memberGiftJumpLink" :disabled="isStart"></el-input>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="ruleForm.isHavePrizes == 1">
                <span>当前样式最多只能设置{{ temItem.awardNumLimit || temItem.prizeType.split(",").length }}个奖项，勾选后则表示选中奖品</span>
                <div class="shopSet">
                  <div class="shopSet-left" v-if="isOld">
                    <div class="shopSetLeft-connet">
                      <template v-for="(item, index) in libaoList">
                        <div class="inner" v-if="item.giftFalse" :class="{ innerAction: item.backAction }" :key="index"
                          @click="handleRemovePoint(item, index)">
                          <div class="innerTap" :class="{ innerTapAction: item.backAction }">
                            <div v-if="item.backAction" class="logoImg" :class="[`img${index}`]"
                              :style="{ background: item.backAction ? `url(${item.hoverImg}) no-repeat` : `url(${item.logoImg}) no-repeat` }">
                            </div>
                            <div v-else class="logoImg" :class="[`img${index}`]"></div>
                            <div class="innerTap-name">{{ item.name }}</div>
                            <div class="innerTap-bottom" :class="{ botAction: item.backAction }"
                              @click.stop="handleClickPoint(item, index)">
                              选择
                            </div>
                          </div>
                          <div class="innerTip">{{ item.priceName }}</div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- 新活动 -->
                  <div class="shopSet-left" v-if="!isOld">
                    <gifBagStyle :giftPrizeType="giftPrizeType" :libaoList="libaoList" :sendCount="ruleForm.sendCount"
                      @handleClickPoint="handleClickPoint2" @closePrize="closePrize" @handleRemovePoint="handleRemovePoint2" 
                      @setDonCoupon="setDonCoupon"/>
                  </div>
                  <div class="shopSet-right">
                    <!-- <div>
                      <jd-button :disabled="isStart" @click="giftPopup = true, giftPopupNum = 3"
                        type="break">重新选择</jd-button>
                      <el-tooltip v-if="false" placement="bottom-start" effect="light" popper-class="tooplitMax">
                        <div slot="content" class="tooltipBox">
                          <div class="tooltipBox-left">
                            <div class="tooltipBoder"></div>
                            <div class="tooltipliji"></div>
                            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/mengbantu.png" alt="" />
                          </div>
                          <div class="tooltipBox-right">
                            <div style="margin-top:28px">
                              <p class="p1">字体：</p>
                              <p class="p2">方正及汉仪字体（正文内容）</p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">尺寸：</p>
                              <p class="p2">礼包整体尺寸（包括氛围素材） 630*788px</p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">按钮：</p>
                              <p class="p2">“领取按钮”大小440*100px，位置居中于礼包下方，并且与礼包有明显的区分，清晰可见；</p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">礼包主要区域要求：</p>
                              <p class="p2">
                                礼包主要区域标题与正文区分，文字内容与礼包背景要有明显的差别，利益点突出，主次分明，利益点文案不得融入背景
                              </p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">氛围素材区域要求：</p>
                              <p class="p2">氛围素材区域剧中与礼包主要区域与整体页面，高度788px；氛围素材与利益点区分；</p>
                            </div>
                          </div>
                        </div>
                        <el-button type="text" style="color:#333">图片示例</el-button>
                      </el-tooltip>
                    </div> -->
                    <div class="wrapperBg" style="margin-top:25px;width: 235px;height: 419px;position: relative;">
                      <img class="giftImg" v-if="ruleForm.customPicUrl" :src="ruleForm.customPicUrl" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                      <span class="giftBottom">{{ ruleForm.buttonText }}</span>
                    </div>
                    <div class="shopSet-right-btn">
                    <jd-button type="break" style="margin-right: 8px;" @click="giftPopup = true,giftPopupNum = 3" :disabled="isStart || backgroundOpacity">更换模板</jd-button>
                    <el-upload
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUploadUrl"
                      :on-success="handleUploadUrl"
                      :disabled="isStart || backgroundOpacity"
                    >
                      <jd-button type="break" style="margin-right: 8px;" :disabled="isStart || backgroundOpacity">更换图片</jd-button>
                    </el-upload>
                    <jd-button type="break" :disabled="isStart || backgroundOpacity" @click="resetUrl">重置图片</jd-button>
                  </div>
                  <div class="shopSet-right-tips">
                    <div>不建议自行更换活动图片，有需求可联系客服进行定制上传</div>
                    <div>图片尺寸：推荐 宽度630px  高度788px</div>
                    <div>图片大小：不超过1M，支持JPG、JPEG、GIF、PNG</div>
                  </div>
                  </div>
                </div>
              </template>
            </el-form-item>
            <!-- 新增字段 -->
            <el-form-item label="是否重点活动:" required>
              <div class="flexc-cen-x mt10">
                <el-radio-group v-model="isKeyActivity" :disabled="isDisabled">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <div>
                      大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                    </div>
                  </template>
                  <i class="new-icon-box ml8"></i>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="活动投放位置:" required>
              <el-checkbox-group v-model="placementPosition" :disabled="isDisabled">
                <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
                <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
                <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
                <el-checkbox label="SHOP">店铺</el-checkbox>
                <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
                <el-checkbox label="OTHER">其他渠道</el-checkbox>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                  </template>
                  <i class="new-icon-box ml8"></i>
                </el-tooltip>
              </el-checkbox-group>
            </el-form-item>
          </template>
          <template v-if="this.activityData.id != 13 && this.activityData.id != 14">
            <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
            <!-- <jd-title label="分享设置" type="bold"/>
            <el-form-item label="小程序分享标题:" required>
              <el-input type="text" style="width: 425px;margin-left:8px;" show-word-limit v-model="ruleForm.shareTitle"
                :maxlength="28" :disabled="isStart"></el-input>
            </el-form-item>
            <el-form-item label="小程序分享简介:" required>
              <el-input type="text" style="width: 425px;margin-left:8px;" show-word-limit
                v-model="ruleForm.shareIntroduce" :maxlength="28" :disabled="isStart"></el-input>
            </el-form-item>
            <el-form-item label="小程序分享图片:" required>
              <div class="miniAppPic" style="margin-left:8px;">
                <div class="top1">
                  <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                    :before-upload="beforeUpload1" :on-success="handleUpload1" :disabled="isStart">
                    <jd-button type="blueText">自定义上传</jd-button>
                  </el-upload>
                  <jd-button type="blueText" style="margin-left: 20px" @click="picUrlReset1">重置</jd-button>
                </div>
                <div class="bottom1">
                  <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-image>
                  <div class="tips">
                    <p>建议上传尺寸：200px * 200px</p>
                    <p>图片大小：1MB以内</p>
                    <p>格式：jpg、png</p>
                  </div>
                </div>
              </div>
            </el-form-item> -->
          </template>

          <template v-if="activityData.id != 13 && activityData.id != 14">
            <activityRules :activityData="activityData" :valueRow="valueRow" :needIsForceRemind="activityData.id != 4&&activityData.id != 7" :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition" :isForceRemind.sync="isForceRemind" v-model="ruleForm.activityRulesText" @generateRule="generateRule"></activityRules>
            <!-- <jd-title label="活动规则" type="bold"/>
            <el-form-item label="规则内容:" required>
              <div style="
              width: 570px;
              backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            ">
                <el-input type="textarea" class="textarea" style="width: 543px" resize="none"
                  v-model="ruleForm.activityRulesText" :maxlength="2000"></el-input>
                <div class="prosi" style="color: #909399">
                  （{{ ruleForm.activityRulesText.length ? ruleForm.activityRulesText.length : 0 }}/2000）
                </div>
                <div>
                  <jd-button type="blue" @click="generateRule" style="margin-top: 16px">
                    生成规则
                  </jd-button>
                </div>
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </el-form-item> -->
          </template>

          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <jd-button v-if="(localStep == 2 && activityData.id != 13 && activityData.id != 14)||backgroundOpacity" v-show="!itemId" @click="clickLocalStep()">{{ backgroundOpacity ?
        "返回列表" :
        "返回上一步" }}</jd-button>
      <jd-button v-else-if="activityData.id == 13 && activityData.id == 14" v-show="!itemId" @click="clickLocalStep()">{{ backgroundOpacity ?
        "返回列表" :
        "返回上一步" }}</jd-button>
      <jd-button @click="saveDraft" style="margin-left: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-show="!itemId" v-if="isSave" type="blue" style="margin-left: 8px" @click="saveEdit"
          v-preventReClick>保存设置</jd-button>
      </template>
      <jd-button v-show="itemId" @click="cancelEdit">取消</jd-button>
      <jd-button v-show="itemId" type="blue" style="margin-left: 12px">保存设置</jd-button>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor v-if="selectGoodsState" :disabled="backgroundOpacity" ref="selectGo" :isShow="selectGoodsState" @close="selectGoodsClose" isInteract
      :selectGoods="selectGoodsArr" :moduleType="true" :skuSearch="true" :xianz="true" :numlimit="numlimit">
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px">确定</jd-button>
      </div>
    </el-dialog>
    <!-- 确定礼包模板弹窗 -->
    <gift-popup :activityDataID="activityData.id" @handleChoice="handleChoice" v-if="giftPopup" />
    <!-- 邀请关注有礼 选择奖品弹窗 -->
    <selectProduct @close="colseDialog" :isShowFirst="isShowFirst" :tipShow="true" :echoDate="echoDate"
      :actId="valueRow" :num="2" :JingdouCount="JingdouCount" v-if="showDialog" ref="selectProduct" :actType="activityData.id" :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData">
    </selectProduct>
    <!-- 红包雨 选择奖品弹窗 -->
    <selectProduct ref="selectProductAward" v-if="showSelectProductAward" :isShowFirst="isShowFirst" :echoDate="echoDate" :actId="valueRow" :num="1"
      :JingdouCount="JingdouCount" :actType="activityData.id" :actEndTime="ruleForm.endTime" @choose-shop="getTheDataAward"> </selectProduct>
    <!-- 红包雨 选择奖品弹窗 -->
    <selectProduct ref="selectProductItem" v-if="showSelectProductItem" :isShowFirst="isShowFirst" :echoDate="echoDate" :actId="valueRow" :num="1"
      :JingdouCount="JingdouCount" :actType="activityData.id" :actEndTime="ruleForm.endTime" @choose-shop="getTheDataItem"> </selectProduct>
    <!-- 礼包 -->
    <selectPrize v-model="dialogPrize" :num="1" :JingdouCount="JingdouCount" :libaoItem="libaoItem"
      @closePrize="closePrize"></selectPrize>
    <!-- 自定义上传 -->
    <uploadPopup :visible.sync="visibleUpload" @handleSave="handleSave" />
    <!-- 选择人群弹窗 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList" @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>

    <!-- 加购部分商品弹窗 -->
    <select-add-good v-model="isSelectAddGood" :goodList="itemListFor" :selectedGoodList="selectedGoodList" @select="onAddGoodSelect"/>
    
    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
    <select-add-good v-if="isSelectAddGood" v-model="isSelectAddGood" :goodList="itemListFor" :selectedGoodList="selectedGoodList" @select="onAddGoodSelect"/>
  </div>
</template>

<script>
import giftPopup from "./giftPopup.vue";
import {
  creatIntegral,
  editIntegral,
  searchIntegral,
  focusStores,
  editfocusStores,
  searchfocusStores,
  invite,
  editInvite,
  searchInvite,
  follow,
  editfollow,
  searchfollow,
  information,
  editInformationAa,
  searchInformation,
  creatPrize,
  editPrize,
  searchPrize,
  incentivesAddCart,
  editAddCart,
  searchAddCart
} from "@/api/jhk/integralCenter/integralTask";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import { getPersonLabelList, createShopGift, getGiftBagTemplate, getGiftBagList, giftBagEide, editShopGift, getValidActivity, hdTaskTemplateGroup, sellerImage,newupdateCommon } from "@/api/jhk/paradiseAndTaskCommonController.js";
import uploadPopup from "./uploadPopup.vue";
import { giftBagTemplate, templateDelete } from "@/api/jhk/public.js";
import { uploadpic, getmoble } from "@/api/jhk/paradiseAndTaskCommonController.js";
import addCartPhone from "./addCartPhone2.vue";
import selectPeople from "@/components/select-people-yunqi.vue";
import SelectAddGood from "./components/SelectAddGood.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import gifBagStyle from "./components/gifBagStyle.vue"
import informationForm from "./components/informationForm.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import taskDialog from "./components/taskDialog.vue"
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

const prizeName = ["", "", "京豆", "实物", "店铺积分", "京东E卡", "爱奇艺会员", "京东PLUS会员", "现金红包"];
export default {
  components: {
    selectProduct,
    selectPrize,
    selectGoodsMonitor,
    draggable,
    giftPopup,
    uploadPopup,
    addCartPhone,
    selectPeople,
    SelectAddGood,
    addPrizeNum,
    gifBagStyle,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    taskDialog,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
    activityDataInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  async created() {
    console.log('当前玩法id---->', this.activityData);
    console.log('当前玩法id---->', this.activityData.id);
    this.isCopy = this.activityData.isCopy ? true : false // 判断当前是否为复制
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    getmoble().then((res) => {
      this.sellerNick = res.data.sellerNick
    })
    
    this.templateInfoData = this.activityDataInfo
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
    } else {
      if (this.activityData.id == 13 || this.activityData.id == 14) {
        this.defaultTime = [this.$getDate(30, 25)[0].substring(11, this.$getDate(30, 25)[0].length), this.$getDate(30, 25)[0].substring(11, this.$getDate(30, 25)[0].length)]
      }
      // 新增活动默认时间
      if(!this.valueRow){
        this.ruleForm.activityStartTime = this.$getDate(30)[0]
        this.ruleForm.activityEndTime = this.$getDate(30)[1]
        this.activityTimeChange();
      }
    }
    
    // 加购有礼需要展示模板配置数据
    if (this.activityData.id == 34 && this.activityDataInfo.id) {
      // 背景图
      this.ruleForm.picUrl = this.activityDataInfo.url
      // 背景色
      this.colorData = this.activityDataInfo.rgb
      this.ruleForm.rgb = this.activityDataInfo.rgb
    }
    if (this.activityData.id == 1 || this.activityData.id == 34) {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.navList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.navList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.getPolite()
    }else{
      if(this.activityData.id != 13 && this.activityData.id != 14){
        this.nextStep('1')
      }
      this.templateId = 0
    }
    console.log('555------>', 555)
    if (this.activityData.id == 13 || this.activityData.id == 14) {
      this.loading = true;
      //  导航分类
      let num = this.activityData.id == 13 ? 0 : 1
      const GiftBag = await getGiftBagList(num)

      if (this.activityData.id == 13) {
        let arr = GiftBag.data
        let index = this.$store.state.loginUserInfo.permissions.indexOf('open:card:upload:template')
        arr[0].isVisible = index == -1 ? false : arr[0].isVisible
        this.navList = [{
          id: "",
          isVisible: true,
          title: "全部",
        }, ...arr]
      } else {
        this.navList = [{
          id: "",
          isVisible: true,
          title: "全部",
        }, ...GiftBag.data]
      }

      this.navItem = this.navList[0]
      // 礼包模板
      this.handleGiftBag()
      this.loading = false;
      // 获取人群
      const { data: res } = await getPersonLabelList();
      this.personLab.customizeList = res.slice(0, 2);
      this.personLab.recommendList = res.slice(2, res.length);
      this.ruleForm.modelIds = res[0].labelId;
    } else {
      this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
      this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
      this.localStep = 1
    }
    if (this.activeValue == 4) {
      //关注店铺有礼
      searchfocusStores({ id: this.valueRow.id })
        .then((res) => {
          // 复制后的活动名称增加“复制”后缀字样
          this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":"");
          this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
          this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
          this.actEndTime = res.data.endTime;
          if (!this.isCopy) { // 复制
            this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
            // 兼容草稿箱
            if(res.data.pointActivityPrizeDTO){
              this.awardSettingsLsit = [res.data.pointActivityPrizeDTO];
              this.awardSettingsLsit.forEach(item => item.minNum = item.totalAmount)
            }
            //曝光商品
            this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
            this.selectGoodsArr = res.data.itemList;
            this.itemListFor = res.data.itemList;
            this.mainImagelist = res.data.itemList;
            this.ruleForm.radio = res.data.priceType;
          }
          this.ruleForm.partner = res.data.allowLevel.split(",");
          this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType
          if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime) {
            this.ruleForm.firstOpenCardTimeType = 2
          }
          if(this.ruleForm.firstOpenCardTimeType==1) {
            this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay;
          }
          this.ruleForm.condFollow = res.data.condFollow ? true : false; //参与条件:开卡
          this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow; //参与条件:开卡
          // 1.14迭代 这里回显
          this.ruleDto={
            openCardStartTime:res.data.ruleDto.openCardStartTime,
            openCardEndTime:res.data.ruleDto.openCardEndTime,
            plusObject:res.data.ruleDto.plusObject, //plus会员
          }
          if(res.data.ruleDto.isForceRemind ){
              this.isForceRemind = res.data.ruleDto.isForceRemind 
          }
          if(res.data.isKeyActivity ){
            this.isKeyActivity = res.data.isKeyActivity 
          }
          if(res.data.placementPosition ){
            this.placementPosition = res.data.placementPosition.split(",")
          }
          if(res.data.ruleDto.cusTemplateJSON){
              this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
          }

          this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
          this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
          this.ruleForm.sharePic = res.data.ruleDto.sharePic;
          this.ruleForm.isValidBlackList = res.data.isValidBlackList;
          // 学生身份
          this.ruleForm.studentSatus = res.data.studentSatus || "";
          this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
          this.activityTimeChange();
          if(res.data.allowLevel == "99"){
            this.peopleSelected = res.data.crowdIds.split(",")
            this.actMember = "3"
          }else if(res.data.allowLevel == "-1"){
            this.actMember = "1"
          }else{
            this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
          }
        })
        .catch(() => { });
    } else if (this.activeValue == 6) {
      //邀请关注有礼
      searchfollow({ id: this.valueRow.id }).then((res) => {
        this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
        this.actEndTime = res.data.endTime;
        if (!this.isCopy) {
          this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize ? 1 : 0;
          if (res.data.ruleDto.isTaskPrize) {
            this.ruleForm.isCumulativePrize = 2
          }
          if (res.data.ruleDto.isTaskPrize) {
            this.ruleForm.isCumulativePrize == 2
          }
          if (this.ruleForm.isCumulativePrize) {
            if (this.ruleForm.isCumulativePrize == 1) {
              this.tableData = res.data.ruleDto.cumulativePrizes.map((item, index) => {
                let obj = {
                  peopleCount: item.cumulativeNum,
                  title: item.cumulativePrizeDTO.title,
                  assetsId: item.cumulativePrizeDTO.assetsId,
                  prizeType: item.cumulativePrizeDTO.prizeType,
                  logo: item.cumulativePrizeDTO.logo,
                  price: item.cumulativePrizeDTO.price || item.cumulativePrizeDTO.singleAmount,
                  singleAmount: item.cumulativePrizeDTO.singleAmount,
                  prizeCount: item.cumulativePrizeDTO.totalAmount,
                  minNum: item.cumulativePrizeDTO.totalAmount,
                  id: item.cumulativePrizeDTO.pointActivityPrizeId,
                  addressFillEndTime: item.cumulativePrizeDTO.addressFillEndTime,
                  predictSendTime: item.cumulativePrizeDTO.predictSendTime,
                  isFollowActivityEndTime: item.cumulativePrizeDTO.isFollowActivityEndTime,
                  shouldCollectExtraData: item.cumulativePrizeDTO.shouldCollectExtraData,
                  extraQuestion: item.cumulativePrizeDTO.extraQuestion,
                  addressFillLimit: item.cumulativePrizeDTO.addressFillLimit,
                  dailyLimit: item.cumulativePrizeDTO.dailyLimit,
                  dailyLimitType: item.cumulativePrizeDTO.dailyLimitType,
                  idleLimit: item.cumulativePrizeDTO.idleLimit,
                  busyLimit: item.cumulativePrizeDTO.busyLimit,
                  prizeGoShop: item.cumulativePrizeDTO.prizeGoShop,
                };
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (obj.prizeType == 3) {
                  if (item.cumulativePrizeDTO.commitAddressLimit) {
                    obj.commitAddressLimit = typeof item.cumulativePrizeDTO.commitAddressLimit === 'string'
                      ? item.cumulativePrizeDTO.commitAddressLimit.split(',').map(Number)
                      : item.cumulativePrizeDTO.commitAddressLimit;
                  } else {
                    obj.commitAddressLimit = [0];
                  }
                }
                if (obj.prizeType == 1) {
                  obj.couponType = item.cumulativePrizeDTO.couponType
                  obj.prizeGoShop = item.cumulativePrizeDTO.prizeGoShop
                }
                if (obj.prizeType == 14) {
                  obj.pointActivityPrizeRemark = item.cumulativePrizeDTO.pointActivityPrizeRemark;
                  obj.isGoodManage = item.cumulativePrizeDTO.isGoodManage||0;
                }
                return obj;
              });
            } else {
              this.taskTableData = res.data.ruleDto.cumulativePrizes.map((item, index) => {
                let obj = {
                  peopleCount: item.cumulativeNum,
                  title: item.cumulativePrizeDTO.title,
                  assetsId: item.cumulativePrizeDTO.assetsId,
                  prizeType: item.cumulativePrizeDTO.prizeType,
                  logo: item.cumulativePrizeDTO.logo,
                  price: item.cumulativePrizeDTO.price || item.cumulativePrizeDTO.singleAmount,
                  singleAmount: item.cumulativePrizeDTO.singleAmount,
                  prizeCount: item.cumulativePrizeDTO.totalAmount,
                  minNum: item.cumulativePrizeDTO.totalAmount,
                  id: item.cumulativePrizeDTO.pointActivityPrizeId,
                  addressFillEndTime: item.cumulativePrizeDTO.addressFillEndTime,
                  predictSendTime: item.cumulativePrizeDTO.predictSendTime,
                  isFollowActivityEndTime: item.cumulativePrizeDTO.isFollowActivityEndTime,
                  shouldCollectExtraData: item.cumulativePrizeDTO.shouldCollectExtraData,
                  extraQuestion: item.cumulativePrizeDTO.extraQuestion,
                  addressFillLimit: item.cumulativePrizeDTO.addressFillLimit,
                  dailyLimit: item.cumulativePrizeDTO.dailyLimit,
                  dailyLimitType: item.cumulativePrizeDTO.dailyLimitType,
                  idleLimit: item.cumulativePrizeDTO.idleLimit,
                  busyLimit: item.cumulativePrizeDTO.busyLimit,
                  prizeGoShop: item.cumulativePrizeDTO.prizeGoShop,
                };
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (obj.prizeType == 3) {
                  if (item.cumulativePrizeDTO.commitAddressLimit) {
                    obj.commitAddressLimit = typeof item.cumulativePrizeDTO.commitAddressLimit === 'string'
                      ? item.cumulativePrizeDTO.commitAddressLimit.split(',').map(Number)
                      : item.cumulativePrizeDTO.commitAddressLimit;
                  } else {
                    obj.commitAddressLimit = [0];
                  }
                }
                if (obj.prizeType == 1) {
                  obj.couponType = item.cumulativePrizeDTO.couponType
                  obj.prizeGoShop = item.cumulativePrizeDTO.prizeGoShop
                }
                if (obj.prizeType == 14) {
                  obj.pointActivityPrizeRemark = item.cumulativePrizeDTO.pointActivityPrizeRemark;
                  obj.isGoodManage = item.cumulativePrizeDTO.isGoodManage||0;
                }
                return obj;                
              });
                console.log('taskTableData',this.taskTableData);

            }
          } else {
            let prize = res.data.ruleDto.cumulativePrizes;
            // 兼容草稿箱
            if(prize && prize.length){
              this.ruleForm.prizeCount = prize[0].totalAmount;
              let obj = {
                ...prize[0].cumulativePrizeDTO,
                singleAmount: prize[0].cumulativePrizeDTO.singleAmount,
                title: prize[0].cumulativePrizeDTO.title,
                assetsId: prize[0].cumulativePrizeDTO.assetsId,
                prizeType: prize[0].cumulativePrizeDTO.prizeType,
                logo: prize[0].cumulativePrizeDTO.logo,
                price: prize[0].cumulativePrizeDTO.price,
                discount: prize[0].cumulativePrizeDTO.singleAmount,
                minNum: prize[0].cumulativePrizeDTO.totalAmount,
                id: prize[0].cumulativePrizeDTO.pointActivityPrizeId,
                shouldCollectExtraData: prize[0].cumulativePrizeDTO.shouldCollectExtraData,
                extraQuestion: prize[0].cumulativePrizeDTO.extraQuestion,
                addressFillEndTime: prize[0].cumulativePrizeDTO.addressFillEndTime,
                predictSendTime: prize[0].cumulativePrizeDTO.predictSendTime,
                isFollowActivityEndTime: prize[0].cumulativePrizeDTO.isFollowActivityEndTime,
                addressFillLimit: prize[0].cumulativePrizeDTO.addressFillLimit,
                dailyLimit: prize[0].cumulativePrizeDTO.dailyLimit,
                dailyLimitType: prize[0].cumulativePrizeDTO.dailyLimitType,
                idleLimit: prize[0].cumulativePrizeDTO.idleLimit,
                busyLimit: prize[0].cumulativePrizeDTO.busyLimit,
                prizeGoShop: prize[0].cumulativePrizeDTO.prizeGoShop,
              };
              if(obj.prizeType == 1) {
                obj.prizeGoShop = prize[0].cumulativePrizeDTO.prizeGoShop
              }
              if (obj.prizeType == 14) {
                obj.pointActivityPrizeRemark = prize[0].cumulativePrizeDTO.pointActivityPrizeRemark;
                obj.isGoodManage = prize[0].cumulativePrizeDTO.isGoodManage||0;
              }
              this.awardSettingsLsit = [obj];
            }
            this.ruleForm.peopleCount = res.data.ruleDto.maxInviteNum || "";
            this.ruleForm.inviteNum = res.data.ruleDto.inviteNum || "";
          }
          //曝光商品
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.itemListFor = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.ruleForm.radio = res.data.priceType;
        }
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType
        // 1.14迭代 这里回显
        this.ruleDto={
          openCardStartTime:res.data.ruleDto.openCardStartTime,
          openCardEndTime:res.data.ruleDto.openCardEndTime,
          plusObject:res.data.ruleDto.plusObject, //plus会员
        }
        if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime) {
          this.ruleForm.firstOpenCardTimeType = 2
        }
        if(this.ruleForm.firstOpenCardTimeType==1) {
          this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay;
        }
        this.ruleForm.condFollow = res.data.condFollow ? true : false; //参与条件
        this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow; //参与条件:开卡
        if(res.data.ruleDto.isForceRemind){
            this.isForceRemind = res.data.ruleDto.isForceRemind 
        }
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        if(res.data.ruleDto.cusTemplateJSON){
            this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
        }
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        this.activityTimeChange();
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        }else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
          if (res.data.allowLevel.indexOf('-1') != -1) {
            this.ruleForm.partner = ['-1']
          }
        }
        // 复制  清空规则和奖品设置
        if (this.isCopy) {
          this.ruleForm.activityRulesText = ""
        }
      });
    } else if (this.activeValue == 7) {
      //完善信息有礼
      searchInformation({ id: this.valueRow.id })
        .then((res) => {
          // this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
          this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":"");
          this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
          this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
          this.ruleForm.partner = res.data.allowLevel.split(",");
          this.actEndTime = res.data.endTime;
          this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType;
          // 1.14迭代 这里回显
          this.ruleDto={
            openCardStartTime:res.data.ruleDto.openCardStartTime,
            openCardEndTime:res.data.ruleDto.openCardEndTime,
            plusObject:res.data.ruleDto.plusObject, //plus会员
          }
          this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
          if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime) {
            this.ruleForm.firstOpenCardTimeType = 2
          }
          if(this.ruleForm.firstOpenCardTimeType==1) {
            this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
          }

          this.ruleForm.condFollow = res.data.condFollow ? true : false; //参与条件
          this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow; //参与条件:开卡

          if(res.data.ruleDto.isForceRemind ){
            this.isForceRemind = res.data.ruleDto.isForceRemind 
          }
          if(res.data.isKeyActivity ){
            this.isKeyActivity = res.data.isKeyActivity 
          }
          if(res.data.placementPosition ){
            this.placementPosition = res.data.placementPosition.split(",")
          }
          if(res.data.ruleDto.cusTemplateJSON){
            this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
          }
          
          this.ruleForm.information = res.data.ruleDto.infoNames;
          if (!this.isCopy) { // 非复制
            this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
            // 兼容草稿箱
            if(res.data.pointActivityPrizeDTO){
              this.awardSettingsLsit = [res.data.pointActivityPrizeDTO];
              this.awardSettingsLsit.forEach(item => item.minNum = item.totalAmount)
            }
          }
          //返回数组转换成数组对象
          let arrList = [];
          for (let i in res.data.ruleDto.staticInfoNames) {
            var j = {};
            j.informationmationOne = res.data.ruleDto.staticInfoNames[i].name;
            j.informationmationSelect = res.data.ruleDto.staticInfoNames[i].type;
            arrList.push(j);
          }
          this.itemArrOne = arrList;
          this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
          this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
          this.ruleForm.sharePic = res.data.ruleDto.sharePic;
          this.ruleForm.isValidBlackList = res.data.isValidBlackList;
          // 学生身份
          this.ruleForm.studentSatus = res.data.studentSatus || "";
          this.activityTimeChange();
          if(res.data.allowLevel == "99"){
            this.peopleSelected = res.data.crowdIds.split(",")
            this.actMember = "3"
          }else if(res.data.allowLevel == "-1"){
            this.actMember = "1"
          }else{
            this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
          }
        })
        .catch(() => { });
    } else if (this.activeValue == 1) {
      //签到赢好礼
      searchIntegral({ id: this.valueRow.id }).then((res) => {
        // this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType;
        // 1.14迭代 这里回显
        this.ruleDto={
          openCardStartTime:res.data.ruleDto.openCardStartTime,
          openCardEndTime:res.data.ruleDto.openCardEndTime,
          plusObject:res.data.ruleDto.plusObject, //plus会员
        }
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
        // 补签开关回显
        if(res.data.ruleDto.isSignInReissueEnabled) {
          this.isSignInReissueEnabled = res.data.ruleDto.isSignInReissueEnabled;
          this.$nextTick(()=> {
            this.$refs.taskDialog.handlerTaskList(res.data.ruleDto.taskList);
          })
        }
        if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime) {
          this.ruleForm.firstOpenCardTimeType = 2
        }
        if(this.ruleForm.firstOpenCardTimeType==1) {
          this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
        }


        if(res.data.ruleDto.isForceRemind ){
          this.isForceRemind = res.data.ruleDto.isForceRemind 
        }
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        if(res.data.ruleDto.cusTemplateJSON){
          this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
        }

        this.ruleForm.condFollow = res.data.condFollow ? true : false; //参与条件
        this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow; //参与条件:开卡
        this.ruleForm.isFollow = res.data.ruleDto.requestFollow; //参与条件
        // 指定日期奖品
        const itemArrDate = res.data.pointActivityPrizeDTOList ? res.data.pointActivityPrizeDTOList.filter(v=> v.fixedSendDate) : [];
        if(itemArrDate.length > 0) {
          this.itemArrDate = itemArrDate;
          this.fixedDate = true;
        }
        if (!this.isCopy) { // 复制不需要回显以下内容
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          if (res.data.continuousActivityPrizeDTOList && res.data.continuousActivityPrizeDTOList.length) {
            this.ruleForm.prizeSetOne = true;
            this.ruleForm.continueRuleType =res.data.ruleDto.continueRuleType
          }else {
            this.ruleForm.prizeSetOne = false;
          }
          if (res.data.pointActivityPrizeDTO) {
            this.awardSettingsLsit = [res.data.pointActivityPrizeDTO];
            this.awardSettingsLsit.forEach(item => item.minNum = item.totalAmount)
            if (res.data.pointActivityPrizeDTO.price != "") {
              this.limit = false;
            }
            this.ruleForm.prizeSet = true;
          } else {
            this.ruleForm.prizeSet = false;
          }
          // 兼容草稿箱
          if(res.data.continuousActivityPrizeDTOList && res.data.continuousActivityPrizeDTOList.length){
            this.itemArr = res.data.continuousActivityPrizeDTOList.map(item => {
              return {
                days: item.continuousSignDay,
                ...item,
                minNum: item.totalAmount
              }
            });
          }
          // 兼容草稿箱
          if(res.data.pointActivityPrizeDTO){
            this.ruleForm.inputprize = String(res.data.pointActivityPrizeDTO.price);
          }
          //曝光商品
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.itemListFor = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.ruleForm.radio = res.data.priceType;
        }

        this.templateJson = JSON.parse(res.data.templateJson)
        this.templateId = res.data.templateId
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        this.activityTimeChange();
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        }else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }
      });
    } else if (this.activeValue == 34) {
      // 加购有礼
      searchAddCart({ id: this.valueRow.id }).then((res) => {
        let templateJsonData = JSON.parse(res.data.templateJson)
        this.templateInfoData = templateJsonData
        this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType;
        // 1.14迭代 这里回显
        this.ruleDto={
          openCardStartTime:res.data.ruleDto.openCardStartTime,
          openCardEndTime:res.data.ruleDto.openCardEndTime,
          plusObject:res.data.ruleDto.plusObject, //plus会员
        }
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
        if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime) {
          this.ruleForm.firstOpenCardTimeType = 2
        }
        if(this.ruleForm.firstOpenCardTimeType==1) {
          this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
        }

        if(res.data.ruleDto.isForceRemind ){
          this.isForceRemind = res.data.ruleDto.isForceRemind 
        }
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        if(res.data.ruleDto.cusTemplateJSON){
          this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
        }

        //tapd 进店逛逛
        this.ruleForm.goShopSetting = res.data.ruleDto.goShopSetting;
        this.ruleForm.goShopAppId  = res.data.ruleDto.goShopAppId;
        this.ruleForm.goShopUrl = res.data.ruleDto.goShopUrl;

        this.ruleForm.condFollow = res.data.ruleDto.requestFollow; //参与条件
        this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow; //参与条件:开卡
        setTimeout(() => {
          this.ruleForm.picUrl = res.data.ruleDto.picUrl; // 活动背景图
        }, 100);
        this.colorData = res.data.ruleDto.rgb; // 活动背景色
        this.ruleForm.rgb = res.data.ruleDto.rgb; // 活动背景色
        this.colorShow2 = false
        this.colors.hex = res.data.ruleDto.rgb; // 活动背景色
        setTimeout(() => {
          this.colorShow2 = true
        }, 100)

        if (!this.isCopy) {
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.showPrize = res.data.ruleDto.showPrize;
          this.ruleForm.showPrizeNum = res.data.ruleDto.showPrizeNum;
          // 兼容草稿箱
          if(res.data.pointActivityPrizeDTO){
            this.awardSettingsLsit = [res.data.pointActivityPrizeDTO];
            this.awardSettingsLsit.forEach(item => item.minNum = item.totalAmount)
          }

          // 加购商品
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          this.itemListFor = res.data.itemList;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;

          this.ruleForm.showBatchAddCart = res.data.ruleDto.showBatchAddCart;
          let itemList = res.data.itemList || [];
          let recommendSkuIds = res.data.ruleDto.recommendSkuIds || [];
          this.selectedGoodList = this.ruleForm.showBatchAddCart ==2 ? itemList.filter(item=> recommendSkuIds.includes(Number(item.skuId))) :[];
        }

        this.ruleForm.addCartNum = res.data.ruleDto.addCartNum;

        this.templateJson = JSON.parse(res.data.templateJson);
        this.templateId = res.data.templateId
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        this.activityTimeChange();
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        } else if (res.data.allowLevel == "100") {
          this.actMember = "4"
          this.nonObj.lastPayStartTime = res.data.ruleDto.lastPayStartTime || '';
          this.nonObj.lastPayEndTime = res.data.ruleDto.lastPayEndTime || '';
          this.nonObjTime = [res.data.ruleDto.lastPayStartTime || '', res.data.ruleDto.lastPayEndTime || '']
          this.nonObj.finishOrderType = res.data.ruleDto.finishOrderType || 0;
          // console.log("res.data.ruleDto", res.data.ruleDto, res.data.ruleDto.hasOwnProperty('numStart'))
          this.nonObj.numStart  = res.data.ruleDto.hasOwnProperty('numStart') ?  res.data.ruleDto.numStart : '';
          this.nonObj.numEnd = res.data.ruleDto.hasOwnProperty('numEnd') ?  res.data.ruleDto.numEnd : '';
        } else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }
      })
    } else if (this.activeValue == 3) {
      //每日限时抢
      searchPrize({ id: this.valueRow.id }).then((res) => {
        this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":"");
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType;
        // 1.14迭代 这里回显
        this.ruleDto={
          openCardStartTime:res.data.ruleDto.openCardStartTime,
          openCardEndTime:res.data.ruleDto.openCardEndTime,
          plusObject:res.data.ruleDto.plusObject, //plus会员
        }
        if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime) {
          this.ruleForm.firstOpenCardTimeType = 2
        }
        if(this.ruleForm.firstOpenCardTimeType==1) {
          this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
        }

        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
        if(res.data.ruleDto.isForceRemind ){
          this.isForceRemind = res.data.ruleDto.isForceRemind 
        }
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        if(res.data.ruleDto.cusTemplateJSON){
          this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
        }

        this.ruleForm.condFollow = res.data.ruleDto.requestFollow; //参与条件
        this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow; //参与条件:开卡
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        if (!this.isCopy) {
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.limitedTimeGrab = res.data.ruleDto.startTime;
          this.ruleForm.prizeCount = res.data.ruleDto.prizeCount;
          // 兼容草稿箱
          if(res.data.pointActivityPrizeDTO){
            this.awardSettingsLsit = [res.data.pointActivityPrizeDTO];
            this.awardSettingsLsit.forEach(item => item.minNum = item.totalAmount)
            if (res.data.pointActivityPrizeDTO.prizeType == 4) {
              this.prizeSettingList.title = res.data.pointActivityPrizeDTO.price + "店铺积分";
            } else {
              this.prizeSettingList.title = res.data.pointActivityPrizeDTO.title;
            }
          }
          //曝光商品
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          // this.itemListFor.length = this.mainImagelist.length;
          this.selectGoodsArr = res.data.itemList;
          this.itemListFor = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.ruleForm.radio = res.data.priceType;
        }
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        this.activityTimeChange();
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        } else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }
        // 复制  清空规则和奖品设置
        // if(this.isCopy){
        //   this.ruleForm.startTime = ""
        //   this.ruleForm.prizeCount = ""
        //   this.ruleForm.activityRulesText = ""
        //   this.awardSettingsLsit = [...this.defaultAwardSettingsLsit]
        // }
      });
    } else if (this.activeValue == 13) {
      // 开卡礼包
      this.fromLoading = true;
      console.log('数据' ,this.valueRow);
      
      giftBagEide(this.valueRow.id).then((res) => {
        // this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":""); //活动类型  13: 开卡礼包 14: 店铺礼包
        this.ruleForm.activityStartTime = res.data.startTime;
        this.ruleForm.activityEndTime = res.data.endTime;
        this.giftID = res.data.giftTemplateId;
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
        // if(){
        //   this.ruleForm.isExposureItem = res.data.ruleDTO.isExposureItem; //是否添加曝光商品 0 否 1 是
        // }
        this.ruleForm.buttonText = res.data.ruleDto.buttonText;
        this.ruleForm.isOutClose = res.data.ruleDto.isOutClose;
        this.ruleForm.isHavePrizes = res.data.ruleDto.isHavePrizes ? "1" : "2";
        if (this.ruleForm.isHavePrizes == '2') {
          this.memberGiftTemplateId = res.data.memberGiftTemplateId;
          this.templateUrlimg1 = res.data.memberGiftTemplateUrl;
        }
        this.ruleForm.requestFollow = res.data.ruleDto.requestFollow ? "1" : "2"; //是否需要关注店铺
        this.ruleForm.sendCount = res.data.ruleDto.sendCount;
        this.ruleForm.jumpLink = res.data.ruleDto.jumpLink;
        this.ruleForm.isMemberGiftCheck = res.data.ruleDto.isMemberGiftCheck;
        this.ruleForm.memberGiftJumpLink = res.data.ruleDto.memberGiftJumpLink;
        this.ruleForm.modelIds = res.data.ruleDto.modelIds;
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        //人群处理
        if (res.data.ruleDto.modelIds.indexOf(":") != -1) {
          const list = res.data.ruleDto.modelIds.split(":");
          const data = list[1].split("_");
          this.ruleForm.modelIds = list[0];
          if (list[0] == "v1_new_p" || list[0] == "v1_plus" || list[0] == "v1_new_fans") {
            this.ruleForm.vermicelliVal = [];
            this.ruleForm.starVal = [];
          }
          // 、、粉丝
          if (list[0] == "v1_no_f") {
            if (data.length == 4) {
              this.verCheckAll = true;
            }

            this.disableVF = false;
            this.ruleForm.vermicelliVal = data;
          }
          // 星极
          if (list[0] == "v1_customer") {
            if (data.length == 6) {
              this.starCheckAll = true;
            }
            this.disableCUS = false;
            this.ruleForm.starVal = data;
          }
        }
        res.data.giftTemplatePrizeType = res.data.giftTemplatePrizeType ? res.data.giftTemplatePrizeType : ''
        // 礼包模板设置显示奖项 1 店铺积分  2 京豆  3  京券  4  东券")
        const numGift1 = res.data.giftTemplatePrizeType.indexOf("1");
        const numGift2 = res.data.giftTemplatePrizeType.indexOf("2");
        const numGift3 = res.data.giftTemplatePrizeType.indexOf("3");
        const numGift4 = res.data.giftTemplatePrizeType.indexOf("4");

        // 礼包样式
        this.libaoList.forEach((item) => {
          res.data.prizes.forEach((info) => {
              if (numGift1 != -1) {
                if (item.prizeType == "6") {
                  item.giftFalse = true;
                }
              }
              if (numGift2 != -1) {
                if (item.prizeType == "4") {
                  item.giftFalse = true;
                }
              }
              if (numGift3 != -1) {
                if (item.prizeType == "0") {
                  item.giftFalse = true;
                }
              }
              if (numGift4 != -1) {
                if (item.prizeType == "1") {
                  item.giftFalse = true;
                }
              }
              if (item.prizeType == info.prizeType) {
                if (info.prizeType == 6) {
                  item.priceName = "每份店铺积分：" + info.price;
                  item.singleAmount = info.price;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                }
                if (info.prizeType == 4) {
                  item.priceName = "每份京豆额：" + info.price;
                  item.assetsId = info.assetsId;
                  item.singleAmount = info.price;
                  item.backAction = true;
                }
                if (info.prizeType == 1) {
                  item.priceName = info.price + "优惠券";
                  item.singleAmount = 1;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                }
                if (info.prizeType == 0) {
                  item.priceName = info.price + "优惠券";
                  item.singleAmount = 1;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                }
              }
            });
        });
        this.ruleForm.prizes = res.data.prizes;
        this.templateUrlimg = res.data.giftTemplateUrl;
        this.ruleForm.customPicUrl = res.data.giftTemplateUrl;
        //曝光商品集合
        this.selectGoodsArr = res.data.itemList;
        // this.itemListFor = res.data.itemList;
        this.mainImagelist = res.data.itemList;
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        this.ruleForm.radio = res.data.isExposureItem;

        this.itemListFor = res.data.itemList;
        this.activityTimeChange();
        this.fromLoading = false;
      });
    } else if (this.activeValue == 14) {
      // 店铺礼包
      giftBagEide(this.valueRow.id).then((res) => {
        this.fromLoading = true;
        this.ruleForm.activityName = res.data.activityName + (this.isCopy?"复制":""); //活动类型  13: 开卡礼包 14: 店铺礼包
        this.ruleForm.activityStartTime = res.data.startTime;
        this.ruleForm.activityEndTime = res.data.endTime;
        this.giftID = res.data.giftTemplateId;
        this.isOld = res.data.isOld; // 1 老版本  0 新版本
        console.log("--- this.isOld:---", this.isOld)
        this.ruleForm.buttonText = res.data.ruleDto.buttonText;
        this.ruleForm.isOutClose = res.data.ruleDto.isOutClose;
        this.ruleForm.isHavePrizes = res.data.ruleDto.isHavePrizes ? "1" : "2";
        if (this.ruleForm.isHavePrizes == '2') {
          this.memberGiftTemplateId = res.data.memberGiftTemplateId;
          this.templateUrlimg1 = res.data.memberGiftTemplateUrl;
        }
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {}
        this.ruleForm.requestFollow = res.data.ruleDto.requestFollow ? "1" : "2"; //是否需要关注店铺
        this.ruleForm.sendCount = res.data.ruleDto.sendCount;
        this.ruleForm.jumpLink = res.data.ruleDto.jumpLink;
        this.ruleForm.isMemberGiftCheck = res.data.ruleDto.isMemberGiftCheck;
        this.ruleForm.memberGiftJumpLink = res.data.ruleDto.memberGiftJumpLink;
        this.ruleForm.modelIds = res.data.ruleDto.modelIds;
        this.ruleForm.customPicUrl = res.data.ruleDto.customPicUrl
        if(res.data.isKeyActivity ){
          this.isKeyActivity = res.data.isKeyActivity 
        }
        if(res.data.placementPosition ){
          this.placementPosition = res.data.placementPosition.split(",")
        }
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        //人群处理
        if (res.data.ruleDto.modelIds.indexOf(":") != -1) {
          const list = res.data.ruleDto.modelIds.split(":");
          const data = list[1].split("_");
          this.ruleForm.modelIds = list[0];
          if (list[0] == "v1_new_p" || list[0] == "v1_plus" || list[0] == "v1_new_fans") {
            this.ruleForm.vermicelliVal = [];
            this.ruleForm.starVal = [];
          }
          // 、、粉丝
          if (list[0] == "v1_no_f") {
            if (data.length == 4) {
              this.verCheckAll = true;
            }
            this.disableVF = false;
            this.ruleForm.vermicelliVal = data;
          }
          // 星极
          if (list[0] == "v1_customer") {
            if (data.length == 6) {
              this.starCheckAll = true;
            }
            this.disableCUS = false;
            this.ruleForm.starVal = data;
          }
        }

        // 礼包模板设置显示奖项 1 店铺积分  2 京豆  3  京券  4  东券")
        res.data.giftTemplatePrizeType = res.data.giftTemplatePrizeType ? res.data.giftTemplatePrizeType : ''
        const numGift1 = res.data.giftTemplatePrizeType.indexOf("1");
        const numGift2 = res.data.giftTemplatePrizeType.indexOf("2");
        const numGift3 = res.data.giftTemplatePrizeType.indexOf("3");
        const numGift4 = res.data.giftTemplatePrizeType.indexOf("4");
        // 礼包样式
        if (!this.isCopy) {
          this.libaoList.forEach((item) => {
            res.data.prizes.forEach((info) => {
              if (numGift1 != -1) {
                if (item.prizeType == "6") {
                  item.giftFalse = true;
                }
              }
              if (numGift2 != -1) {
                if (item.prizeType == "4") {
                  item.giftFalse = true;
                }
              }
              if (numGift3 != -1) {
                if (item.prizeType == "0") {
                  item.giftFalse = true;
                }
              }
              if (numGift4 != -1) {
                if (item.prizeType == "1") {
                  item.giftFalse = true;
                }
              }
              if ((item.prizeType == info.prizeType) && !this.isCopy) {
                if (info.prizeType == 6) {
                  item.priceName = "每份店铺积分：" + info.price;
                  item.singleAmount = info.price;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                }
                if (info.prizeType == 4) {
                  item.priceName = "每份京豆额：" + info.price;
                  item.singleAmount = info.price;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                }
                if (info.prizeType == 1) {
                  item.priceName = info.price + "优惠券";
                  item.singleAmount = 1;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                  if (this.isOld===0) { // 为新活动
                    item.price = info.price
                    item.quota = info.quota
                    item.singleAmount = info.singleAmount
                    item.title = info.title
                    item.totalAmount = info.totalAmount
                    item.bindType = info.bindType
                    item.skuIds = info.skuIds
                    item.validateDay = info.validateDay
                    item.giftFalse = true
                  }
                }
                if (info.prizeType == 0) {
                  item.priceName = info.price + "优惠券";
                  item.singleAmount = 1;
                  item.assetsId = info.assetsId;
                  item.backAction = true;
                }
              }
            });
          });
          console.log("修改或查看模式");
          //曝光商品集合
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.ruleForm.radio = res.data.isExposureItem;
          this.itemListFor = res.data.itemList;
          // if(!res.data.ruleDto.customPicUrl) {
          //   this.ruleForm.customPicUrl = res.data.giftTemplateUrl;
          // }
        }
        this.ruleForm.prizes = res.data.prizes;
        this.templateUrlimg = res.data.giftTemplateUrl;
        this.activityTimeChange();
        this.fromLoading = false;
        if (this.isCopy) {
          // this.ruleForm.isOutClose = false
        }
      });
    }
  },
  filters: {
    prizeType(num,type) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "13") {
        result = "令牌";
      } else if (num == "12") {
        result = type? "令牌" : "专享价";
      } else if (num == "13") {
        result = "令牌";
      } else if (num == "14") {
        result = "实物（随单发）";
      } 
      return result;
    },

  },
  mounted() {
    this.isStart = this.activityData.isStart ? true : false
    this.getLevel();
    this.$nextTick(() => {
      if (this.activityData.id != 13 && this.activityData.id != 14 && this.activityData.id != 1) {
        console.log('222------>', this.activityData)
        this.$refs.queryId && this.qrcodeAll(this.activityData.telCode,this.$refs.queryId);
        if (this.activityData.id == 1) {
          console.log('222------>', 222)
          this.$refs.queryId2 && this.qrcodeAll(this.activityData.telCode2, this.$refs.queryId2)
          this.$refs.queryId3 && this.qrcodeAll(this.activityData.telCode3, this.$refs.queryId3)
        }
      }
    });
    
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    this.colorShow2 = false
    this.colorData = this.ruleForm.rgb
    setTimeout(() => {
      this.colorShow2 = true
    }, 100)
  },
  data() {
    return {
      customerPaperwork: {},
      isKeyActivity: 0,
      placementPosition: [],
      fixedSendDateOptions: {
        disabledDate: (date)=>{
          const flag = this.itemArrDate.find(v=> v.fixedSendDate == this.moment(date).format('YYYY-MM-DD'))
          return flag;
        }
      },
      fixedDate: false,
      isShowTaskDialog: false,
      taskList: [],
      isSignInReissueEnabled: false, // 是否开启补签
      cusTemplateJSON:"",
      isForceRemind:false,

      actEndTime: "",
      isShowTip: false,
      showSelectProductAward: false,
      showSelectProductItem: false,
      msgOptions: [
        {
          label: "文本",
          value: 1
        },
        {
          label: "图片",
          value: 2
        }
      ],
      // 1.14迭代
      ruleDto:{
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },
      openClick:3,
      actMember: "1",
      isCopy: false,
      firstNum: '',
      uploadSize: true,
      sellerNick: "",
      templateId: "", // 模板id
      visibleUpload: false,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      temItem: {

        prizeType: '',
      },
      itemIndex: 0,
      echoDate: {},
      awardIndex: 0,
      awardSettingsLsit: [  // 奖品设置列表
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
      defaultAwardSettingsLsit: [  // 默认奖品设置列表 -> 复制清空奖项用
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
      giftPopup: false,
      giftPopupNum: 0,
      navList: [],
      tabActive: 0,
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          if(this.ruleForm.activityEndTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if(this.ruleForm.activityStartTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      templateUrlimg: "",
      templateUrlimg1: '',// 开卡礼包会员
      memberGiftTemplateId: '',//开卡礼包会员礼包id
      giftWuDisabled: false,
      giftYouDisabled: false,
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftID: "", // 礼包id
      giftList: [], // 礼包模板
      disableVF: true, // 人群禁用
      disableCUS: true, //  人群禁用
      dialogPrize: false, // 弹窗
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      // 礼包样式四个奖品
      libaoList: [
        {
          name: "店铺积分",
          priceName: "每份店铺积分：1",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6828.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu12.svg",
          singleAmount: "1",
          prizeType: "6", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: true,
          totalAmount: "1", //总共奖品数量
          giftFalse: false,
        },
        {
          name: "京豆",
          priceName: "每份京豆额：0",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6829.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu13.svg",
          singleAmount: "", //单份奖励数量 例如一次发放10个京豆就传10，一次发放一个6.66元的红包就传1
          prizeType: "4", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: false,
        },
        {
          name: "东券",
          priceName: "0元优惠券",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6826.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu14.svg",
          singleAmount: "1",
          prizeType: "1", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: false,
        },
        {
          name: "京券",
          priceName: "0元优惠券",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6827.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu15.svg",
          singleAmount: "1",
          prizeType: "0", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: false,
        },
      ],
      // 获取人群
      personLab: {
        customizeList: [],
        recommendList: [],
      },
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      // dialogPrize: true,
      levelList: [],
      disableTime: false,

      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",

        addressFillEndTime:"",
        predictSendTime:"",
        isFollowActivityEndTime:"",
        addressFillLimit:"",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return time.getTime(time) < new Date(this.ruleForm.activityStartTime).getTime();
            } else {
              return time.getTime(time) + day < new Date(this.ruleForm.activityStartTime).getTime();
            }
          } else { }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime();
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
          prizeType: null,
          price: '',
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
      itemArrDate: [
        {
          continueSignPoints: "",
          days: "",
          prizeType: null,
          price: '',
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
          fixedSendDate:""
        },
      ],
      itemArrOne: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      isShowFirst: false,
      clickActual: this.activityData.id == 6 ? true : false,
      clickActual1: false,
      activityStartTime: null,
      activityEndTime: null,
      ruleForm: {
        limitedTimeGrab:"",  //每日限时抢时间
        continueRuleType: 0,
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        condFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        inviteNum: "",
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: 0,
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是
        buttonText: "", //礼包确认按钮文案
        requestFollow: "1", // 是否需要关注店铺
        jumpLink: "", //跳转链接
        memberGiftJumpLink: "", //会员礼包跳转链接
        isMemberGiftCheck: false,
        isHavePrizes: "2",
        prizes: [], // 礼包样式  积分  京豆等等
        itemList: [], //曝光商品集合
        picUrl: "", // 活动背景图
        rgb: "#f5f7fa", // 活动背景色
        showPrize: 1, // 是否展示奖品
        showPrizeNum: 1, // 是否展示奖品剩余数量
        // showBatchAddCart: true, // 是否支持一键加购
        showBatchAddCart: 1, // 是否支持一键加购
        addCartNum: 1, // 加购方式(需要加购的商品数量)
        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片

        goShopSetting:0, //进店设置
        goShopAppId: '',//小程序appId
        goShopUrl: '',//小程序页面路径
        customPicUrl: "",//更换图片
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        openCardFollow: 0,
        isValidBlackList: 0
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
          price: '',
          title: '',
        },
      ],
      taskTableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
          price: '',
          title: '',
        },
      ],
      tableIndex: null,
      taskTableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        activityRulesText: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      templateJson: { templateUItype: '' },
      giftItem: {},
      navItem: {},
      // 颜色提取器
      colorShow: false,
      colorShow2: true,
      colors: {
        hex: '#F8E71C',
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
      },
      colorData: '#F8E71C',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
      ],
      // 曝光商品/加购商品最大商品数量
      numlimit: 20,
      templateInfoData: {},
      phoneShow: true,
      sharePic: "", // 默认分享图片
      isStart: false,
      selectPeopleShow: false, // 选择人群弹窗
      peopleSelected: [],
      peopleList: [],
      nonObj: {
        lastPayStartTime: '',
        lastPayEndTime: '',
        finishOrderType: 0,
        numStart: '',
        numEnd: '',
      },
      nonObjTime: [],
      nonPickerOption: {

      },
      isDraft:false,

      isSelectAddGood: false,
      selectedGoodList: [],
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
      isOld: false, // 是否是老活动
      informationList: [
        {name:"姓名",value: "姓名"},
        {name:"手机号码",value: "手机号码"},
        {name:"生日",value: "生日"},
        {name:"微信",value: "微信"},
        {name:"QQ",value: "QQ"},
        {name:"邮箱",value: "邮箱"},
        {name:"性别",value: "性别"},
        {name:"职业",value: "职业"},
        {name:"地区",value: "地区"},
        {name:"详细地址",value: "详细地址"},
      ]
    };
  },
  computed:{
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.isCopy
    },
    isCheckAllInformation: {
      get(){
        if(this.ruleForm.information.indexOf("-1") != -1 || this.ruleForm.information.length == this.informationList.length){
          return true
        } else {
          return false
        }
      },
      set(val) {
        if(val) {
          this.ruleForm.information = ["-1"]
        } else {
          this.ruleForm.information = []
        }
        console.log(this.ruleForm.information)
      }
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    isDisabled() {
      // 判断this.activityData对象是否有status和isStart属性
      let falg = false;
      if(this.activityData&&Object.keys(this.activityData).includes('status')){
        falg = true
      }
      if(this.activityData&&Object.keys(this.activityData).includes('isStart')) {
        falg = true
      }
      
      return falg&&!this.activityData.isCopy;
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          if (this.activityData.id == 13 || this.activityData.id == 14 || this.activityData.id == 1 || this.activityData.id == 34) {
            this.getCodeIMG();
          } else {
            this.$refs.queryId && this.qrcodeAll(this.activityData.telCode, this.$refs.queryId);
            if (this.activityData.id == 1) {
              this.$refs.queryId2 && this.qrcodeAll(this.activityData.telCode2, this.$refs.queryId2)
              this.$refs.queryId3 && this.qrcodeAll(this.activityData.telCode3, this.$refs.queryId3)
            }
          }
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    //每日签到奖品设置监听
    // awardSettingsLsit: {
    //   handler(newValue, oldValue) {
    //     if (this.localStepNum == 1) {
    //       if (newValue[0].prizeType != null) {
    //         this.ruleForm.prizeSet = true
    //       } else {
    //         this.ruleForm.prizeSet = false
    //       }
    //     }
    //   }, deep: true
    // },
    //连续签到奖品设置
    // itemArr: {
    //   handler(newValue, oldValue) {
    //     if (this.localStepNum == 1) {
    //       if (newValue[0].prizeType != null) {
    //         this.ruleForm.prizeSetOne = true
    //       } else {
    //         this.ruleForm.prizeSetOne = false
    //       }
    //     }
    //   }, deep: true
    // },

    'itemListFor': {
      handler(val) {
        if(val) {
          if(this.selectedGoodList.length) {
            let skuIds = val.map(item => item.skuId)
            this.selectedGoodList = this.selectedGoodList.filter(item => skuIds.includes(item.skuId))
          }
          console.log('val>>',val)
          console.log('selectedGoodList>>',this.selectedGoodList)
        }
      },
    }
  },
  methods: {
    lookDesignSpecifications(){
      this.$refs.activityPageSettings.lookDesignSpecifications()
    },
    addFixedDate() {
      // if(this.itemArrDate.length >= 20) {
      //   this.$message.warring("最多添加20个奖项");
      //   return;
      // }
      this.itemArrDate.push(
        {
          continueSignPoints: "",
          days: "",
          prizeType: null,
          price: '',
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
          fixedSendDate:""
        },
      )
    },
    fixedSendDateChange(val,row) {
      console.log(val);
      if(!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warring("请先完成活动时间");
        row.fixedSendDate = "";
        return;
      }
      if (
        this.moment(val + " 23:59:59").valueOf() <
          this.moment(this.ruleForm.activityStartTime).valueOf() ||
        this.moment(val + " 00:00:00").valueOf() >
          this.moment(this.ruleForm.activityEndTime).valueOf()
      ) {
        this.$message.warring("指定签到日期奖品只能在活动时间范围内");
        row.fixedSendDate = "";
      } else {
        
      }
    },
    heightNumberFind(){
      if(this.activityData.id == '3'){
        return 1400
      }else if(this.activityData.id == '4'){
        return 918
      }else if(this.activityData.id == '6'){
        return 3042
      }else if(this.activityData.id == '7'){
        return 269
      }
    },
    selectTemplate(index,id,items){
      this.colorShow = false
      // 加购有礼需要展示模板配置数据
      if (this.activityData.id == 34 && items.id) {
        // 背景图
        this.ruleForm.picUrl = items.url
        // 背景色
        this.ruleForm.rgb = items.rgb
        this.activityDataInfo = items
        // this.colors.a = 0;
        this.colorShow2 = false
        this.colors.hex = items.rgb; // 活动背景色
        this.templateInfoData = items
        this.colorData = items.rgb
        setTimeout(() => {
          // this.colors.a = 1;
          this.colorShow2 = true
        }, 100)
      }
      this.$emit('titopName', this.activityData.name, true)
      // 1 店铺积分  2 京豆  3  京券  4  东券
      this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
      this.giftPrizeType.forEach((info) => {
        this.libaoList.forEach((ele) => {
          if (info == 1) {
            if (ele.prizeType == "6") {
              ele.giftFalse = true;
            }
          }
          if (info == 2) {
            if (ele.prizeType == "4") {
              ele.giftFalse = true;
            }
          }
          if (info == 3) {
            if (ele.prizeType == "0") {
              ele.giftFalse = true;
            }
          }
          if (info == 4) {
            if (ele.prizeType == "1") {
              ele.giftFalse = true;
            }
          }
        });
      });
      this.temItem = items
      // 0 无奖项  1 有奖项
      if (items.giftPrizeType == 0) {
        this.ruleForm.isHavePrizes = "2";
        this.giftYouDisabled = true;
        //无奖项
        this.ruleForm.prizes = [];
        this.ruleForm.buttonText = "";
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            item.priceName = "每份店铺积分：0";
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
      } else {
        this.ruleForm.isHavePrizes = "1";
        this.giftWuDisabled = true;
        // 有奖项
        this.ruleForm.jumpLink = "";
        this.ruleForm.isMemberGiftCheck = false;
        this.ruleForm.memberGiftJumpLink = "";
        const num = this.giftPrizeType.indexOf("1");
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            if (num != -1) {
              item.backAction = true;
              item.totalAmount = 1;
              item.singleAmount = "1";
              item.priceName = "每份店铺积分：1";
            } else {
              item.priceName = "每份店铺积分：0";
            }
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
        if (num != -1) {
          this.ruleForm.prizes = [
            {
              price: 1,
              prizeType: 6,
              singleAmount: 1,
              totalAmount: this.ruleForm.sendCount,
              title: `1积分`,
            },
          ];
        }
      }
      this.templateId = id
    },
    changeInformation(e,value){
      if(e){
        this.ruleForm.information.push(value)
      } else{
        const index = this.informationList.findIndex(v=> v.value == value)
        this.ruleForm.information.splice(index,1)
      }
      if(this.ruleForm.information.length == this.informationList.length) {
        this.ruleForm.information = ["-1"]
      }
    },
    // 点击活动时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      if(toAddBelong == 'awardSettingsLsit' || toAddBelong == 'itemArr' || toAddBelong == 'itemArrDate'){
        this[toAddBelong][toAddIndex].totalAmount = num;
      }else {
        this[toAddBelong][toAddIndex].prizeCount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      if(arrStr == 'awardSettingsLsit' || arrStr == 'itemArr' || arrStr == 'itemArrDate'){
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].totalAmount
        };
      }else {
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].prizeCount
        };
      }
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = '';
      this.ruleForm.goShopUrl = '';
    },
    onAddGoodSelect(e) {
      this.selectedGoodList = e.list;
    },
    selectAddGoods() {
      if(!this.itemListFor.length) return this.$message.error('未添加加购商品，请先添加加购商品')
      this.isSelectAddGood = true;
    },
    handleSelect(val,index) {
      this.itemArrOne[index].informationmationOne = ""
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 打开选择人群
    openCrowd(){
      this.peopleList = this.peopleSelected.map(item => {
        return { id: item }
      })
      this.selectPeopleShow = true
      this.actMember = "3"
    },
    // 选择人群关闭
    selectPeopleSure(val){
      this.peopleSelected = val.map(item=>item.id)
      this.selectPeopleShow = false
    },
    // 京东计划数量计算
    prizeNum(row, type = 1) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (type == 1) {
          if (Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)) {
            row.totalAmount = ""
            if (row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
            if (row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
            if (row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
            if (row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
            if (row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
          }
        } else {
          if (Number(row.prizeCount) && (Number(row.prizeCount) > row.budgetRemain)) {
            row.prizeCount = ""
            if (row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
            if (row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
            if (row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
            if (row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
            if (row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
          }
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row, type = 1) {
      if (this.activityData.isStart) {
        if (type == 1) {
          if (row.totalAmount < row.minNum && row.minNum) {
            row.totalAmount = row.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        } else if (type == 2) {
          if (row.prizeCount < row.minNum && row.minNum) {
            row.prizeCount = row.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }
      }
    },
    indexMethod(index) {
      return "任务" + this.$toChinesNum(index + 1);
    },

    inviteNumBlur() {
      if (this.ruleForm.inviteNum >= this.ruleForm.peopleCount && this.ruleForm.peopleCount && this.ruleForm.inviteNum) {
        this.ruleForm.inviteNum = ""
        this.$message.warning("活动最多邀请人数需大于固定邀请人数")
      }
    },

    peopleCountBlur() {
      if (this.ruleForm.inviteNum >= this.ruleForm.peopleCount && this.ruleForm.inviteNum && this.ruleForm.peopleCount) {
        this.ruleForm.peopleCount = ""
        this.$message.warning("活动最多邀请人数需大于固定邀请人数")
      }
    },

    //上传图片前校验
    beforeUpload(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 750 && image.height == 574)
        file.isFlag = valid
        _this.uploadSize = valid
        if (valid) {
        } else {
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    //更换图片前校验
    beforeUploadUrl(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 630 && image.height == 788)
        file.isFlag = valid
        _this.uploadSize = valid
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      const isLt1M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg",".jpeg",".gif"]
      if (!isLt1M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 更换图片成功
    handleUploadUrl(res){
      if(res.code != 1){
        this.$message.error(res.message);
      }else{
        if(this.uploadSize){
          this.ruleForm.customPicUrl = res.data;
        }
      }
    },
    // 重置图片
    resetUrl() {
      this.ruleForm.customPicUrl = this.templateUrlimg
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        if (valid) {
        } else {
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功
    handleUpload(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.ruleForm.picUrl = res.data;
        }
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
        }
      }
    },
    // 重置背景图
    picUrlReset() {
      if (this.activityData.isStart) return
      this.ruleForm.picUrl = this.activityDataInfo.url
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      if (this.activityData.isStart) return
      this.ruleForm.sharePic = this.sharePic
    },
    // 重置背景色
    rgbReset() {
      if (this.activityDataInfo.rgb) {
        this.ruleForm.rgb = this.activityDataInfo.rgb
        this.colorData = this.activityDataInfo.rgb
      } else {
        this.ruleForm.rgb = this.templateInfoData.rgb
        this.colorData = this.templateInfoData.rgb
      }

    },
    // 打开颜色选择器
    showColorPicker() {
      this.colorShow = !this.colorShow
    },
    // 修改颜色
    handleChangeColor(val) {
      this.ruleForm.rgb = val
      this.colorData = val
      // this.ruleForm.rgb = val.hex
      // this.ruleForm.rgb = `rgba{${val.rgba.r},${val.rgba.g},${val.rgba.b}}`
    },
    changeColor(val) {
      if (val == null) {
        this.ruleForm.rgb = null
      }
    },
    //添加商品弹窗
    addGoods() {
      this.selectGoodsState = true;
      this.numlimit = 50
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    // 修改加购计数器
    handleAddNum(newVal, oldVal) {
      if (this.selectGoodsArr.length == 0) {
        if (newVal == 1) return
        this.$message.info("请先选择商品")
        // 需要使用$nextTick在dom更新后赋值，否则会使change失效
        this.$nextTick(() => {
          this.ruleForm.addCartNum = oldVal
        })
        return
      }
      if (newVal > this.selectGoodsArr.length) {
        this.$nextTick(() => {
          this.ruleForm.addCartNum = oldVal
        })
        this.$message.info("用户加购商品不得多于已设置加购商品数量！")
      }

    },
    handleCheckputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "1") {
          if (e.target.value > 9) {
            e.target.value = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e.target.value > 1) {
            e.target.value = "";
          }
        }
        if (num == "5") {
          if (e.target.value < 2 || e.target.value > 5) {
            e.target.value = "";
          }
        }
      } else {
        if (num.quantityTotal && num.price && num.totalAmount && num.prizeType == 2) {
          let numTotal = this.$jingdouTotal({ ...num, prizeCount: num.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    handleCheckputn1(e, num = "-1", type = "nojingdou") {
    },
    // 自定义保存
    handleSave(obj) {
      giftBagTemplate({ ...obj, templateDirId: this.navItem.id }).then((res) => {
        if (res.code == 1) {
          this.visibleUpload = false;
          this.handleGiftBag();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleDel(item) {
      this.giftItem = item;
      this.$confirm("是否删除此模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleDeleteTable();
      })
    },
    handleDeleteTable() {
      templateDelete(this.giftItem.id).then((res) => {
        if (res.code == 1) {
          this.handleGiftBag();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    selectItemArr(index, item) {
      if (this.isStart) return;
      this.JingdouCount.prizeCount = item.totalAmount || 0;
      this.itemIndex = index;
      this.echoDate = item;
      this.showSelectProductItem = true
      this.$nextTick(()=>{
        this.$refs.selectProductItem.openDialog();
      })
    },
    getTheDataItem2(data, prizeType) {
      const itemArr = this.itemArrDate;
      if (prizeType == 1) {
        itemArr[this.itemIndex].couponType = data.couponType;
        itemArr[this.itemIndex].singleAmount = 1;
        itemArr[this.itemIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.itemArr[this.itemIndex].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        itemArr[this.itemIndex].addressFillEndTime = data.addressFillEndTime
        itemArr[this.itemIndex].predictSendTime = data.predictSendTime
        itemArr[this.itemIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
        itemArr[this.itemIndex].shouldCollectExtraData = data.shouldCollectExtraData
        itemArr[this.itemIndex].extraQuestion = data.extraQuestion
        itemArr[this.itemIndex].addressFillLimit = data.addressFillLimit
        itemArr[this.itemIndex].commitAddressLimit = data.commitAddressLimit
        if(!data.isGoodManage) {
          itemArr[this.itemIndex].skuId = data.skuId;
          delete itemArr[this.itemIndex].isGoodManage
        } else {
          itemArr[this.itemIndex].isGoodManage = data.isGoodManage;
        }
      }
      if (data.giftType) {
        itemArr[this.itemIndex].giftType = Number(data.giftType);
      }
      itemArr[this.itemIndex].price = data.discount || data.singleAmount;
      itemArr[this.itemIndex].assetsId = Number(data.couponId || data.skuId);
      itemArr[this.itemIndex].logo = data.logo;
      itemArr[this.itemIndex].prizeType = prizeType;
      if (prizeType == 4) {
        itemArr[this.itemIndex].title = data.discount + "店铺积分";
      } else {
        if (data.name) itemArr[this.itemIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        itemArr[this.itemIndex].singleAmount = data.singleAmount;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(itemArr[this.itemIndex],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        itemArr[this.itemIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        itemArr[this.itemIndex].budgetRemain = data.budgetRemain;
      }
      this.showSelectProductItem = false
    },
    getTheDataItem(data, prizeType) {
      if(this.echoDate.fixedSendDate != undefined) {
        this.getTheDataItem2(data,prizeType)
        return;
      }
      if (prizeType == 1) {
        this.itemArr[this.itemIndex].couponType = data.couponType;
        this.itemArr[this.itemIndex].singleAmount = 1;
        this.itemArr[this.itemIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.itemArr[this.itemIndex].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        this.itemArr[this.itemIndex].addressFillEndTime = data.addressFillEndTime
        this.itemArr[this.itemIndex].predictSendTime = data.predictSendTime
        this.itemArr[this.itemIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
        this.itemArr[this.itemIndex].shouldCollectExtraData = data.shouldCollectExtraData
        this.itemArr[this.itemIndex].extraQuestion = data.extraQuestion
        this.itemArr[this.itemIndex].addressFillLimit = data.addressFillLimit
        this.itemArr[this.itemIndex].commitAddressLimit = data.commitAddressLimit
        if(!data.isGoodManage) {
          this.itemArr[this.itemIndex].skuId = data.skuId;
          delete this.itemArr[this.itemIndex].isGoodManage
        } else {
          this.itemArr[this.itemIndex].isGoodManage = data.isGoodManage;
        }
      }
      if (data.giftType) {
        this.itemArr[this.itemIndex].giftType = Number(data.giftType);
      }
      this.itemArr[this.itemIndex].price = data.discount || data.singleAmount;

      this.itemArr[this.itemIndex].assetsId = Number(data.couponId || data.skuId);
      this.itemArr[this.itemIndex].logo = data.logo;
      this.itemArr[this.itemIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.itemArr[this.itemIndex].title = data.discount + "店铺积分";
      } else {
        if (data.name) this.itemArr[this.itemIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.itemArr[this.itemIndex].singleAmount = data.singleAmount;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.itemArr[this.itemIndex],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.itemArr[this.itemIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.itemArr[this.itemIndex].budgetRemain = data.budgetRemain;
      }
      this.showSelectProductItem = false
    },
    // 红包雨  弹框
    getTheDataAward(data, prizeType) {
      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
        this.awardSettingsLsit[this.awardIndex].assetsId = data.assetsId;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        this.awardSettingsLsit[this.awardIndex].addressFillEndTime = data.addressFillEndTime
        this.awardSettingsLsit[this.awardIndex].predictSendTime = data.predictSendTime
        this.awardSettingsLsit[this.awardIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
        this.awardSettingsLsit[this.awardIndex].shouldCollectExtraData = data.shouldCollectExtraData
        this.awardSettingsLsit[this.awardIndex].extraQuestion = data.extraQuestion
        this.awardSettingsLsit[this.awardIndex].addressFillLimit = data.addressFillLimit
        this.awardSettingsLsit[this.awardIndex].commitAddressLimit = data.commitAddressLimit
        if(!data.isGoodManage) {
          this.awardSettingsLsit[this.awardIndex].skuId = data.skuId;
          delete this.awardSettingsLsit[this.awardIndex].isGoodManage
        } else {
          this.awardSettingsLsit[this.awardIndex].isGoodManage = data.isGoodManage;
        }
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(data.giftType);
      }
      this.awardSettingsLsit[this.awardIndex].price = data.discount || data.singleAmount;
      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId || data.skuId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      // if (prizeType == 3) {
      //   if(!data.isGoodManage) {
      //     this.awardSettingsLsit[this.awardIndex].skuId = data.skuId;
      //   } else {
      //     this.awardSettingsLsit[this.awardIndex].isGoodManage = data.isGoodManage;
      //   }
      // }
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title = data.discount + "店铺积分";
      } else {
        if (data.name) this.awardSettingsLsit[this.awardIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount = data.singleAmount;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.awardSettingsLsit[this.awardIndex],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain = data.budgetRemain;
      }
      this.showSelectProductAward = false

    },
    // 红包雨
    selectPacket(index, item) {
      if (this.isStart) return;
      // this.itemArr = []
      this.showSelectProductAward = true
      this.$nextTick(()=>{
        this.$refs.selectProductAward.openDialog();
      })
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.echoDate = item;
    },
    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      if (this.activityData.id == 1 || this.activityData.id == 34) {
        this.getPolite()
      } else {
        this.handleGiftBag()
      }
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.pageData.size = val;
      this.handleGiftBag();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      this.handleGiftBag();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      if(!this.templateId&&this.activityData.id!=13&&this.activityData.id!=14){
        this.selectTemplate(0,this.giftList[0].id,this.giftList[0])
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    // 礼包模板
    async handleGiftBag() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        dirId: this.navItem.id,
        giftType: this.activityData.id == 13 ? 0 : 1,
      };
      // 开卡礼包版本
      const { data } = await getGiftBagTemplate(params);
      this.giftList = data.records.map((item) => ({
        ...item,
        days: item.expirationType == 1 ? this.getDaysBetween(item.expirationStartDate, item.expirationEndDate) : "",
      }));
      // if (this.activityData.id == 13) {
      //   this.giftList = giftList.filter((i) => i.giftType == 0);
      // }
      // if (this.activityData.id == 14) {
      //   this.giftList = giftList.filter((i) => i.giftType == 1);
      // }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    addPrizeRule() {
      if (this.ruleForm.isCumulativePrize == 1) {
        this.tableData.push({
          peopleCount: "",
          prizeType: "",
          value: "",
          prizeCount: "",
          title: ''
        });
      } else {
        this.taskTableData.push({
          peopleCount: "",
          prizeType: "",
          value: "",
          prizeCount: "",
          title: ''
        });
      }
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = this.activityData.id == 6 ? true : false
      this.clickActual1 = false
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => { });
    },
    // 二维码地址
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = this.activityData.id == 14 ? "http://yq-hd-rc.isvjcloud.com/shop.html" : "http://index.yeionsms.com/yidongd/index.html"
      const arr = [1, 8, 16, 17, 18, 19, 27, 28, 34]
      if (arr.includes(Number(this.activityData.id))) {
        url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      }
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        if (this.activityData.id == 34) {
          new QRCode(element, {
            width: 140, // 设置宽度，单位像素
            height: 140, // 设置高度，单位像素
            // 设置二维码内容或跳转地址
            text: `${url}${this.giftList[index].imageUrl}`
          });
        } else {
          new QRCode(element, {
            width: 140, // 设置宽度，单位像素
            height: 140, // 设置高度，单位像素
            // 设置二维码内容或跳转地址
            text: this.activityData.id == 13 ? `${url}?image=${this.giftList[index].templateUrl}` : arr.includes(Number(this.activityData.id)) ?
              `${url}${this.giftList[index].secondImageUrl}` :
              `${url}?image=${this.giftList[index].templateExampleUrl}`
          });
        }
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      console.log('val------>', val)
      console.log('queryId------>', queryId)
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e, data = '', type = 'nojingdou') {

      if (type == 'nojingdou') {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        let row = {
          prizeCount: data,
          price: this.prizeSettingList.price,
          quantityTotal: this.prizeSettingList.quantityTotal,
        }
        if (row.quantityTotal && row.price && row.prizeCount) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            return this.$message.warning("京豆奖品份数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.prizeCount;
        }
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //选择商品数据
    getTheData(data, prizeType) {
      this.showDialog = false;

      // v3.4邀请开卡
      /**
       * @param singleAmount 积分数，京豆数  其余奖项为1
       */
      if (this.activityData.name == "邀请关注有礼") {
        // 梯度奖励
        if (this.ruleForm.isCumulativePrize == 1) {
          if (prizeType == 1) {
            this.tableData[this.tableIndex].couponType = data.couponType;
            this.tableData[this.tableIndex].singleAmount = 1;
            this.tableData[this.tableIndex].quota = data.quota;
            this.tableData[this.tableIndex].prizeGoShop = data.prizeGoShop
          }
          if (prizeType == 2) {
            this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
          }
          if (prizeType == 3) {
            this.tableData[this.tableIndex].addressFillEndTime = data.addressFillEndTime
            this.tableData[this.tableIndex].predictSendTime = data.predictSendTime
            this.tableData[this.tableIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
            this.tableData[this.tableIndex].shouldCollectExtraData = data.shouldCollectExtraData;
            this.tableData[this.tableIndex].extraQuestion = data.extraQuestion;
            this.tableData[this.tableIndex].addressFillLimit = data.addressFillLimit
            this.tableData[this.tableIndex].commitAddressLimit = data.commitAddressLimit
            if(!data.isGoodManage) {
              this.tableData[this.tableIndex].skuId = data.skuId;
              delete this.tableData[this.tableIndex].isGoodManage
            } else {
              this.tableData[this.tableIndex].isGoodManage = data.isGoodManage;
            }
          }
          if (data.giftType) {
            this.tableData[this.tableIndex].giftType = Number(data.giftType);
          }
          this.tableData[this.tableIndex].price = data.discount || data.singleAmount;

          this.tableData[this.tableIndex].assetsId = Number(data.couponId || data.skuId);
          this.tableData[this.tableIndex].logo = data.logo;
          this.tableData[this.tableIndex].prizeType = prizeType;
          if (prizeType == 4) {
            this.tableData[this.tableIndex].title = data.discount + "店铺积分";
          } else {
            if (data.name) this.tableData[this.tableIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
          }
          if (data.singleAmount) {
            this.tableData[this.tableIndex].singleAmount = data.singleAmount;
          }
          // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
          if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
            this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
          }
          if(prizeType==3&&data.isGoodManage) {
            this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
          }
        } else if (this.ruleForm.isCumulativePrize == 2) {
          if (prizeType == 1) {
            this.taskTableData[this.taskTableIndex].couponType = data.couponType;
            this.taskTableData[this.taskTableIndex].singleAmount = 1;
            this.taskTableData[this.taskTableIndex].quota = data.quota;
            this.taskTableData[this.tableIndex].prizeGoShop = data.prizeGoShop
          }
          if (prizeType == 2) {
            this.taskTableData[this.taskTableIndex].quantityTotal = data.quantityTotal;
          }
          if (prizeType == 3) {
            this.taskTableData[this.taskTableIndex].addressFillEndTime = data.addressFillEndTime
            this.taskTableData[this.taskTableIndex].predictSendTime = data.predictSendTime
            this.taskTableData[this.taskTableIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
            this.taskTableData[this.taskTableIndex].shouldCollectExtraData = data.shouldCollectExtraData;
            this.taskTableData[this.taskTableIndex].extraQuestion = data.extraQuestion;
            this.taskTableData[this.taskTableIndex].addressFillLimit = data.addressFillLimit
            this.taskTableData[this.taskTableIndex].commitAddressLimit = data.commitAddressLimit
            if(!data.isGoodManage) {
              this.taskTableData[this.taskTableIndex].skuId = data.skuId;
              delete this.taskTableData[this.taskTableIndex].isGoodManage
            } else {
              this.taskTableData[this.taskTableIndex].isGoodManage = data.isGoodManage;
            }
          }
          if (data.giftType) {
            this.taskTableData[this.taskTableIndex].giftType = Number(data.giftType);
          }
          this.taskTableData[this.taskTableIndex].price = data.discount || data.singleAmount;

          this.taskTableData[this.taskTableIndex].assetsId = Number(data.couponId || data.skuId);
          this.taskTableData[this.taskTableIndex].logo = data.logo;
          this.taskTableData[this.taskTableIndex].prizeType = prizeType;
          if (prizeType == 4) {
            this.taskTableData[this.taskTableIndex].title = data.discount + "店铺积分";
          } else {
            if (data.name) this.taskTableData[this.taskTableIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
          }
          if (data.singleAmount) {
            this.taskTableData[this.taskTableIndex].singleAmount = data.singleAmount;
          }
          // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
          if ([2,5, 6, 7, 8,10].includes(Number(prizeType))) {
            this.taskTableData[this.taskTableIndex].budgetRemain = data.budgetRemain;
          }
          if(prizeType==3&&data.isGoodManage) {
            this.taskTableData[this.taskTableIndex].budgetRemain = data.budgetRemain;
          }
        }
      } else if (this.ruleForm.isCumulativePrize == 2) {
        this.prizeSettingList.price = Number(data.discount);
        if (prizeType == 4) {
          this.prizeSettingList.title = data.discount + "店铺积分";
          this.prizeSettingList.discount = data.discount;
        } else if (prizeType == 3) {
            this.prizeSettingList.addressFillEndTime = data.addressFillEndTime
            this.prizeSettingList.predictSendTime = data.predictSendTime
            this.prizeSettingList.isFollowActivityEndTime = data.isFollowActivityEndTime
            this.prizeSettingList.shouldCollectExtraData = data.shouldCollectExtraData;
            this.prizeSettingList.extraQuestion = data.extraQuestion;
            this.prizeSettingList.addressFillLimit = data.addressFillLimit
            this.prizeSettingList.commitAddressLimit = data.commitAddressLimit
            if(!data.isGoodManage) {
              delete prizeSettingList.isGoodManage
            } else {
              this.prizeSettingList.isGoodManage = data.isGoodManage;
            }
          }else if (prizeType == 1) {
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = data.name;
          this.prizeSettingList.prizeGoShop = data.prizeGoShop
        } else {
          this.prizeSettingList.title = data.name;
        }
        if (prizeType == 2) {
          this.prizeSettingList.quantityTotal = data.quantityTotal;
        }
        this.prizeSettingList.assetsId = Number(data.couponId || data.skuId);
        this.prizeSettingList.prizeType = prizeType;
        this.prizeSettingList.logo = data.logo;
        // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
        if ([2, 5, 6, 7, 8,10].includes(Number(prizeType))) {
          this.prizeSettingList.budgetRemain = data.budgetRemain;
        }
        if(prizeType==3&&data.isGoodManage) {
            this.prizeSettingList.budgetRemain = data.budgetRemain;
          }
      }
    },
    //模板下一步
    nextStep(uitype, templateId = 0) {
      console.log("选择模板，下一步", this.activityData);
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit('titopName', this.activityData.name, true)
      this.templateJson.templateUItype = uitype
      if (templateId) {
        this.templateId = templateId
      }
    },
    //开卡礼包
    async nextStepKai(items, type = '1') {
      this.colorShow = false
      // 加购有礼需要展示模板配置数据
      if (this.activityData.id == 34 && items.id) {
        // 背景图
        this.ruleForm.picUrl = items.url
        // 背景色
        this.ruleForm.rgb = items.rgb
        this.activityDataInfo = items
        // this.colors.a = 0;
        this.colorShow2 = false
        this.colors.hex = items.rgb; // 活动背景色
        this.templateInfoData = items
        this.colorData = items.rgb
        setTimeout(() => {
          // this.colors.a = 1;
          this.colorShow2 = true
        }, 100)
      }
      
      // if ((this.activityData.id == 14 || this.activityData.id == 15)&&type==1) {
      //   const res = await getValidActivity()
      //   if (res.data) {
      //     const message = '当前正在进行【' + res.data[0].activityName + '】活动' + res.data[0].activityStartTime + '~' + res.data[0].activityEndTime + '，必须结束后才能新建！'
      //     this.$message.warning(message)
      //     return
      //   }
      // }
      if(type==1) {
        // 进来  会员和非会员 默认为同一模板认
        this.giftID = items.id;
        this.memberGiftTemplateId = items.id;
        this.ruleForm.customPicUrl = items.templateUrl;
        this.templateUrlimg = items.templateUrl;
        this.templateUrlimg1 = items.templateUrl
      }
      this.localStep = 1;
      this.$emit('titopName', this.activityData.name, true)
      // 1 店铺积分  2 京豆  3  京券  4  东券
      this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
      this.giftPrizeType.forEach((info) => {
        this.libaoList.forEach((ele) => {
          if (info == 1) {
            if (ele.prizeType == "6") {
              ele.giftFalse = true;
            }
          }
          if (info == 2) {
            if (ele.prizeType == "4") {
              ele.giftFalse = true;
            }
          }
          if (info == 3) {
            if (ele.prizeType == "0") {
              ele.giftFalse = true;
            }
          }
          if (info == 4) {
            if (ele.prizeType == "1") {
              ele.giftFalse = true;
            }
          }
        });
      });
      console.log("1111111111111111111");
      console.log("--- this.libaoList:---", this.libaoList)
      this.temItem = items
      // 0 无奖项  1 有奖项
      if (items.giftPrizeType == 0) {
        this.ruleForm.isHavePrizes = "2";
        this.giftYouDisabled = true;
        //无奖项
        this.ruleForm.prizes = [];
        this.ruleForm.buttonText = "";
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            item.priceName = "每份店铺积分：0";
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
      } else {
        this.ruleForm.isHavePrizes = "1";
        this.giftWuDisabled = true;
        // 有奖项
        this.ruleForm.jumpLink = "";
        this.ruleForm.isMemberGiftCheck = false;
        this.ruleForm.memberGiftJumpLink = "";
        const num = this.giftPrizeType.indexOf("1");
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            if (num != -1) {
              item.backAction = true;
              item.totalAmount = 1;
              item.singleAmount = "1";
              item.priceName = "每份店铺积分：1";
            } else {
              item.priceName = "每份店铺积分：0";
            }
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
        if (num != -1) {
          this.ruleForm.prizes = [
            {
              price: 1,
              prizeType: 6,
              singleAmount: 1,
              totalAmount: this.ruleForm.sendCount,
              title: `1积分`,
            },
          ];
        }
      }
    },
    async nextStepKai1(items, type = '1') {
      if (type == '1') {
        this.giftID = items.id;
        this.memberGiftTemplateId = items.id;
        this.templateUrlimg = items.templateUrl;
        this.templateUrlimg1 = items.templateUrl
        this.localStep = 1;
        this.$emit('titopName', this.activityData.name, true)
      }

      // 1 店铺积分  2 京豆  3  京券  4  东券
      this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
      this.giftPrizeType.forEach((info) => {
        this.libaoList.forEach((ele) => {
          if (info == 1) {
            if (ele.prizeType == "6") {
              ele.giftFalse = true;
            }
          }
          if (info == 2) {
            if (ele.prizeType == "4") {
              ele.giftFalse = true;
            }
          }
          if (info == 3) {
            if (ele.prizeType == "0") {
              ele.giftFalse = true;
            }
          }
          if (info == 4) {
            if (ele.prizeType == "1") {
              ele.giftFalse = true;
            }
          }
        });
      });
      this.temItem = items
      // 0 无奖项  1 有奖项
      if (items.giftPrizeType == 0) {
        this.ruleForm.isHavePrizes = "2";
        this.giftYouDisabled = true;
        //无奖项
        this.ruleForm.prizes = [];
        this.ruleForm.buttonText = "";
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            item.priceName = "每份店铺积分：0";
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
      } else {
        this.ruleForm.isHavePrizes = "1";
        this.giftWuDisabled = true;
        // 有奖项
        this.ruleForm.jumpLink = "";
        this.ruleForm.isMemberGiftCheck = false;
        this.ruleForm.memberGiftJumpLink = "";
        const num = this.giftPrizeType.indexOf("1");
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            if (num != -1) {
              item.backAction = true;
              item.totalAmount = 1;
              item.singleAmount = "1";
              item.priceName = "每份店铺积分：1";
            } else {
              item.priceName = "每份店铺积分：0";
            }
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
        if (num != -1) {
          this.ruleForm.prizes = [
            {
              price: 1,
              prizeType: 6,
              singleAmount: 1,
              totalAmount: this.ruleForm.sendCount,
              title: `1积分`,
            },
          ];
        }
      }
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      //签到赢好礼
      let everyDay = {
        activityName: this.ruleForm.activityName, //活动名称
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级
        condFollow: this.ruleForm.condFollow == true ? 1 : 0, //参与条件
        startTime: this.ruleForm.startTime || this.ruleForm.activityStartTime, //活动结束时间
        endTime: this.ruleForm.endTime || this.ruleForm.activityEndTime, //活动结束时间
        isExposureItem: this.ruleForm.exposureSwitch == false ? 0 : 1, //是否曝光商品：0否,1是
        itemList: this.itemListFor, //曝光商品集合
        points: Number(this.ruleForm.inputprize), //单次奖励积分bonusPoints
        priceType: this.ruleForm.radio, //曝光商品价格显示：0显示京东价，1显示促销价
        pointActivityPrizeDTO: {
          //选择奖品数据
          price: this.prizeSettingList.price,
          title: this.prizeSettingList.title,
          assetsId: this.prizeSettingList.skuId ? this.prizeSettingList.skuId : this.prizeSettingList.assetsId,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          couponType: this.prizeSettingList.couponType,
          skuId: this.prizeSettingList.skuId,

          addressFillEndTime:this.prizeSettingList.addressFillEndTime,
          predictSendTime:this.prizeSettingList.predictSendTime,
          isFollowActivityEndTime:this.prizeSettingList.isFollowActivityEndTime,
          shouldCollectExtraData: this.prizeSettingList.shouldCollectExtraData,
          extraQuestion: this.prizeSettingList.extraQuestion,
          addressFillLimit:this.prizeSettingList.addressFillLimit,
        },
        ruleDTO: {
          // 1.14迭代 这里提交
          cusTemplateJSON:this.cusTemplateJSON,
          isForceRemind:this.isForceRemind,
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
          openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
          openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
          openCardBeforeDay:this.ruleForm.openCardBeforeDay,
          plusObject:this.ruleDto.plusObject,
          //规则拓展信息(没有选择奖品的不传，不然后端校验不通过)
          continueRule: this.itemArr.filter(v=> v.prizeType).map(item => {
            return {
              continueSignPoints: 0,
              days: item.days,
              prizeDTO: {
                ...item,
                assetsId: item.skuId ? item.skuId : item.assetsId,
              }
            }
          }),
          requestFollow: this.ruleForm.condFollow, //是否关注
          openCardFollow: this.ruleForm.openCardFollow, //开卡
          startTime: this.ruleForm.limitedTimeGrab,
          prizeCount: Number(this.ruleForm.prizeCount),
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          customPicUrl: this.ruleForm.customPicUrl,
          isSignInReissueEnabled: this.isSignInReissueEnabled, // 是否开启补卡任务
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        },
        ruleDescription: this.ruleForm.activityRulesText, //规则拓展信息
        startTime: this.ruleForm.activityStartTime, //活动开始时间
        templateJson: this.templateJson,
        templateId: this.templateId ? this.templateId : this.giftID,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
        studentStatus: this.ruleForm.studentStatus,
      };
      if(this.isSignInReissueEnabled) {
        everyDay.ruleDTO.taskList = this.taskList;
        everyDay.taskList = this.taskList;
      } else {
        everyDay.ruleDTO.taskList = [];
        everyDay.taskList = [];
      }
      if(this.fixedDate) {
        everyDay.pointActivityPrizeDTOList = JSON.parse(JSON.stringify(this.itemArrDate))
      }
      if(this.actMember == 1){
        everyDay.allowLevel = "-1"
      }else if(this.actMember == 3){
        everyDay.allowLevel = "99"
        everyDay.crowdIds = this.peopleSelected.join(",")
      } else if(this.actMember == 4){
        everyDay.allowLevel = "100"
      } else if(this.actMember == 2){
        everyDay.allowLevel = this.ruleForm.partner.join(",");
        if (everyDay.allowLevel == '-1') {
          //会员等级设置
          let list = ['-1','0']
          this.levelList.forEach((item,index) => {
            let num = index + 1
            list.push(num)
          })
          everyDay.allowLevel = list.join(",")
        }
      }
      // 复制-重新选择模板
      if (this.isCopy) {
        everyDay.templateJson = {}
      }
      if ((this.localStepNum == 1 || this.activityData.id == 1 || sessionStorage.getItem('num') == 1) && this.ruleForm.prizeSet == false) {
        everyDay.pointActivityPrizeDTO = ''
      }
      if ((this.localStepNum == 1 || this.activityData.id == 1 || sessionStorage.getItem('num') == 1) && this.ruleForm.prizeSetOne == false) {
        everyDay.ruleDTO.continueRule = []
      }
      
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.startTime || this.ruleForm.activityStartTime,
        endTime: this.ruleForm.endTime || this.ruleForm.activityEndTime,
        activityType: this.activityData.id, //活动类型  13: 开卡礼包 14: 店铺礼包
        giftTemplateId: this.giftID, //礼包模板id
        isExposureItem: this.ruleForm.radio, //是否添加曝光商品 0 否 1 是
        ruleDTO: {
          // 1.14迭代 这里提交
          firstOpenCardTimeType:this.actMember==2?this.ruleForm.firstOpenCardTimeType:0,
          openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
          openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
          openCardBeforeDay:this.ruleForm.openCardBeforeDay,
          plusObject:this.ruleDto.plusObject,
          cusTemplateJSON:this.cusTemplateJSON,
          isForceRemind:this.isForceRemind,

          requestFollow: this.ruleForm.requestFollow == 1 ? true : false, //是否需要关注店铺
          openCardFollow: this.ruleForm.openCardFollow, //参与条件:开卡
          buttonText: this.ruleForm.buttonText,
          isOutClose: this.ruleForm.isOutClose == 1 ? true : false, //勾选奖品发完是否自动结束活动
          isHavePrizes: this.ruleForm.isHavePrizes == 1 ? true : false, //是否有奖项
          sendCount: this.ruleForm.sendCount,
          jumpLink: this.ruleForm.jumpLink,
          isMemberGiftCheck: this.ruleForm.isMemberGiftCheck,
          memberGiftJumpLink: this.ruleForm.memberGiftJumpLink,
          modelIds: this.ruleForm.modelIds, //人群
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        }, //活动名称
        prizes: this.ruleForm.prizes,
        itemList: this.itemListFor, //曝光商品集合
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
        studentStatus: this.ruleForm.studentStatus,
      };
      if (this.ruleForm.isHavePrizes == "2") {
        cardParams.memberGiftTemplateId = this.memberGiftTemplateId;
      }
      //人群处理
      if (this.activityData.id == 13 || this.activityData.id == 14) {
        if (this.ruleForm.modelIds == this.personLab.customizeList[1].labelId || this.ruleForm.modelIds == this.personLab.recommendList[3].labelId) {
          const str1 = this.ruleForm.vermicelliVal.join("_");
          const str2 = this.ruleForm.starVal.join("_");
          if ((this.ruleForm.modelIds == "v1_no_f" && !str1) || (this.ruleForm.modelIds == "v1_customer" && !str2)) {
            return this.$message.warning("请选择目标人群");
          }
          if (str1) {
            cardParams.ruleDTO.modelIds = `${this.ruleForm.modelIds}:${str1}`;
          }
          if (str2) {
            cardParams.ruleDTO.modelIds = `${this.ruleForm.modelIds}:${str2}`;
          }
        }
        if (this.ruleForm.modelIds == "v1_new_p" || this.ruleForm.modelIds == "v1_plus" || this.ruleForm.modelIds == "v1_new_fans") {
          cardParams.ruleDTO.modelIds = `${this.ruleForm.modelIds}:0`;
        }
      }
      if(this.ruleForm.prizeSetOne) {
        everyDay.ruleDTO.continueRuleType = this.ruleForm.continueRuleType
      }
      // v1.18迭代
      if(this.activityData.id == 14) {
        cardParams.ruleDTO.customPicUrl = this.ruleForm.customPicUrl
      }

      //编辑回显
      this.momentValue = everyDay;
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        everyDay.itemList = b;
      }
      
      if(!this.isDraft){
        //活动名称的限制
        if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }
        if(this.actMember == 3 && !this.peopleSelected.length){
          this.$message.warning("请选择指定人群");
          return;
        }
        // 1.14迭代 这里判断
        if(this.actMember == '2'){
          if(this.ruleForm.firstOpenCardTimeType==1&&!this.ruleForm.openCardBeforeDay){
            return this.$message.warning("请完善首次入会时间");
          }
          if(this.ruleForm.firstOpenCardTimeType==2&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
            return this.$message.warning("请完善首次入会时间");
          }
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return
        }
        if (this.activityData.id == 13 || this.activityData.id == 14) {
          //选择目标人群
          if (!this.ruleForm.modelIds) {
            this.$message.warning("请选择目标人群");
            return;
          }
          //发送人数
          if (!this.ruleForm.sendCount) {
            this.$message.warning("请输入发送人数");
            return;
          }
          // 礼包样式:
          if (this.ruleForm.isHavePrizes == "1") {
            if (this.ruleForm.prizes.length == 0) {
              this.$message.warning("请输入选择礼包样式");
              return;
            }else{ //不为空的时候 如果勾选了店铺礼包或京豆, 则输入框必填
              console.log("--- this.ruleForm:---", this.ruleForm)
              let flag = false
             this.ruleForm.prizes.forEach((item) => {
                if (item.prizeType == 6 && !item.price) {
                    this.$message.warning("请输入每人店铺积分");
                    flag = true
                }
                if (item.prizeType == 4 &&!item.price) {
                    this.$message.warning("请输入每人京豆数量");
                    flag = true
                }
                if (item.prizeType == 1 && item.bindType== 2) {
                  if(!item.skuIds){
                    this.$message.warning("请选择商品");
                     flag = true
                  }
                }
              })
              if (flag) {
                return
              }
            }
          }
        }
        if(this.activityData.id == 1) {
          // 日历签到
          if(this.fixedDate) {
            let errText = "";            
            this.itemArrDate.forEach(item => {
              if(!item.fixedSendDate) {
                errText =  "请输入指定签到日期";
              } else if (item.prizeType == null || item.prizeType == undefined) {
                errText =  "请先选择指定签到日期奖品";
              } else if (item.totalAmount <= 0) {
                errText =  "请输入指定签到日期奖品数量";
              }
            })
            console.log(errText);
            if(errText) {
              return this.$message.warning(errText);
            }
          }
          if(this.isSignInReissueEnabled && this.taskList.length == 0) {
            return this.$message.warning("最少添加一个任务！");
          }
        }
        if (this.activityData.id != 13 && this.activityData.id != 14) {
          if (!this.ruleForm.shareTitle) {
            this.$message.warning("请输入小程序分享标题");
            return;
          }
          if (!this.ruleForm.shareIntroduce) {
            this.$message.warning("请输入小程序分享简介");
            return;
          }
          if (!this.ruleForm.activityRulesText) {
            this.$message.warning("活动规则不能为空");
            return;
          }
        }
        // 加购有礼-最近一次付款时间校验
        if (this.activityData.id == 34 && this.actMember == '4'){
          if(!this.nonObjTime || this.nonObjTime.length == 0){
            return this.$message.warning('最近一次交易时间不能为空')
          }
          //if(this.nonObj.numStart == '' || !this.nonObj.numStart){
          //  this.$message.warning("完成订单笔数不能为空");
           // return;
          //}
          if(this.nonObj.finishOrderType == 2 &&  ((this.nonObj.numEnd == '' || !this.nonObj.numEnd) || (this.nonObj.numStart == '' || !this.nonObj.numStart)) ){
            this.$message.warning("完成订单笔数不能为空");
            return;
          }
        }
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.activityData.id == 13) {
          if (this.valueRow && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            //修改礼包 开卡  店铺
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                // endTime: cardParams.endTime,
                ruleDescription: cardParams.ruleDescription,
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDto: cardParams.ruleDTO,
                condFollow: this.ruleForm.condFollow ? 1: 0,
                isValidBlackList: this.ruleForm.isValidBlackList,
              }
              res = await updateCommon(params)
            } else {
               if (this.valueRow.status != 2) {
              res = await editShopGift({ ...cardParams, id: this.valueRow.id })
              }else{
                let template = {
                  memberGiftTemplateId:this.memberGiftTemplateId,
                  memberGiftTemplatePrizeType:'',
                  memberGiftTemplateUrl:this.templateUrlimg1,
                  giftTemplateId: this.giftID, //礼包模板id
                  giftTemplatePrizeType:'',
                  giftTemplateUrl:this.ruleForm.customPicUrl,
                }
              res = await newupdateCommon({ 
                templateJson:JSON.stringify(template), 
                ruleDto:cardParams.ruleDTO, 
                activityName:cardParams.activityName, 
                activityId: this.valueRow.id,
               })
              }
            }
            // editShopGift({ ...cardParams, id: this.valueRow.id }).then((res) => {
            if (res.code == 1) {
              this.$router.push({
                path: "/interactiveMarketing/activityManagement",
                query: {
                  sort: "gift"
                }
              })
              this.$emit("saveEdit");
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // });
          } else {
            if(this.isDraft){
              cardParams.status = 5
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              cardParams.id = this.valueRow.id
            }
            //创建礼包 开卡  店铺
            createShopGift(cardParams).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$router.push({
                    path: "/interactiveMarketing/activityManagement",
                    query: {
                      sort: "gift"
                    }
                  })
                  this.$emit("saveEdit");
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else if (this.activityData.id == 14) {
          if (this.valueRow && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            //修改礼包 开卡  店铺
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                // endTime: cardParams.endTime,
                ruleDescription: cardParams.ruleDescription,
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDto: cardParams.ruleDTO,
                condFollow: this.ruleForm.condFollow ? 1: 0,
                isValidBlackList: this.ruleForm.isValidBlackList,
              }
              res = await updateCommon(params)
            } else {
              res = await editShopGift({ ...cardParams, id: this.valueRow.id })
            }
            // editShopGift({ ...cardParams, id: this.valueRow.id }).then((res) => {
            if (res.code == 1) {
              this.$router.push({
                path: "/interactiveMarketing/activityManagement",
                query: {
                  sort: "gift"
                }
              })
              this.$emit("saveEdit");
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // });
          } else {
            if(this.isDraft){
              cardParams.status = 5
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              cardParams.id = this.valueRow.id
            }
            //创建礼包 开卡  店铺
            createShopGift(cardParams).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$router.push({
                    path: "/interactiveMarketing/activityManagement",
                    query: {
                      sort: "gift"
                    }
                  })
                  this.$emit("saveEdit");
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else if (this.activityData.name.indexOf("签到") != -1) {
          if (this.ruleForm.partner.length == 0 && !this.isDraft) return this.$message.warning('请选择活动对象')
          let isflay = false
          let objSet = this.awardSettingsLsit.map((item, index) => {
            let prize = {
              ...item,
              awardLevel: index + 1,
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
              // prize.singleAmount = item.price;
            } 
            if(prize.prizeType == 3){
              prize.addressFillEndTime = item.addressFillEndTime
              prize.predictSendTime = item.predictSendTime
              prize.isFollowActivityEndTime = item.isFollowActivityEndTime
              prize.addressFillLimit = item.addressFillLimit
            }
            if (!item.prizeType) isflay = true
            return prize;
          });
          everyDay.pointActivityPrizeDTO = { ...objSet[0] }
          if (everyDay.pointActivityPrizeDTO.skuId) everyDay.pointActivityPrizeDTO.assetsId = everyDay.pointActivityPrizeDTO.skuId;
          // if(isflay) return this.$message.warning('请填写奖品')

          if (this.activeValue == 1 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            if (this.activityData.id == 1) {
              delete everyDay.templateJson
            }
            if (this.localStepNum == 1 && this.ruleForm.prizeSet == false) {
              everyDay.pointActivityPrizeDTO = ''
            }
            if (this.localStepNum == 1 && this.ruleForm.prizeSetOne == false) {
              everyDay.ruleDTO.continueRule = []
            }
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                templateId: this.templateId,
                endTime: everyDay.endTime,
                ruleDescription: everyDay.ruleDescription,
                prizes: [
                  ...everyDay.ruleDTO.continueRule.filter(item => item.totalAmount).map(item => {
                    return {
                      ...item.prizeDTO,
                      prizeId: item.prizeDTO.id,
                      totalAmount: item.prizeDTO.totalAmount,
                      title:item.prizeDTO.title,
                    }
                  }),
                  ...this.awardSettingsLsit.map(item=>{
                    return{
                      ...item,
                      prizeId: item.id,
                      totalAmount: item.totalAmount,
                      title:item.title
                    }
                  }),
                  ...this.itemArr.filter(item => item.totalAmount).map(item=>{
                    return{
                      ...item,
                      prizeId: item.id,
                      totalAmount: item.totalAmount,
                      title:item.title
                    }
                  }),
                  ...this.itemArrDate.filter(item => item.totalAmount).map(item=>{
                    return{
                      ...item,
                      prizeId: item.id,
                      totalAmount: item.totalAmount,
                      title:item.title
                    }
                  }),
                ],
                ruleDto: everyDay.ruleDTO,
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                condFollow: this.ruleForm.condFollow ? 1: 0,
                isValidBlackList: this.ruleForm.isValidBlackList,
              }
              if(this.isSignInReissueEnabled) {
                params.taskList = this.taskList;
              } else {
                params.taskList = [];
              }
              if(everyDay.pointActivityPrizeDTO.id) {
                params.prizes.unshift( {
                    prizeId: everyDay.pointActivityPrizeDTO.id,
                    totalAmount: everyDay.pointActivityPrizeDTO.totalAmount,
                    title:everyDay.pointActivityPrizeDTO.title,
                  })
              }
              // 去掉prizeId相同的元素
              params.prizes = params.prizes.filter((prize, index, self) => 
                index === self.findIndex(p => p.prizeId === prize.prizeId)
              );
              // 去掉prizeId为空或者prizeId不存在的元素
              params.prizes = params.prizes.filter(prize => prize.prizeId);
              res = await updateCommon(params)
            } else {
              res = await editIntegral(everyDay)
            }
            // editIntegral(everyDay)
            //   .then((res) => {
            if (res.code == 1) {
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
          } else {
            if (this.localStepNum == 1 && this.ruleForm.prizeSet == false) {
              everyDay.pointActivityPrizeDTO = ''
            }
            if (this.localStepNum == 1 && this.ruleForm.prizeSetOne == false) {
              everyDay.ruleDTO.continueRule = []
            }
            if(this.isDraft){
              everyDay.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              if(!everyDay.pointActivityPrizeDTO.prizeType){
                everyDay.pointActivityPrizeDTO = null
              }
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            creatIntegral(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  if(this.isDraft){
                    this.$message.success("保存成功！")
                    this.$emit("returnBack",true);
                  }else{
                    this.$router.push({
                      name: "throw",
                      query: {
                        id: res.data.id,
                        activityType: res.data.activityType,
                      },
                    });
                    this.$message.success(res.message);
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => { });
          }
        } else if (this.activityData.name == "每日限时抢") {
          if (this.ruleForm.partner.length == 0 && !this.isDraft) return this.$message.warning('请选择活动对象')
          if (!this.ruleForm.limitedTimeGrab && !this.isDraft) return this.$message.warning('请设置每日开抢时间')
          if (!this.ruleForm.prizeCount && !this.isDraft) return this.$message.warning('请设置奖品份数')
          //每日限时抢
          let isflay = false
          let objSet = this.awardSettingsLsit.map((item, index) => {
            let prize = {
              ...item,
              awardLevel: index + 1,
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
              // prize.singleAmount = item.price;
            }
            if (!item.prizeType) isflay = true
            return prize;
          });
          everyDay.pointActivityPrizeDTO = { ...objSet[0] }
          if (everyDay.pointActivityPrizeDTO.skuId) everyDay.pointActivityPrizeDTO.assetsId = everyDay.pointActivityPrizeDTO.skuId;
          if (isflay && !this.isDraft) return this.$message.warning('请填写奖品')
          if (!this.isDraft && this.awardSettingsLsit[0].totalAmount * 1 < everyDay.ruleDTO.prizeCount * 1) {
            return this.$message.warning('每日赠送的份数不得大于上面设置的奖品数量')
          }
          if (this.activeValue == 3 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                templateId: this.templateId,
                endTime: everyDay.endTime,
                ruleDto: everyDay.ruleDTO,
                ruleDescription: everyDay.ruleDescription,
                prizes: [{
                  ...everyDay.pointActivityPrizeDTO,
                  prizeId: everyDay.pointActivityPrizeDTO.id,
                  totalAmount: everyDay.pointActivityPrizeDTO.totalAmount,
                  title:everyDay.pointActivityPrizeDTO.title,
                }],
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                condFollow: this.ruleForm.condFollow ? 1: 0,
                isValidBlackList: this.ruleForm.isValidBlackList,
              }
              if (!everyDay.pointActivityPrizeDTO.totalAmount) delete params.prizes
              res = await updateCommon(params)
            } else {
              res = await editPrize(everyDay)
            }
            // editPrize(everyDay).then((res) => {
            if (res.code == 1) {
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // });
          } else {
            if(this.isDraft){
              everyDay.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              if(!everyDay.pointActivityPrizeDTO.prizeType){
                everyDay.pointActivityPrizeDTO = null
              }
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            creatPrize(everyDay).then((res) => {
              if (res.code == 1) {
                // this.$emit("saveEdit");
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else if (this.activityData.name == "关注店铺有礼") {
          everyDay.ruleDTO = {
            // 1.14迭代 这里提交
            firstOpenCardTimeType:this.actMember==2?this.ruleForm.firstOpenCardTimeType:0,
            openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
            openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
            openCardBeforeDay:this.ruleForm.openCardBeforeDay,
            plusObject:this.ruleDto.plusObject,

            cusTemplateJSON:this.cusTemplateJSON,
            isForceRemind:this.isForceRemind,

            shareTitle: this.ruleForm.shareTitle,
            shareIntroduce: this.ruleForm.shareIntroduce,
            sharePic: this.ruleForm.sharePic,
            condFollow: this.ruleForm.condFollow ? 1 : 0,
            openCardFollow: this.ruleForm.openCardFollow, //参与条件:开卡
            customerPaperwork: JSON.stringify(this.customerPaperwork),
          };
          // everyDay.points = this.ruleForm.bonusPoints;
          let isflay = false
          let objSet = this.awardSettingsLsit.map((item, index) => {
            let prize = {
              ...item,
              awardLevel: index + 1,
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
              // prize.singleAmount = item.price;
            }
            if (!item.prizeType) isflay = true
            return prize;
          });
          everyDay.pointActivityPrizeDTO = { ...objSet[0] }
          if (everyDay.pointActivityPrizeDTO.skuId) everyDay.pointActivityPrizeDTO.assetsId = everyDay.pointActivityPrizeDTO.skuId;

          if (isflay && !this.isDraft) this.$message.warning('请填写奖品')
          if (this.activeValue == 4 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                endTime: everyDay.endTime,
                ruleDto: everyDay.ruleDTO,
                ruleDescription: everyDay.ruleDescription,
                prizes: [{
                  ...everyDay.pointActivityPrizeDTO,
                  prizeId: everyDay.pointActivityPrizeDTO.id,
                  totalAmount: everyDay.pointActivityPrizeDTO.totalAmount,
                  title:everyDay.pointActivityPrizeDTO.title,
                }],
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                templateId: this.templateId,
                condFollow: this.ruleForm.condFollow ? 1: 0,
                isKeyActivity: this.isKeyActivity,
                placementPosition: this.placementPosition.join(","),
                isValidBlackList: this.ruleForm.isValidBlackList,
              }
              if (!everyDay.pointActivityPrizeDTO.totalAmount) {
                delete params.prizes
              }
              res = await updateCommon(params)
            } else {
              res = await editfocusStores(everyDay)
            }
            // editfocusStores(everyDay)
            //   .then((res) => {
            if (res.code == 1) {
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // })
            // .catch(() => {});
          } else {
            if(this.isDraft){
              everyDay.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              if(!everyDay.pointActivityPrizeDTO.prizeType){
                everyDay.pointActivityPrizeDTO = null
              }
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            focusStores(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  if(this.isDraft){
                    this.$message.success("保存成功！")
                    this.$emit("returnBack",true);
                  }else{
                    this.$router.push({
                      name: "throw",
                      query: {
                        id: res.data.id,
                        activityType: res.data.activityType,
                      },
                    });
                    this.$message.success(res.message);
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => { });
          }
        } else if (this.activityData.name == "邀请开卡有礼") {  // 此活动不在当前页面中 暂时废弃
          everyDay.ruleDTO = {
            // 1.14迭代 这里提交
            firstOpenCardTimeType:this.actMember==2?this.ruleForm.firstOpenCardTimeType:0,
            openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
            openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
            openCardBeforeDay:this.ruleForm.openCardBeforeDay,
            plusObject:this.ruleDto.plusObject,
            cusTemplateJSON:this.cusTemplateJSON,
            isForceRemind:this.isForceRemind,
          };
          // 接口需要，points固定传个正数
          everyDay.points = 1;

          everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
          everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize == 1 ? true : false;
          delete everyDay.pointActivityPrizeDTO;
          // 梯度奖励
          if (this.ruleForm.isCumulativePrize) {
            everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
              let prize = {
                title: item.title,
                assetsId: item.skuId ? item.skuId : item.assetsId,
                prizeType: item.prizeType,
                singleAmount: item.singleAmount,
                totalAmount: item.prizeCount,
                prizeGoShop: item.prizeGoShop,
              };
              if (prize.prizeType == 4||prize.prizeType == 12) {
                prize.logo = item.logo;
              }
              if (prize.prizeType == 3) {
                prize.addressFillEndTime = item.addressFillEndTime
                prize.predictSendTime = item.predictSendTime
                prize.isFollowActivityEndTime = item.isFollowActivityEndTime
                prize.shouldCollectExtraData = item.shouldCollectExtraData;
                prize.extraQuestion = item.extraQuestion;
                prize.logo = item.logo;
                if(item.isGoodManage) {
                  prize.isGoodManage = item.isGoodManage;
                }
              }
              if (prize.prizeType != 2 && prize.prizeType != 4) {
                prize.price = item.discount;
              }
              if (prize.prizeType == 2 || prize.prizeType == 4) {
                prize.singleAmount = item.price;
              } else {
                prize.singleAmount = 1;
              }
              return {
                cumulativeNum: item.peopleCount,
                cumulativePrizeDTO: prize,
              };
            });
            everyDay.ruleDTO.maxInviteNum = this.tableData[this.tableData.length - 1].peopleCount;
          } else {
            let prize = {
              title: this.prizeSettingList.title,
              assetsId: this.prizeSettingList.skuId ? this.prizeSettingList.skuId : this.prizeSettingList.assetsId,
              prizeType: this.prizeSettingList.prizeType,
              logo: this.prizeSettingList.logo,
              singleAmount: this.prizeSettingList.singleAmount,
              totalAmount: this.ruleForm.prizeCount,
              prizeGoShop: this.prizeSettingList.prizeGoShop,
            };
            if (prize.prizeType == 4) {
              prize.logo = item.logo;
            }
            if (prize.prizeType == 3) {
              prize.addressFillEndTime =this.prizeSettingList.addressFillEndTime
              prize.predictSendTime = this.prizeSettingList.predictSendTime
              prize.isFollowActivityEndTime = this.prizeSettingList.isFollowActivityEndTime
              prize.shouldCollectExtraData = this.prizeSettingList.shouldCollectExtraData;
              prize.extraQuestion = this.prizeSettingList.extraQuestion;
              prize.addressFillLimit = this.prizeSettingList.addressFillLimit
              prize.logo = item.logo;
              if(this.prizeSettingList.isGoodManage) {
                prize.isGoodManage = this.prizeSettingList.isGoodManage;
              }
            }
            if (prize.prizeType != 2 && prize.prizeType != 4) {
              prize.price = this.prizeSettingList.discount;
            }

            if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = this.prizeSettingList.price;
            } else {
              prize.singleAmount = 1;
              // prize.singleAmount = item.price;
            }


            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum: 1,
                cumulativePrizeDTO: prize,
              },
            ];
          }

          if (this.activeValue == 5 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            editInvite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => { });
          } else {
            if(this.isDraft){
              everyDay.status = 5
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            invite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  if(this.isDraft){
                    this.$message.success("保存成功！")
                    this.$emit("returnBack",true);
                  }else{
                    this.$router.push({
                      name: "throw",
                      query: {
                        id: res.data.id,
                        activityType: res.data.activityType,
                      },
                    });
                    this.$message.success(res.message);
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => { });
          }
        } else if (this.activityData.name == "邀请关注有礼") {
          everyDay.ruleDTO.maxInviteNum = Number(this.ruleForm.peopleCount);
          everyDay.points = this.ruleForm.prizeSite;
          everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
          everyDay.ruleDTO.inviteNum = this.ruleForm.inviteNum;
          everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize == 1 ? true : false;
          everyDay.ruleDTO.isForceRemind = this.isForceRemind
          everyDay.ruleDTO.cusTemplateJSON = this.cusTemplateJSON
          // 是否任务类型
          everyDay.ruleDTO.isTaskPrize = this.ruleForm.isCumulativePrize == 2 ? true : false
          // delete everyDay.pointActivityPrizeDTO;
          // 梯度奖励
          if (this.ruleForm.isCumulativePrize) {
            if (this.ruleForm.isCumulativePrize == 1) {
              everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
                let prize = {
                  ...item,
                  couponType: item.couponType,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  singleAmount: item.singleAmount,
                  totalAmount: item.prizeCount,
                  id: item.id,
                };
                if (prize.prizeType == 3) {
                  prize.addressFillEndTime = item.addressFillEndTime
                  prize.predictSendTime = item.predictSendTime
                  prize.isFollowActivityEndTime = item.isFollowActivityEndTime
                  prize.shouldCollectExtraData = item.shouldCollectExtraData;
                  prize.extraQuestion = item.extraQuestion;
                  prize.addressFillLimit = item.addressFillLimit
                  prize.logo = item.logo;
                  if(!item.isGoodManage) {
                    if(item.skuId)prize.assetsId = item.skuId;
                  } else {
                    prize.isGoodManage = item.isGoodManage;
                  }
                }
                if (prize.prizeType == 10||prize.prizeType == 12) {
                  prize.logo = item.logo;
                }
                if (prize.prizeType != 2 && prize.prizeType != 4) {
                  prize.price = item.price;
                }
                if (prize.prizeType == 2 || prize.prizeType == 4) {
                  prize.singleAmount = item.price;
                } else {
                  prize.singleAmount = 1;
                }
                prize.price = item.price;
                return {
                  cumulativeNum: item.peopleCount,
                  cumulativePrizeDTO: prize,
                };
              });
              everyDay.ruleDTO.maxInviteNum = this.tableData[this.tableData.length - 1].peopleCount;
            } else {
              everyDay.ruleDTO.cumulativePrizes = this.taskTableData.map((item) => {
                let prize = {
                  ...item,
                  couponType: item.couponType,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  singleAmount: item.singleAmount,
                  totalAmount: item.prizeCount,
                  id: item.id,
                };
                prize.price = item.price;
                if (prize.prizeType == 3) {
                  prize.addressFillEndTime = item.addressFillEndTime
                  prize.predictSendTime = item.predictSendTime
                  prize.isFollowActivityEndTime = item.isFollowActivityEndTime
                  prize.shouldCollectExtraData = item.shouldCollectExtraData;
                  prize.extraQuestion = item.extraQuestion;
                  prize.addressFillLimit = item.addressFillLimit
                  prize.logo = item.logo;
                  if(!item.isGoodManage) {
                    if(item.skuId)prize.assetsId = item.skuId;
                  } else {
                    prize.isGoodManage = item.isGoodManage;
                  }
                }
                if (prize.prizeType == 10||prize.prizeType == 12) {
                  prize.logo = item.logo;
                }
                if (prize.prizeType != 2 && prize.prizeType != 4) {
                  prize.price = item.price;
                }
                if (prize.prizeType == 2 || prize.prizeType == 4) {
                  prize.singleAmount = item.price;
                } else {
                  prize.singleAmount = 1;
                }
                return {
                  cumulativeNum: item.peopleCount,
                  cumulativePrizeDTO: prize,
                };
              });
            }
          } else {
            let isflay = false;
            let objSet = this.awardSettingsLsit.map((item, index) => {
              let prize = {
                ...item,
                assetsId: item.skuId ? item.skuId : item.assetsId,
                awardLevel: index + 1,
              };
              if (prize.prizeType == 1) {
                prize.quota = item.quota;
                prize.couponType = item.couponType;
                prize.singleAmount = 1;
                prize.assetsId = item.assetsId;
              }  else  if (prize.prizeType == 3) {
                  prize.addressFillEndTime = item.addressFillEndTime
                  prize.predictSendTime = item.predictSendTime
                  prize.isFollowActivityEndTime = item.isFollowActivityEndTime
                  prize.shouldCollectExtraData = item.shouldCollectExtraData;
                  prize.extraQuestion = item.extraQuestion;
                  prize.logo = item.logo;
                  if(item.isGoodManage) {
                    prize.isGoodManage = item.isGoodManage;
                  }
                } else  if (prize.prizeType == 10) {
                  prize.logo = item.logo;
                } else if (prize.prizeType == 2 || prize.prizeType == 4) {
                prize.singleAmount = item.price;
              } else {
                prize.singleAmount = 1;
                // prize.singleAmount = item.price;
              }

              if (!item.prizeType) isflay = true;
              return prize;
            });
            // everyDay.pointActivityPrizeDTO = { ...objSet[0] };
            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum: 1,
                cumulativePrizeDTO: { ...objSet[0] },
              },
            ];
            if (isflay && !this.isDraft) this.$message.warning("请填写奖品");
          }

          if (this.activeValue == 6 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                ruleDescription: everyDay.ruleDescription,
                prizes: everyDay.ruleDTO.cumulativePrizes.filter(item => item.cumulativePrizeDTO.totalAmount).map(item => {
                  return {
                    ...item.cumulativePrizeDTO,
                    prizeId: item.cumulativePrizeDTO.id,
                    totalAmount: item.cumulativePrizeDTO.totalAmount,
                    title:item.cumulativePrizeDTO.title,
                  }
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                endTime: everyDay.endTime,
                ruleDto:everyDay.ruleDTO,
                condFollow: this.ruleForm.condFollow ? 1: 0,
              }
              res = await updateCommon(params)
            } else {
              res = await editfollow(everyDay)
            }
            if (res.code == 1) {
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // })
            // .catch(() => {});
          } else {
            if(this.isDraft){
              everyDay.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              if(!everyDay.pointActivityPrizeDTO.prizeType){
                everyDay.pointActivityPrizeDTO = null
              }
              everyDay.ruleDTO.cumulativePrizes = everyDay.ruleDTO.cumulativePrizes.filter(item=>item.cumulativePrizeDTO.prizeType)
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            follow(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  if(this.isDraft){
                    this.$message.success("保存成功！")
                    this.$emit("returnBack",true);
                  }else{
                    this.$router.push({
                      name: "throw",
                      query: {
                        id: res.data.id,
                        activityType: res.data.activityType,
                      },
                    });
                    this.$message.success(res.message);
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => { });
          }
        } else if (this.activityData.name == "完善信息有礼") {
          if (this.ruleForm.information.length == 0 && !this.isDraft) return this.$message.warning('请选择完善资料信息')
          this.testInfo = [];
          this.itemArrOne.forEach((i) => {
            this.testInfo.push({
              type: i.informationmationSelect,
              name: i.informationmationOne
            });
          });
          everyDay.ruleDTO = {
            // 1.14迭代 这里提交
            firstOpenCardTimeType:this.actMember==2?this.ruleForm.firstOpenCardTimeType:false,
            openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
            openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
            openCardBeforeDay:this.ruleForm.openCardBeforeDay,
            plusObject:this.ruleDto.plusObject,

            shareTitle: this.ruleForm.shareTitle,
            shareIntroduce: this.ruleForm.shareIntroduce,
            sharePic: this.ruleForm.sharePic,

            cusTemplateJSON:this.cusTemplateJSON,
            isForceRemind:this.isForceRemind,
            openCardFollow: this.ruleForm.openCardFollow,
            customerPaperwork: JSON.stringify(this.customerPaperwork),
          };
          everyDay.ruleDTO.infoNames = this.ruleForm.information;
          everyDay.ruleDTO.staticInfoNames = this.testInfo;
          // everyDay.points = this.ruleForm.bonusPoints;
          let isflay = false
          let objSet = this.awardSettingsLsit.map((item, index) => {
            let prize = {
              ...item,
              awardLevel: index + 1,
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
              // prize.singleAmount = item.price;
            }
            if (!item.prizeType) isflay = true
            return prize;
          });
          everyDay.pointActivityPrizeDTO = { ...objSet[0] }
          if (everyDay.pointActivityPrizeDTO.skuId) everyDay.pointActivityPrizeDTO.assetsId = everyDay.pointActivityPrizeDTO.skuId;

          if (isflay && !this.isDraft) return this.$message.warning('请填写奖品')

          if (this.activeValue == 7 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                endTime: everyDay.endTime,
                ruleDescription: everyDay.ruleDescription,
                prizes: [{
                  ...everyDay.pointActivityPrizeDTO,
                  prizeId: everyDay.pointActivityPrizeDTO.id,
                  totalAmount: everyDay.pointActivityPrizeDTO.totalAmount,
                  title:everyDay.pointActivityPrizeDTO.title,
                }],
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                ruleDto: everyDay.ruleDTO,
                condFollow: this.ruleForm.condFollow ? 1: 0,
              }
              res = await updateCommon(params)
            } else {
              res = await editInformationAa(everyDay)
            }
            // editInformationAa(everyDay)
            //   .then((res) => {
            if (res.code == 1) {
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // })
            // .catch(() => {});
          } else {
            if(this.isDraft){
              everyDay.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              if(!everyDay.pointActivityPrizeDTO.prizeType){
                everyDay.pointActivityPrizeDTO = null
              }
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            information(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  if(this.isDraft){
                    this.$message.success("保存成功！")
                    this.$emit("returnBack",true);
                  }else{
                    this.$router.push({
                      name: "throw",
                      query: {
                        id: res.data.id,
                        activityType: res.data.activityType,
                      },
                    });
                    this.$message.success(res.message);
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => { });
          }
        } else if (this.activityData.name == "加购有礼") {
          everyDay.ruleDTO = {
            // 1.14迭代 这里提交
            firstOpenCardTimeType:this.actMember==2?this.ruleForm.firstOpenCardTimeType:0,
            openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
            openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
            openCardBeforeDay:this.ruleForm.openCardBeforeDay,
            plusObject:this.ruleDto.plusObject,

            cusTemplateJSON:this.cusTemplateJSON,
            isForceRemind:this.isForceRemind,

            shareTitle: this.ruleForm.shareTitle,
            shareIntroduce: this.ruleForm.shareIntroduce,
            sharePic: this.ruleForm.sharePic,

            goShopSetting: this.ruleForm.goShopSetting,
            goShopAppId: this.ruleForm.goShopAppId,
            goShopUrl: this.ruleForm.goShopUrl,
            openCardFollow: this.ruleForm.openCardFollow,
            customerPaperwork: JSON.stringify(this.customerPaperwork),
          };
          everyDay.ruleDTO.picUrl = this.ruleForm.picUrl
          everyDay.ruleDTO.requestFollow = this.ruleForm.condFollow
          everyDay.ruleDTO.rgb = this.ruleForm.rgb
          everyDay.ruleDTO.showPrize = this.ruleForm.showPrize
          everyDay.ruleDTO.showPrizeNum = this.ruleForm.showPrizeNum
          // everyDay.ruleDTO.showBatchAddCart = this.ruleForm.showBatchAddCart ? '1' : '0'
          everyDay.ruleDTO.showBatchAddCart = this.ruleForm.showBatchAddCart;
          // 加购推荐商品列表 当showBatchAddCart为2时必填 传数组
          if(this.ruleForm.showBatchAddCart==2) {
            everyDay.ruleDTO.recommendSkuIds = this.selectedGoodList.map(item => item.skuId)
          }


          everyDay.ruleDTO.addCartNum = this.ruleForm.addCartNum
          let isflay = false
          let objSet = this.awardSettingsLsit.map((item, index) => {
            let prize = {
              ...item,
              awardLevel: index + 1,
            };
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              prize.singleAmount = 1;
            } else if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
              // prize.singleAmount = item.price;
            }
            if (!item.prizeType) isflay = true
            return prize;
          });
          if (isflay && !this.isDraft) return this.$message.warning('请填写奖品')
          everyDay.pointActivityPrizeDTO = { ...objSet[0] }
          if (everyDay.pointActivityPrizeDTO.skuId) everyDay.pointActivityPrizeDTO.assetsId = everyDay.pointActivityPrizeDTO.skuId
          if (everyDay.pointActivityPrizeDTO.title === "" && !this.isDraft) return this.$message.warning('请将奖品填写完整！')
          if (everyDay.allowLevel === "") return this.$message.warning('请选择参与对象')
          if (!everyDay.itemList.length && !this.isDraft) return this.$message.warning('请添加加购商品')
          if(this.activityData.id == 34 && this.actMember == '4') {
            if(this.nonObjTime && this.nonObjTime.length){
              everyDay.ruleDTO.lastPayStartTime = this.nonObjTime[0] || '';
              everyDay.ruleDTO.lastPayEndTime = this.nonObjTime[1] || '';
            }
            everyDay.ruleDTO.finishOrderType = this.nonObj.finishOrderType;
            everyDay.ruleDTO.numStart = this.nonObj.numStart;
            everyDay.ruleDTO.numEnd = this.nonObj.numEnd;
          }
          if (this.activeValue == 34 && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
            everyDay.pointActivityId = this.valueRow.id;
            let res;
            if (this.activityData.isStart) {
              let params = {
                activityId: this.valueRow.id,
                ruleDescription: everyDay.ruleDescription,
                prizes: [{
                  ...everyDay.pointActivityPrizeDTO,
                  prizeId: everyDay.pointActivityPrizeDTO.id,
                  totalAmount: everyDay.pointActivityPrizeDTO.totalAmount,
                  title:everyDay.pointActivityPrizeDTO.title,
                }],
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
                endTime: everyDay.endTime,
                ruleDto: everyDay.ruleDTO,
                templateId: this.templateId,
                condFollow: this.ruleForm.condFollow ? 1: 0,
              }
              res = await updateCommon(params)
            } else {
              res = await editAddCart(everyDay)
            }
            // editAddCart(everyDay).then((res)=>{
            if (res.code == 1) {
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // }).catch(() => {});
          } else {
            if(this.isDraft){
              everyDay.status = 5
              // 草稿箱奖品填写完整校验-若不全则为空
              if(!everyDay.pointActivityPrizeDTO.prizeType){
                everyDay.pointActivityPrizeDTO = null
              }
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              everyDay.id = this.valueRow.id
            }
            incentivesAddCart(everyDay).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            }).catch(() => { });
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },
    //完善信息删除
    deleteaInfo(index) {
      if (this.isStart) return;
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if (this.isStart) return;
      if (this.ruleForm.isCumulativePrize == 1) {
        this.itemArr = this.tableData
      } else if (this.ruleForm.isCumulativePrize == 2) {
        this.itemArr = this.taskTableData
      }
      this.JingdouCount.prizeCount = this.ruleForm.prizeCount
      this.echoDate = scope.row;
      if (this.ruleForm.isCumulativePrize == 1) {
        this.tableIndex = scope.$index;
        if (this.tableData[scope.$index].prizeType == 3) {
          this.clickActual = true;
          if (this.activityData.id == 6) this.clickActual = false;
        }
      } else {
        this.taskTableIndex = scope.$index;
        if (this.taskTableData[scope.$index].prizeType == 3) {
          this.clickActual = true;
          if (this.activityData.id == 6) this.clickActual = false;
        }
      }
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
      if (val == false) {
        this.itemArr = [
          {
            continueSignPoints: "",
            days: "",
            prizeType: null,
            price: '',
            title: "",
            totalAmount: null,
            awardMinScore: null,
            awardMaxScore: null,
            awardLevel: null,
          },
        ]
      }
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    itemDel(index) {
      if (this.ruleForm.isCumulativePrize == 1) {
        if (this.tableData.length == 1) {
          this.$message.warning("梯度奖品必须有一个奖项");
          return
        }
        this.tableData.splice(index, 1);
      } else if (this.ruleForm.isCumulativePrize == 2) {
        if (this.taskTableData.length == 1) {
          this.$message.warning("任务奖品必须有一个奖项");
          return
        }
        this.taskTableData.splice(index, 1);
      }
    },
    checkputnCount(e, row) {
      if (row.quantityTotal && row.price && row.prizeCount) {
        let numTotal = this.$jingdouTotal(row);
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.prizeCount;
      }
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push({
        peopleCount: "",
        prizeType: "",
        title: "",
        price: '',
        prizeCount: "",
        days: '',
      });

      // this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationSelect: 1,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
        this.awardSettingsLsit = [
          {
            prizeType: null,
            price: null,
            title: "",
            totalAmount: null,
            awardMinScore: null,
            awardMaxScore: null,
            awardLevel: null,
          },
        ]
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      // 校验有无时间
      if(!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime)return;
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime != "" && this.ruleForm.activityStartTime != "") {
                console.log('88888888');
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // 更换组件后需要更换时间计算方法
        const timeDiff = Math.abs(new Date(this.ruleForm.activityEndTime) - new Date(this.ruleForm.activityStartTime));
        this.timeDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        const timeHour = Math.floor(timeDiff / 1000 / 60 / 60);

        if (timeHour < 1 && !this.backgroundOpacity && this.localStep) {
          this.$message.warning("活动开始时间和结束时间间隔必须大于1小时！");
          // this.activityTimeValue[1] = "";
          this.ruleForm.activityEndTime = "";
          this.timeOut = 0
          this.timeDay = 0
          // this.activityTimeValue = []
          return;
        }

        // this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (this.activityData.id == 13 || this.activityData.id == 14) {
        if ((start - nowTime) / 1000 / 60 < 20) {
          if (this.activeValue) {
            this.disableTime = true;
          } else {
            // this.$message.warning("活动时间开始时间要大于当前时间的20分钟");
          }
        }
      } else {
        if ((start - nowTime) / 1000 / 60 < 5) {
          if (this.activeValue) {
            this.disableTime = true;
          } else {
            // this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          }
        }
      }

      if (end < nowTime && this.localStep) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start && this.localStep) {
        this.$message.warning("结束时间不能小于开始时间");
      }
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1 && this.activityData.id != 13 && this.activityData.id != 14) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0
      // this.localStepNum = this.activityData.id;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      let state = true;
      if (this.ruleForm.isCumulativePrize) {
        let title = this.ruleForm.isCumulativePrize == 1 ? this.tableData.map((i) => {
          return i.title;
        }) : this.taskTableData.map((i) => {
          return i.title;
        })
        if (title.indexOf("") != -1) {
          return this.$message.error("请在条件中设置奖品");
        }

        let count = this.ruleForm.isCumulativePrize == 1 ? this.tableData.map((i) => {
          return i.prizeCount;
        }) : this.taskTableData.map((i) => {
          return i.prizeCount;
        })
        if (count.indexOf("") != -1) {
          return this.$message.error("请在条件中设置奖品数量");
        }

        let arr = this.ruleForm.isCumulativePrize == 1 ? this.tableData.map((i) => {
          return i.peopleCount * 1;
        }) : this.taskTableData.map((i) => {
          return i.peopleCount * 1;
        })
        if (arr.indexOf(0) != -1) {
          return this.$message.error("邀请人数不可为空");
        }

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          for (let indexSecond = index; indexSecond < arr.length; indexSecond++) {
            if (element > arr[indexSecond]) {
              state = false;
            }
          }
        }
        if (!state && this.ruleForm.isCumulativePrize == 1) {
          return this.$message.error("邀请人数梯度不可大于上一个梯度");
        }
      } else if (this.ruleForm.isCumulativePrize == 0 && this.activityData.name == "邀请关注有礼") {
        if (!this.ruleForm.peopleCount || !this.ruleForm.inviteNum) {
          return this.$message.error("请输入邀请人数");
        }
        let title = this.awardSettingsLsit.map((i) => {
          return i.title;
        });
        if (!title[0]) {
          return this.$message.error("请在条件中设置奖品");
        }
        let arr = this.awardSettingsLsit.map((i) => {
          return i.totalAmount;
        });
        if (!arr[0]) {
          return this.$message.error("邀请人数不可为空");
        }
      }
      let flag = false
      if(this.itemArr.length>1) {
        for(let i=0;i<this.itemArr.length;i++) {
          if(i<this.itemArr.length-1) {
            if(Number(this.itemArr[i+1].days)<=Number(this.itemArr[i].days)) {
              flag = true
            }
          }
        }
      }
      if(flag) {
        return this.$message.error("连续天数后面数值需大于前面输入的数值，不可等于");
      }

      if(this.activityData.id == 34) {
        //新增进店设置校验
        if(this.ruleForm.goShopSetting==1 && !this.ruleForm.goShopAppId) {
          this.$message.warning("请输入小程序appId");
          return;
        }
        if(this.ruleForm.goShopSetting==2) {
          if(!this.ruleForm.goShopUrl) {
           this.$message.warning("请输入指定链接");
           return;
          }else if(!this.ruleForm.goShopUrl.startsWith('https://') || !this.ruleForm.goShopUrl.includes('jd.com')) {
            this.$message.warning("输入的内容非链接或为接口无法支持的链接，请重新设置");
            return;
          }
        }

        if(this.ruleForm.showBatchAddCart==2) {
          if(!this.selectedGoodList.length) {
            this.$message.warning("未设置一键加购商品");
            return;
          }
        }
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 下一步
    resetForm() {
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.numlimit = 20
      this.selectGoodsState = true;
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].skuName || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text11 = "";
        const {firstTextStr,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember,false);
        let secondTextStr = "\n二、【如何获奖】";
        let thirdTextStr = "\n\n三、【活动奖品】";
        let infoPrecautions = "1.客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放);实物奖品采取寄送方式发放，获得中奖资格的用户根据填写的姓名、联系电话、详细地址信息发放。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品;\n2.若用户已在当前店铺填写过生日信息，活动将回显最新采集的生日，生日信息一经填写，不可修改，如有疑问可咨询店铺客服。\n3.活动参与主体资格：\n（1）同一用户仅限参与活动一次。同一用户是指账户、手机号码、收件地址、支付账号、身份证号码、设备标识符、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的（包括但不限于批量相同、雷同、邻近、虚构的地址）均视为同一用户。同一用户注册、持有、使用或控制多个会员账号，商家有权取消/限制其参与本活动或领取奖品的资格；\n" + 
      "（2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格;\n4.注意事项：\n（1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利;\n（2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动\n（3）本活动所发放的实物奖、虚拟奖品均不得提现、不得转赠他人、不得为他人付款;\n（4）是否获得中奖资格以活动发布者后台统计结果为准;\n（5）实物奖品一经发出，无质量问题恕不退换，如有疑问，请咨询客服。\n"+ 
      "（6）商家可根据活动的实际进行情况，在法律允许的范围内，对本活动规则进行调整或变动，相关调整或变动将公布在活动规则页上。\n（7）如对本活动有任何疑问，请咨询客服。\n"
      let fourthTextStr = `\n\n四、【注意事项】\n${ infoPrecautions }`
      //奖品设置
      if (this.activityData.name.indexOf("签到")  != -1) {
        secondTextStr = "\n二、【如何参与】"
        secondTextStr += "\n1.参与方式：活动有效期内，进入活动手动签到参与；"
        if(this.ruleForm.prizeSetOne) {
          if(this.ruleForm.continueRuleType==0) {
            text11 = "\n2.达到连续签到最大天数并领取奖品或中途漏签后，签到记录清零，从第1天重新计算；例如：连续签到规则最大天数为5天，则连续签到5天并领取奖品后，第6天的连续签到记录是1天，多条件为累计叠加"
          } else {
            text11 = "\n2.达到连续签到最大天数并领取奖品或中途漏签后，签到记录不清零，可以继续签到但是不再获得奖品"
          }
          secondTextStr += text11;
        }
        thirdTextStr += "\n1.活动奖品:\n";
        let prizeText = [];
        if (this.awardSettingsLsit[0].title != "" && (this.ruleForm.singScore == false || !this.ruleForm.singScore)) {
          text6 ="每日签到送" + this.awardSettingsLsit[0].title;
          prizeText.push(text6)
        } else if (this.awardSettingsLsit[0].title == "" && !this.ruleForm.singScore) {
          text6 = "";
        } else {
          text6 = "每日签到送" + this.awardSettingsLsit[0].title + ";";
          prizeText.push(text6)
        }
        if(this.fixedDate) {
          const dates = this.itemArrDate.filter(v=> v.fixedSendDate && v.title).map(v=> `指定日期${v.fixedSendDate}签到赠送礼品：${v.title}`).join("；")
          if(dates) {
            text6 = `${dates}`
          }
          prizeText.push(text6)
        }
        if (this.ruleForm.prizeSetOne && this.itemArr.length) {
          text6 = "";
          this.itemArr.forEach((item, index) => {
            text6 += "连续签到" + item.days + "天" + "," + "赠送" + item.title + ";";
          });
          prizeText.push(text6)
        }
        let prizeIndex = 0;
        prizeText.forEach((item,index)=> {
          if(item) {
            thirdTextStr += `（${prizeIndex+1}）${item}\n`
            prizeIndex++
          }
        })
        thirdTextStr += "2.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况;\n3.如果是实物奖项，需填写收货地址后进行发货，活动结束后不允许填写地址，请在活动时间内填写地址，否则将视为放弃机会;"
      } else if (this.activityData.name == "加购有礼") {
        text6 = "活动奖品数量有限，先到先得";
      } else if (this.activityData.name == "完善信息有礼") {
        thirdTextStr += "\n1.活动奖品：" + this.awardSettingsLsit[0].title;
        thirdTextStr += "\n2.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；"
      } else if (this.activityData.name == "关注店铺有礼") {
        secondTextStr = "";
        thirdTextStr = "\n二、【活动奖品】";
        fourthTextStr = `\n\n三、【注意事项】\n1.${ precautions }`
        thirdTextStr += "\n1.活动奖品：" + this.awardSettingsLsit[0].title;
        thirdTextStr += "\n2.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；"
      }
       else if (this.activityData.name == "邀请开卡有礼") {
        if (!this.ruleForm.isCumulativePrize) {
          let priceText = this.prizeSettingList.discount + prizeName[this.prizeSettingList.prizeType];
          if (this.prizeSettingList.prizeType == 3) {
            priceText = this.prizeSettingList.title;
          }
          text6 =
            "奖品设置：" + "每邀请一人获得" + priceText + "," + "活动期间最多邀请" + this.ruleForm.peopleCount + "人" + "," + "超出人数不再获得奖励";
        } else {
          
        }
      } else if (this.activityData.name == "邀请关注有礼") {
        secondTextStr = "";
        thirdTextStr = "\n二、【活动奖品】";
        thirdTextStr += `\n1.活动奖品：${this.ruleForm.isCumulativePrize==0?"":this.ruleForm.isCumulativePrize==1?"梯度奖品":"任务奖品"}`
        if (this.ruleForm.isCumulativePrize == 0) {
          text6 = "邀请" + this.ruleForm.inviteNum + "人可获得" + this.awardSettingsLsit[0].title + ",";
          if (this.ruleForm.peopleCount) {
            text6 += "活动期间最多邀请" + this.ruleForm.peopleCount + "人" + ";";
          }
        } else if (this.ruleForm.isCumulativePrize == 1) {
          let textArr = this.tableData.map((i,index) => {
            let str = `\n（${index+1}）邀请${i.peopleCount}人可获得${i.title}`;
            return str;
          });
          text6 = textArr.join("，");
        } else {
          let textArr = this.taskTableData.map((i, index) => {
            let str = `\n（${index+1}）任务${this.$toChinesNum(index + 1)}：邀请${i.peopleCount}人可获得${i.title}`;
            return str;
          });
          text6 = textArr.join("，");
        }
        thirdTextStr += text6 + "\n2.领奖说明：需用户点击立即领取才可获奖，超出人数不再获得奖励;\n3.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；";
        fourthTextStr = `\n\n三、【注意事项】\n1.${ precautions }`
      }else if(this.activityData.name == "每日限时抢") {
        secondTextStr = "\n二、【如何参与】"
        secondTextStr += "\n1.参与方式：在活动有效期内，每日在指定时间节点进入活动页参与；"
        if (this.ruleForm.limitedTimeGrab) {
          text7 = "\n2.每日开抢时间:" + this.ruleForm.limitedTimeGrab;
        }
        secondTextStr += text7;
        if(this.awardSettingsLsit && this.awardSettingsLsit.length >0) {
          let prizeItem = this.awardSettingsLsit[0];
          if(prizeItem.prizeType ==3) {
            thirdTextStr += "\n1.活动奖品:" + `${prizeItem.title}，共${prizeItem.totalAmount}份，价值${prizeItem.price}元`;
          }else {
            thirdTextStr += "\n1.活动奖品:" + `${prizeItem.title}，共${prizeItem.totalAmount}份`;
          }
        }else {
          thirdTextStr += "\n1.活动奖品:" + ``;
        }
        if (this.ruleForm.prizeCount) {
          text8 = "\n2.奖品份数：每日共赠送" + this.ruleForm.prizeCount + "份奖品，每人每日限领一份奖品，先到先得";
        }else {
          text8 = "\n2.奖品份数：每日共赠送" + "份奖品，每人每日限领一份奖品，先到先得";
        }
        thirdTextStr += text8 + "\n3.若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）;"; 
      }
      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push({
          type: v.informationmationSelect,
          name: v.informationmationOne
        });
      });
      levetListTwo = levetListOne.join(",");
       levetList.forEach((item)=>{
        levetListThree += (item.type==1 ? "文本：" : "图片：") + item.name +  "，"
      });
      levetListThree = levetListThree.substring(0,levetListThree.length-1)
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }
      //完善资料信息
      if (this.activityData.name == "完善信息有礼") {
        secondTextStr += "\n1.参与方式：活动时间范围内，进入活动按要求完善信息参与；"
        text8 = "\n2.完善资料信息:" + levetListTwo + levetListThree;
      }
      if (this.activityData.name == "加购有礼") {
        secondTextStr += "\n1.加购方式:" + `需要加购${this.ruleForm.addCartNum}件商品后才可领取奖品`;
        secondTextStr += "\n2.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；";
        secondTextStr += "\n3.若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）";
        thirdTextStr = "";
        fourthTextStr = fourthTextStr.replace("四、","三、");
      }
      this.ruleForm.activityRulesText = firstTextStr + secondTextStr + thirdTextStr + fourthTextStr;
    },
    // 礼包点击
    handleClickPoint(item, i) {
      if (this.isStart) return;
      this.currtIndex = i;
      this.libaoItem = item;
      this.JingdouCount.prizeCount = this.ruleForm.sendCount
      this.dialogPrize = true;
    },
    handleClickPoint2(item, i) {
      if (this.isStart) return;
      this.currtIndex = i;
      this.libaoItem = item;
      this.JingdouCount.prizeCount = this.ruleForm.sendCount
      if(item.prizeType == 1){ // 东券
        this.libaoList[i].quota = item.quota
        this.libaoList[i].price = item.price
        this.libaoList[i].validateDay = item.validateDay
        this.libaoList[i].couponType = item.couponType
        this.libaoList[i].bindType = item.bindType
        this.libaoList[i].batchKey = item.batchKey
      }
      console.log("执行了handleClickPoint",item,i);
    },
    // 移除
    handleRemovePoint(item, i) {
      if (this.isStart) return;
      this.libaoList[i].backAction = false;
      this.libaoList[i].singleAmount = "";
      if (item.assetsId) {
        this.libaoList[i].assetsId = "";
      }
      if (item.prizeType == 6) {
        this.libaoList[i].priceName = "每份店铺积分：0";
      }
      if (item.prizeType == 4) {
        this.libaoList[i].priceName = "每份京豆额：0";
      }
      if (item.prizeType == 1) {
        this.libaoList[i].priceName = "0优惠券";
      }
      if (item.prizeType == 0) {
        this.libaoList[i].priceName = "0优惠券";
      }
      let num = -1
      this.ruleForm.prizes.forEach((ele, index) => {
        if (ele.prizeType == item.prizeType) {
          num = index
        }
      })
      if (num != -1) {
        this.ruleForm.prizes.splice(num, 1);
      }
    },
    // 移除
    handleRemovePoint2(item, i) {
      console.log("执行了handleRemovePoint2",item,i);
      
      if (this.isStart) return;
      this.libaoList[i].backAction = false;
      this.libaoList[i].singleAmount = "";
      if (item.assetsId) {
        this.libaoList[i].assetsId = "";
      }
      if (item.prizeType == 6) {
        this.libaoList[i].priceName = "每份店铺积分：0";
      }
      if (item.prizeType == 4) {
        this.libaoList[i].priceName = "每份京豆额：0";
      }
      if (item.prizeType == 1) {
      }
      let num = -1
      this.ruleForm.prizes.forEach((ele, index) => {
        if (ele.prizeType == item.prizeType) {
          num = index
        }
      })
      if (num != -1) {
        this.ruleForm.prizes.splice(num, 1);
      }
    },
    // 多选
    handleCheckedStarChange(val) {
      const data = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.map((i) => i.level);
      this.ruleForm.starVal = val ? data : [];
      this.starCheckAll = val;
    },
    handleCheckedChange(val) {
      const data = this.personLab.customizeList[this.personLab.customizeList.length - 1].labelVal.map((i) => i.level);
      this.ruleForm.vermicelliVal = val ? data : [];
      this.verCheckAll = val;
    },
    handleChang() {
      const num1 = this.personLab.customizeList[this.personLab.customizeList.length - 1].labelVal.length;
      const num2 = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.length;
      if (this.ruleForm.vermicelliVal.length == num1) {
        this.verCheckAll = true;
      } else {
        if (this.verCheckAll) {
          this.verCheckAll = false;
        }
      }
      if (this.ruleForm.starVal.length == num2) {
        this.starCheckAll = true;
      } else {
        if (this.starCheckAll) {
          this.starCheckAll = false;
        }
      }

      if(this.ruleForm.starVal.indexOf('-1') == -1 && this.ruleForm.starVal.length != 0){
          this.openClick = 1;
      }else if(this.ruleForm.starVal.length == 0){
        this.openClick = 3 ;
      }else{
        this.openClick = 2 ;
      }

    },
    // 礼包奖项
    changeHavePrizes() {
      if (this.ruleForm.isHavePrizes == 1) {
        this.ruleForm.jumpLink = "";
        this.ruleForm.isMemberGiftCheck = false;
        this.ruleForm.memberGiftJumpLink = "";
        const num = this.giftPrizeType.indexOf("1");
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            if (num != -1) {
              item.backAction = true;
              item.totalAmount = 1;
              item.singleAmount = "1";
              item.priceName = "每份店铺积分：1";
            } else {
              item.priceName = "每份店铺积分：0";
            }
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
        if (num != -1) {
          this.ruleForm.prizes = [
            {
              price: 1,
              prizeType: 6,
              singleAmount: 1,
              totalAmount: this.ruleForm.sendCount,
              title: `1积分`,
            },
          ];
        }
      } else {
        this.ruleForm.prizes = [];
        this.ruleForm.buttonText = "";
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            item.priceName = "每份店铺积分：0";
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
      }
    },
    //单选处理
    radioChange(val) {
      // 选中未关注店铺 启用改单选对应的多选 并禁用其他多选
      if (val == "v1_no_f") {
        this.ruleForm.starVal = [];
        this.disableVF = false;
        this.disableCUS = true;
        this.starCheckAll = false;
      } else if (val == "v1_customer") {// 选中店铺店铺会员 启用改单选对应的多选 并禁用其他多选
        this.disableCUS = false;
        this.disableVF = true;
        this.ruleForm.vermicelliVal = [];
        this.verCheckAll = false;
      } else {
        this.ruleForm.starVal = [];
        this.ruleForm.vermicelliVal = [];
        this.verCheckAll = false;
        this.starCheckAll = false;
        this.disableVF = true;
        this.disableCUS = true;
      }
    },
    //发送人数
    handleSendCount() {
      if (this.ruleForm.prizes.length > 0) {
        this.ruleForm.prizes.forEach((item) => {
          item.totalAmount = this.ruleForm.sendCount;
        });
      }
    },
    // 接收礼包样式弹窗
    closePrize(val, item) {
      console.log("--- item:closePrize---", item)
      this.dialogPrize = false;
      if (val) {
        // 、、 京券
        if (item.prizeType == "0") {
          let params = {
            assetsId: item.couponId,
            price: item.discount, //满100减10   填10
            prizeType: item.prizeType,
            singleAmount: 1, // 使用条件 默认为1
            totalAmount: this.ruleForm.sendCount,
            title: `${item.name}`,
            quota: item.quota, //满100减10   填100
            couponType: item.couponType
          };
          this.libaoList[this.currtIndex].priceName = item.discount + "元优惠券";
          this.libaoList[this.currtIndex].singleAmount = 1;
          this.libaoList[this.currtIndex].assetsId = item.assetsId;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "0") {
                ele.assetsId = item.couponId;
                ele.price = item.discount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = 1;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.name}`;
                ele.quota = item.quota;
                ele.couponType = item.couponType
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "1") {
          // 、、 东券
          let params = {
            assetsId: item.couponId,
            price: item.discount,
            prizeType: item.prizeType,
            singleAmount: 1,
            totalAmount: this.ruleForm.sendCount,
            title: `${item.name}`,
            quota: item.quota,
            couponType: item.couponType
          };
          this.libaoList[this.currtIndex].priceName = item.discount + "元优惠券";
          this.libaoList[this.currtIndex].singleAmount = 1;
          this.libaoList[this.currtIndex].assetsId = item.assetsId;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "1") {
                ele.assetsId = item.couponId;
                ele.price = item.discount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = 1;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.name}`;
                ele.quota = item.quota;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "6") {
          // 、、 积分
          let params = {
            price: item.point,
            prizeType: item.prizeType,
            singleAmount: item.point,
            totalAmount: this.ruleForm.sendCount,
            title: `${item.point}积分`,
          };
          this.libaoList[this.currtIndex].priceName = "每份店铺积分：" + item.point;
          this.libaoList[this.currtIndex].singleAmount = item.point;
          // this.libaoList[this.currtIndex].assetsId = item.activityName.value;
          // const num = this.ruleForm.prizes.indexOf(item.priceType);
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "6") {
                // ele.assetsId = item.activityName.value
                ele.price = item.point;
                ele.prizeType = item.prizeType;
                ele.singleAmount = item.point;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.point}积分`;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "4") {
          // 、、 京豆
          let params = {
            assetsId: item.activityName.value,
            price: item.singleAmount,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount,
            totalAmount: this.ruleForm.sendCount,
            title: `${item.singleAmount}京豆`,
            quantityTotal: item.quantityTotal,
          };
          this.libaoList[this.currtIndex].priceName = "每份京豆额：" + item.singleAmount;
          this.libaoList[this.currtIndex].singleAmount = item.singleAmount;
          this.libaoList[this.currtIndex].assetsId = item.activityName.value;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "4") {
                ele.assetsId = item.activityName.value;
                ele.price = item.singleAmount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = item.singleAmount;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.singleAmount}京豆`;
                ele.quantityTotal = item.quantityTotal;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        }
      }
    },
    // 设置东券数据
    setDonCoupon(item) {
      console.log("执行了setDonCoupon",item);
      
      // 东券
      let params = {
        price: item.price,
        quota: item.quota,
        prizeType: item.prizeType,
        singleAmount: 1,
        validateDay: item.validateDay,
        title: item.title,
        totalAmount: this.ruleForm.sendCount,
        bindType: item.bindType,
        skuIds: item.skuIds,
        batchKey: item.batchKey,
      };
      // console.log("--- params:setDonCoupon---", params)
      // 判断是否选中
      // console.log("--- this.libaoItem:---", this.libaoItem)
      if (this.libaoItem.backAction == true) {
        this.ruleForm.prizes.forEach((ele) => {
          if (ele.prizeType == "1") {
            ele.price = item.price;
            ele.quota = item.quota;
            ele.prizeType = item.prizeType;
            ele.singleAmount = 1;
            ele.validateDay = item.validateDay;
            ele.title = item.title;
            ele.totalAmount = this.ruleForm.sendCount,
            ele.bindType = item.bindType;
            ele.skuIds = item.skuIds;
            ele.batchKey = item.batchKey;
          }
        });
        console.log("--- this.ruleForm.prizes:---", this.ruleForm.prizes)
        this.libaoList[this.currtIndex].validateDay = item.validateDay
        this.libaoList[this.currtIndex].price = item.price
        this.libaoList[this.currtIndex].quota = item.quota
        this.libaoList[this.currtIndex].bindType = item.bindType;
        this.libaoList[this.currtIndex].skuIds = item.skuIds;
        this.libaoList[this.currtIndex].batchKey = item.batchKey;
      } else {
        this.ruleForm.prizes.push(params);
      }
      this.libaoList[this.currtIndex].backAction = true;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputnsend(e, data = '', type = 'nojindou') {
      if (type == 'nojindou') {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }

      } else {
        let quantityTotal = 0
        let price = 0
        this.ruleForm.prizes.forEach((ele) => {
          if (ele.prizeType == "4") {
            price = ele.price;
            quantityTotal = ele.quantityTotal;
          }
        });

        if (quantityTotal && price && data) {
          let numTotal = this.$jingdouTotal({ price: price, quantityTotal: quantityTotal, prizeCount: data });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return data;
        }
      }

    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    //曝光商品
    exposureChange(val) {
      if (val == '0') {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = []
        this.mainImagelist = [];
      } else {
        this.ruleForm.exposureSwitch = true
      }

    },
    //重新选择模板
    handleChoice(item) {
      if (item) {
        if (item.giftPrizeType == 0) {
          if (this.giftPopupNum == 2) {
            this.memberGiftTemplateId = item.id;
            this.templateUrlimg1 = item.templateUrl
          } else {
            this.giftID = item.id;
            this.templateUrlimg = item.templateUrl;
            this.ruleForm.customPicUrl = item.templateUrl;
          }
        } else {
          this.giftID = item.id;
          this.templateUrlimg = item.templateUrl;
          this.ruleForm.customPicUrl = item.templateUrl;
        }
        this.temItem = item

        this.nextStepKai(item, '2')
      }

      this.giftPopup = false;
    },

    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.activityData.isCopy) {
        this.localStep = 0;
        return
      }
      
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = []
      this.ruleForm.isOutClose = "";
      this.verCheckAll = false;
      this.starCheckAll = false;
      this.ruleForm.vermicelliVal = [];
      this.ruleForm.starVal = [];
      this.ruleForm.activityName = ""; //活动类型  13: 开卡礼包 14: 店铺礼包
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.ruleForm.buttonText = "";
      this.ruleForm.sendCount = "";
      this.ruleForm.jumpLink = "";
      this.ruleForm.modelIds = "-2";
      this.ruleForm.prizes = [];
      this.ruleForm.isMemberGiftCheck = false;
      this.ruleForm.memberGiftJumpLink = "";
      this.ruleForm.showPrize = 1;
      this.ruleForm.showPrizeNum = 1;
      this.ruleForm.picUrl = "";
      this.ruleForm.showBatchAddCart = 1;
      this.ruleForm.addCartNum = 1;

      this.awardSettingsLsit = [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
        //曝光商品集合
        this.libaoList.forEach((ele) => {
          ele.giftFalse = false;
          ele.totalAmount = "";
          ele.singleAmount = "";
          ele.backAction = false;
          ele.totalAmount = ""; //总共奖品数量
        });
      this.$emit('titopName', this.activityData.name, false)
    },
    handleFinishOrder() {
      this.nonObj.numStart = '';
      this.nonObj.numEnd = '';
    },
    handleInput(value) {
      let num = value.replace(/[^\d]/g, "").replace(/^0+(\d)/, "$1");
      this.$forceUpdate();
      return num;
    },
    updateNumStartInputBox() {
      let num = Number(this.nonObj.numStart);
      if (num < 0) {
        this.nonObj.numStart = 0;
      } 
      if(!!this.nonObj.numEnd && this.nonObj.numEnd != 'undefined' && this.nonObj.finishOrderType == 2) {
        if(Number(this.nonObj.numStart) > Number(this.nonObj.numEnd)) {
          this.nonObj.numStart = '';
          this.$message.warning('完成订单笔数开始值需要小于结束值');
        }
      }
    },
    updateNumEndInputBox() {
      let num = Number(this.nonObj.numEnd);
      if (num < 0) {
        this.nonObj.numEnd = 0;
      } 
      if(!!this.nonObj.numStart && this.nonObj.numStart != 'undefined' && this.nonObj.finishOrderType == 2) {
        if(Number(this.nonObj.numStart) > Number(this.nonObj.numEnd)) {
          this.nonObj.numEnd = '';
          this.$message.warning('完成订单笔数结束值需要大于开始值');
        }
      }
    },
    handleChange() {
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="scss" scoped>
.addCartPhoneTmp {
  position: absolute;
  // width: 100px;
  // height: 50px;
  overflow: hidden;
}

.mask-gift {
  position: absolute;
  bottom: 3px;
  width: 100%;

  div {
    text-align: center;
    color: #ffffff !important;
    font-size: 14px !important;
    opacity: 0.7;
    font-weight: 500 !important;
    line-height: 19px;
  }
}

.add_btn1 {
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-top: 8px;
}

.navTab {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;

  span {
    height: 50px;
    line-height: 50px;
    position: relative;
    padding: 0 11px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .active {
    color: #fe4d45;

    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background-color: #fe4d45;
      transition: all 0.2s;
      animation: opation 0.2s;
    }

    @keyframes opation {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 100%;
      }
    }
  }
}

.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;

  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}

.orangeColor {
  color: #FF7600;
}

.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}

//
.wrapperBg {
  background-color: #666 !important;
}

.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}

.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shopSet {
  width: 1200px;
  display: flex;

  &-left {
    width: 60%;
    .shopSetLeft-connet {
      width: 580px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .inner {
        margin-top: 20px;
        width: 275px;
        height: 150px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        border-radius: 8px;
        cursor: pointer;

        .innerTap {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding: 0 12px;
          background: #f5f5f5;
          border-radius: 8px 8px 0px 0px;
          position: relative;

          .logoImg {
            position: absolute;
            top: 17px;
            width: 16px;
            height: 16px;
            display: inline-block;
          }

          .img0 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6828.svg") no-repeat;
          }

          .img1 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6829.svg") no-repeat;
          }

          .img2 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6826.svg") no-repeat;
          }

          .img3 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6827.svg") no-repeat;
          }

          .innerTap-name {
            display: inline-block;
            width: 186px;
            height: 26px;
            line-height: 26px;
            padding-left: 19px;
          }

          .innerTap-bottom {
            display: inline-block;
            width: 60px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background: #d5d8de;
            border-radius: 4px;
            color: #fff;
          }
        }

        .innerTip {
          width: 100%;
          height: 100px;
          line-height: 100px;
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }

        &:hover {
          border: 1px solid #2768FF;
          box-shadow: 0px 6px 16px rgba(160, 26, 20, 0.15);
          border-radius: 9px;

          .innerTap {
            background: #2768FF !important;
            color: #fff;

            .img0 {
              background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu12.svg") no-repeat;
            }

            .img1 {
              background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu13.svg") no-repeat;
            }

            .img2 {
              background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu14.svg") no-repeat;
            }

            .img3 {
              background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu15.svg") no-repeat;
            }

            .innerTap-bottom {
              background: #fff;
              color: #2768FF;
            }
          }
        }
      }

      .innerAction {
        border: 1px solid #2768FF;
        box-shadow: 0px 6px 16px rgba(160, 26, 20, 0.15);
        border-radius: 9px;

        .innerTapAction {
          background: #2768FF;
          color: #fff;

          .imgAction0 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu12.svg") no-repeat;
          }

          .imgAction1 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu13.svg") no-repeat;
          }

          .imgAction2 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu14.svg") no-repeat;
          }

          .imgAction3 {
            background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu15.svg") no-repeat;
          }

          .botAction {
            background: #fff;
            color: #2768FF;
          }
        }
      }
    }
  }

  &-right {
    // padding-top: 20px;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    flex: 1;
    margin-top: -5px;
    margin-left: 100px;
    width: 550px;
    &-btn {
      margin: 16px 0;
      display: flex;
      align-items: center;
    }
    &-tips {
      line-height: 20px;
      font-size: 14px;
      color: #999;
    }
  }
}

.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;

  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}

.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;

  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;

    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;

      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }

    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;

      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }

      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }

  &-right {
    width: 368px;
    height: 100%;

    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }

    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}

.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}

.crowd {
  padding-left: 50px;
  margin-bottom: 20px;

  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;

    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #fe4d45;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }

  &-tab {
    width: 100%;

    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }

    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }

    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }

    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }

    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }

    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }

    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}

.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;

  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }

  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}

.prosi {
  position: absolute;
  bottom: 45px;
  right: 30px;
}

.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }

  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}

.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;

  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }

  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }

  .tips_task {
    width: 600px;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;

    p {
      padding-left: 20px;
      padding-bottom: 6px;
      line-height: 20px;
    }
  }
}

.line {
  display: flex;
  align-items: center;
}

.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;

  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;

    span {
      color: #ccc;
      cursor: pointer;
    }

    .name {
      color: #333;
      cursor: default;
    }
  }

  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 0;

    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }

    .itemList {
      display: flex;

      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;

        &:hover {

          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }

        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;

          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }

          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }

          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;

            &:hover {

              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }

            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;

              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }

              &::before {
                border-top: 1px solid #fe4d45;
                border-bottom: 1px solid #fe4d45;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }

              &::after {
                border-right: 1px solid #fe4d45;
                border-left: 1px solid #fe4d45;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }

            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }

            &:hover {
              .queryIdIMG {
                display: block;
              }

              .mask {
                opacity: 1;
              }
            }

            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;

              .img {
                max-width: 130px;
                margin: 0 auto 30px;

                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }

                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }

          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

          }

          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              // font-family: system-ui;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }

        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;

          .queryId {
            display: none;
          }

          &:hover {
            .queryId {
              display: block;
            }

            .mask {
              opacity: 1;
            }

            .borderkaika::before,
            .borderkaika::after {
              opacity: 1;
              transform: scale(1);
            }
          }

          .mask {
            width: 206px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;

            .img {
              max-width: 130px;
              margin: 0 auto 30px;

              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }

              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }

          .borderkaika {
            position: absolute;
            left: -6px;
            top: -6px;
            width: 104%;
            height: 104%;
            border-radius: 4px;

            &::before,
            &::after {
              position: absolute;
              top: -2%;
              right: 0;
              bottom: 0;
              left: -2%;
              content: "";
              opacity: 0;
              pointer-events: none;
              transition: opacity 0.8s, transform 0.8s;
              border-radius: 4px;
            }

            &::before {
              border-top: 1px solid #fe4d45;
              border-bottom: 1px solid #fe4d45;
              -webkit-transform: scale(0, 1);
              transform: scale(0, 1);
            }

            &::after {
              border-right: 1px solid #fe4d45;
              border-left: 1px solid #fe4d45;
              -webkit-transform: scale(1, 0);
              transform: scale(1, 0);
            }
          }
        }
      }
    }
  }

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;

    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }

    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
    }

    .lastTime {
      margin-left: 20px;
      font-size: 14px;

      i {
        color: #ccc;
      }
    }

    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;

      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/yhq.png");
        border-radius: 8px;
        position: absolute;
        color: #333333;

        .discount_sty {
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          color: #fe4d45;
          font-size: 45px;
        }

        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }

      .btnQx {
        display: none;
      }

      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }

        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .rule-tip {
      width: 545px;
      margin-left: 7px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }


  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}

@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}

.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: rgba(123, 97, 255, 0.05);
    }

  }

  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

  }
}

.miniAppPic {
  position: relative;

  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;

    i {
      font-size: 30px;
      color: #909399;
    }
  }

  .top1 {
    display: flex;

    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      // background: rgba(123, 97, 255, 0.1);
      border: 1px solid #fe4d45;

      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }

    .reset {
      color: #2768FF;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }

  .bottom1 {
    position: relative;
    top: 15px;

    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }

    .tips {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

.non-member-box {
  width: 550px;
  background-color: #F5F5F7;
  margin: -8px 0 6px 140px;
  padding: 12px;
  .el-form-item--small.el-form-item {
    margin-bottom: 12px;
  }
  .non-tip {
    margin-left: 40px;
    .tip-color {
      color: rgb(245, 108, 108)!important;
    }
  }
  /deep/ .el-input input{
    background: #ffffff !important;
  }
  /deep/ .el-range-input{
    background: #ffffff !important;
  }
  /deep/.el-date-editor .el-range-input {
    width: 44% !important;
  }
  /deep/ .el-date-editor--datetimerange.el-input__inner {
    width: 380px !important;
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }

  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }

  .el-step__head.is-process {
    position: absolute;
  }

  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }

  .el-step {
    position: relative;
  }
}

.tooplitMax {
  max-width: 1000px !important;
}

.activitypicUrl {
  position: relative;

  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;

    i {
      font-size: 30px;
      color: #909399;
    }
  }

  .right {
    position: absolute;
    top: 0px;
    left: 220px;

    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
    }

    .tips {
      line-height: 1.5;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

.activityBgColor {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 5px;
  cursor: pointer;
}

.reset1 {
  color: #fe4d45;
  cursor: pointer;
  font-size: 14px;
  position: relative;
  left: 10px;
  top: -25px;
}

.itemImg {
  margin-left: -35px;
  position: relative;
  top: -8px;

  i {
    color: #cccccc;
  }
}

.itemImg1 {
  i {
    color: #cccccc;
  }
}

.itemImg2 {
  i {
    color: #cccccc;
  }
}

.itemImg3 {
  margin-left: -10px;
  position: relative;
  top: -10px;
  color: #cccccc !important;

  i {
    color: #a54545;
  }
}


</style>
